/* eslint-disable */
// GENERATED by scripts/build-offline-engine.mjs from supabase/functions/_shared. Do not edit.
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// ../supabase/functions/_shared/triviaData.ts
var TRIVIA_ROWS = [
  ["Jeff Garcia", "QB", "SF", 2001, 16, 296.9, 3538, 32, 12, 254, 5, 0, 0, 0],
  ["Kurt Warner", "QB", "STL", 2001, 16, 293.2, 4830, 36, 22, 60, 0, 0, 0, 0],
  ["Rich Gannon", "QB", "OAK", 2001, 16, 266.2, 3828, 27, 9, 231, 2, 0, 0, 0],
  ["Steve McNair", "QB", "TEN", 2001, 15, 265.4, 3350, 21, 12, 414, 5, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2001, 16, 260.9, 4131, 26, 23, 157, 4, 0, 0, 0],
  ["Brett Favre", "QB", "GB", 2001, 16, 260.4, 3921, 32, 15, 56, 1, 0, 0, 0],
  ["Donovan McNabb", "QB", "PHI", 2001, 15, 259.5, 3233, 25, 12, 482, 2, 0, 0, 0],
  ["Aaron Brooks", "QB", "NO", 2001, 16, 253.1, 3832, 26, 22, 358, 1, 0, 0, 0],
  ["Kordell Stewart", "QB", "PIT", 2001, 16, 238.1, 3109, 14, 11, 537, 5, 0, 0, 0],
  ["Jay Fiedler", "QB", "MIA", 2001, 16, 220, 3248, 20, 19, 321, 4, 0, 0, 0],
  ["Jake Plummer", "QB", "ARI", 2001, 16, 202.4, 3653, 18, 14, 163, 0, 0, 0, 0],
  ["Daunte Culpepper", "QB", "MIN", 2001, 11, 201.1, 2612, 14, 13, 416, 5, 1, 0, 0],
  ["Brad Johnson", "QB", "TB", 2001, 16, 196.2, 3406, 13, 11, 120, 3, 0, 0, 0],
  ["Brian Griese", "QB", "DEN", 2001, 15, 192.8, 2827, 23, 19, 173, 1, 1, -6, 0],
  ["Kerry Collins", "QB", "NYG", 2001, 16, 190.7, 3764, 19, 16, 73, 0, 1, -2, 0],
  ["Trent Green", "QB", "KC", 2001, 16, 188.2, 3783, 17, 24, 158, 0, 1, 1, 0],
  ["Marshall Faulk", "RB", "STL", 2001, 14, 419.7, 0, 0, 0, 1382, 12, 83, 765, 9],
  ["Priest Holmes", "RB", "KC", 2001, 16, 334.9, 0, 0, 0, 1555, 8, 62, 614, 2],
  ["Ahman Green", "RB", "GB", 2001, 16, 318.1, 0, 0, 0, 1387, 9, 62, 594, 2],
  ["Shaun Alexander", "RB", "SEA", 2001, 16, 298.1, 0, 0, 0, 1318, 14, 44, 343, 2],
  ["Curtis Martin", "RB", "NYJ", 2001, 16, 297, 18, 1, 0, 1513, 10, 53, 320, 0],
  ["LaDainian Tomlinson", "RB", "SD", 2001, 16, 269.3, 0, 0, 0, 1236, 10, 59, 367, 0],
  ["Ricky Williams", "RB", "NO", 2001, 16, 265.6, 0, 0, 0, 1245, 6, 60, 511, 1],
  ["Corey Dillon", "RB", "CIN", 2001, 16, 258.3, 0, 0, 1, 1315, 10, 34, 228, 3],
  ["Tiki Barber", "RB", "NYG", 2001, 14, 240.2, 0, 0, 0, 865, 4, 72, 577, 0],
  ["Charlie Garner", "RB", "OAK", 2001, 16, 227.7, 0, 0, 0, 839, 1, 72, 578, 2],
  ["Garrison Hearst", "RB", "SF", 2001, 16, 224.3, 0, 0, 0, 1206, 4, 41, 347, 1],
  ["Antowain Smith", "RB", "NE", 2001, 16, 223.9, 0, 0, 0, 1157, 12, 19, 192, 1],
  ["Stephen Davis", "RB", "WAS", 2001, 16, 217.7, 0, 0, 0, 1432, 5, 28, 205, 0],
  ["Dominic Rhodes", "RB", "IND", 2001, 13, 214.8, 0, 0, 0, 1104, 9, 34, 224, 0],
  ["Duce Staley", "RB", "PHI", 2001, 13, 208, 0, 0, 0, 604, 2, 63, 626, 2],
  ["Anthony Thomas", "RB", "CHI", 2001, 14, 202.1, 0, 0, 0, 1183, 7, 22, 178, 0],
  ["Warrick Dunn", "RB", "TB", 2001, 13, 200.4, 0, 0, 0, 447, 3, 68, 557, 3],
  ["Lamar Smith", "RB", "MIA", 2001, 16, 188.2, 0, 0, 0, 968, 6, 30, 234, 2],
  ["Stacey Mack", "RB", "JAX", 2001, 16, 185.2, 0, 0, 0, 877, 9, 23, 165, 1],
  ["Michael Pittman", "RB", "ARI", 2001, 15, 179, 0, 0, 0, 846, 5, 42, 264, 0],
  ["Eddie George", "RB", "TEN", 2001, 16, 176.8, 0, 0, 0, 939, 5, 37, 279, 0],
  ["Jamel White", "RB", "CLE", 2001, 16, 168.1, 0, 0, 0, 443, 5, 44, 418, 1],
  ["Maurice Smith", "RB", "ATL", 2001, 14, 152, 0, 0, 0, 760, 5, 19, 230, 1],
  ["Jerome Bettis", "RB", "PIT", 2001, 11, 149.3, 32, 1, 0, 1072, 4, 8, 48, 0],
  ["Emmitt Smith", "RB", "DAL", 2001, 14, 146.7, 0, 0, 0, 1021, 3, 17, 116, 0],
  ["Cory Schlesinger", "RB", "DET", 2001, 16, 138, 0, 0, 0, 154, 3, 60, 466, 0],
  ["Michael Bennett", "RB", "MIN", 2001, 13, 137.8, 0, 0, 0, 682, 2, 29, 226, 1],
  ["Travis Henry", "RB", "BUF", 2001, 13, 132.8, 0, 0, 0, 729, 4, 22, 179, 0],
  ["Kevan Barlow", "RB", "SF", 2001, 15, 127.9, 0, 0, 0, 512, 4, 22, 247, 1],
  ["James Stewart", "RB", "DET", 2001, 11, 127.7, 0, 0, 0, 685, 1, 23, 242, 1],
  ["Marvin Harrison", "WR", "IND", 2001, 16, 351.7, 0, 0, 0, 3, 0, 109, 1524, 15],
  ["Terrell Owens", "WR", "SF", 2001, 16, 332.3, 0, 0, 0, 21, 0, 93, 1412, 16],
  ["Rod Smith", "WR", "DEN", 2001, 15, 318, 0, 0, 0, 27, 0, 113, 1343, 11],
  ["David Boston", "WR", "ARI", 2001, 16, 307.3, 0, 0, 0, 35, 0, 98, 1598, 8],
  ["Jimmy Smith", "WR", "JAX", 2001, 16, 297, 0, 0, 0, -3, 0, 112, 1373, 8],
  ["Troy Brown", "WR", "NE", 2001, 16, 272, 0, 0, 0, 91, 0, 101, 1199, 5],
  ["Tim Brown", "WR", "OAK", 2001, 16, 271.4, 0, 0, 0, 39, 0, 91, 1165, 9],
  ["Randy Moss", "WR", "MIN", 2001, 16, 270.3, 29, 0, 0, 38, 0, 82, 1233, 10],
  ["Joe Horn", "WR", "NO", 2001, 16, 261.9, 0, 0, 0, 4, 0, 83, 1265, 9],
  ["Torry Holt", "WR", "STL", 2001, 16, 259.3, 0, 0, 0, 0, 0, 81, 1363, 7],
  ["Marty Booker", "WR", "CHI", 2001, 16, 259.3, 34, 1, 0, 8, 0, 100, 1071, 8],
  ["Jerry Rice", "WR", "OAK", 2001, 16, 250.9, 0, 0, 0, 0, 0, 83, 1139, 9],
  ["Derrick Mason", "WR", "TEN", 2001, 15, 247.8, 0, 0, 0, 0, 0, 73, 1128, 9],
  ["Kevin Johnson", "WR", "CLE", 2001, 16, 247.7, 0, 0, 0, 0, 0, 84, 1097, 9],
  ["Keenan McCardell", "WR", "JAX", 2001, 16, 240, 0, 0, 0, 0, 0, 93, 1110, 6],
  ["Keyshawn Johnson", "WR", "TB", 2001, 15, 236.6, 0, 0, 0, 0, 0, 106, 1266, 1],
  ["Curtis Conway", "WR", "SD", 2001, 16, 235.1, 0, 0, 0, 116, 1, 71, 1125, 6],
  ["Darrell Jackson", "WR", "SEA", 2001, 16, 227, 0, 0, 0, 9, 0, 70, 1081, 8],
  ["Hines Ward", "WR", "PIT", 2001, 16, 226.6, 0, 0, 0, 83, 0, 94, 1003, 4],
  ["Qadry Ismail", "WR", "BAL", 2001, 16, 221.9, 0, 0, 0, 0, 0, 74, 1059, 7],
  ["Willie Jackson", "WR", "NO", 2001, 16, 217.6, 0, 0, 0, 0, 0, 81, 1046, 5],
  ["Johnnie Morton", "WR", "DET", 2001, 16, 215, 0, 0, 0, 6, 0, 77, 1154, 4],
  ["Isaac Bruce", "WR", "STL", 2001, 16, 208.9, 0, 0, 0, 23, 0, 64, 1106, 6],
  ["Amani Toomer", "WR", "NYG", 2001, 16, 208.2, 0, 0, 0, 8, 0, 72, 1054, 5],
  ["Plaxico Burress", "WR", "PIT", 2001, 16, 202.8, 0, 0, 0, 0, 0, 66, 1008, 6],
  ["Bill Schroeder", "WR", "GB", 2001, 14, 199.4, 0, 0, 0, 6, 0, 53, 918, 9],
  ["Laveranues Coles", "WR", "NYJ", 2001, 16, 198.6, 0, 0, 0, 108, 0, 59, 868, 7],
  ["James Thrash", "WR", "PHI", 2001, 15, 198, 0, 0, 0, 57, 0, 63, 833, 8],
  ["Peerless Price", "WR", "BUF", 2001, 16, 196.2, 0, 0, 0, 97, 0, 55, 895, 7],
  ["Cris Carter", "WR", "MIN", 2001, 16, 192.5, 0, 0, 0, 4, 0, 73, 871, 6],
  ["Eric Moulds", "WR", "BUF", 2001, 16, 187.7, 0, 0, 0, 3, 0, 67, 904, 5],
  ["Kevin Dyson", "WR", "TEN", 2001, 16, 180.5, 0, 0, 0, 0, 0, 54, 825, 7],
  ["Chris Chambers", "WR", "MIA", 2001, 16, 177.2, 0, 0, 0, -11, 0, 48, 883, 7],
  ["Antonio Freeman", "WR", "GB", 2001, 16, 171.3, 0, 0, 0, -5, 0, 52, 818, 6],
  ["David Patten", "WR", "NE", 2001, 15, 167, 60, 1, 1, 67, 1, 51, 749, 4],
  ["Jeff Graham", "WR", "SD", 2001, 14, 161.1, 0, 0, 0, 0, 0, 52, 811, 5],
  ["Tony Gonzalez", "TE", "KC", 2001, 16, 205.2, 40, 0, 0, 9, 0, 73, 917, 6],
  ["Marcus Pollard", "TE", "IND", 2001, 16, 168.9, 0, 0, 0, 0, 0, 47, 739, 8],
  ["Shannon Sharpe", "TE", "BAL", 2001, 16, 164.1, 0, 0, 0, 0, 0, 73, 811, 2],
  ["Frank Wycheck", "TE", "TEN", 2001, 16, 152.1, 21, 0, 0, 1, 0, 60, 672, 4],
  ["Byron Chamberlain", "TE", "MIN", 2001, 16, 139.6, 0, 0, 0, 0, 0, 57, 666, 3],
  ["Desmond Clark", "TE", "DEN", 2001, 14, 139.6, 0, 0, 0, 0, 0, 51, 566, 6],
  ["Jay Riemersma", "TE", "BUF", 2001, 16, 130, 0, 0, 0, 0, 0, 53, 590, 3],
  ["Bubba Franks", "TE", "GB", 2001, 15, 122.2, 0, 0, 0, 0, 0, 36, 322, 9],
  ["David Sloan", "TE", "DET", 2001, 14, 119.9, 0, 0, 0, 0, 0, 37, 409, 7],
  ["Wesley Walls", "TE", "CAR", 2001, 14, 118.2, 0, 0, 0, 0, 0, 43, 452, 5],
  ["Chad Lewis", "TE", "PHI", 2001, 15, 117.2, 0, 0, 0, 0, 0, 41, 422, 6],
  ["Ernie Conwell", "TE", "STL", 2001, 16, 109.9, 0, 0, 0, 28, 1, 38, 431, 4],
  ["Rich Gannon", "QB", "OAK", 2002, 16, 303.2, 4689, 26, 10, 156, 3, 0, 0, 0],
  ["Daunte Culpepper", "QB", "MIN", 2002, 16, 285, 3853, 18, 23, 609, 10, 0, 0, 0],
  ["Mike Vick", "QB", "ATL", 2002, 15, 279.1, 2936, 16, 8, 777, 8, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2002, 16, 264.8, 4200, 27, 19, 148, 2, 0, 0, 0],
  ["Aaron Brooks", "QB", "NO", 2002, 16, 256.2, 3572, 27, 15, 253, 2, 0, 0, 0],
  ["Trent Green", "QB", "KC", 2002, 16, 256.1, 3690, 26, 13, 225, 1, 0, 0, 0],
  ["Steve McNair", "QB", "TEN", 2002, 16, 253.5, 3387, 22, 15, 440, 3, 0, 0, 0],
  ["Drew Bledsoe", "QB", "BUF", 2002, 16, 251.1, 4359, 24, 15, 67, 2, 0, 0, 0],
  ["Jeff Garcia", "QB", "SF", 2002, 16, 251.1, 3344, 21, 10, 353, 3, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2002, 16, 245.6, 3764, 28, 14, 110, 1, 0, 0, 0],
  ["Donovan McNabb", "QB", "PHI", 2002, 10, 223.6, 2289, 17, 6, 460, 6, 0, 0, 0],
  ["Brett Favre", "QB", "GB", 2002, 16, 221.6, 3658, 27, 16, 73, 0, 0, 0, 0],
  ["Chad Pennington", "QB", "NYJ", 2002, 15, 217.7, 3120, 22, 6, 49, 2, 0, 0, 0],
  ["Kerry Collins", "QB", "NYG", 2002, 16, 210.6, 4073, 19, 14, -3, 0, 0, 0, 0],
  ["Brad Johnson", "QB", "TB", 2002, 13, 201, 3049, 22, 6, 30, 0, 0, 0, 0],
  ["Drew Brees", "QB", "SD", 2002, 16, 188.4, 3284, 17, 16, 130, 1, 0, 0, 0],
  ["Priest Holmes", "RB", "KC", 2002, 14, 440.7, 0, 0, 0, 1615, 21, 70, 672, 3],
  ["LaDainian Tomlinson", "RB", "SD", 2002, 16, 384.2, 0, 0, 0, 1683, 14, 79, 489, 1],
  ["Ricky Williams", "RB", "MIA", 2002, 16, 360.6, 0, 0, 0, 1853, 16, 47, 363, 1],
  ["Charlie Garner", "RB", "OAK", 2002, 16, 347.3, 0, 0, 0, 962, 7, 91, 941, 4],
  ["Shaun Alexander", "RB", "SEA", 2002, 16, 328.5, 0, 0, 0, 1175, 16, 59, 460, 2],
  ["Tiki Barber", "RB", "NYG", 2002, 16, 321.4, 0, 0, 0, 1387, 11, 69, 597, 0],
  ["Clinton Portis", "RB", "DEN", 2002, 16, 316.2, 0, 0, 0, 1508, 15, 33, 364, 2],
  ["Deuce McAllister", "RB", "NO", 2002, 15, 311, 0, 0, 0, 1388, 13, 47, 352, 3],
  ["Travis Henry", "RB", "BUF", 2002, 16, 285.7, 0, 0, 0, 1438, 13, 43, 309, 1],
  ["Marshall Faulk", "RB", "STL", 2002, 14, 283, 0, 0, 0, 953, 8, 80, 537, 2],
  ["Fred Taylor", "RB", "JAX", 2002, 16, 269.2, 0, 0, 0, 1314, 8, 49, 408, 0],
  ["Ahman Green", "RB", "GB", 2002, 14, 268.3, 0, 0, 0, 1240, 7, 57, 393, 2],
  ["Eddie George", "RB", "TEN", 2002, 16, 262, 0, 0, 0, 1165, 12, 36, 255, 2],
  ["Duce Staley", "RB", "PHI", 2002, 16, 258, 0, 0, 0, 1029, 5, 51, 541, 3],
  ["Jamal Lewis", "RB", "BAL", 2002, 16, 251.9, 0, 0, 0, 1327, 6, 47, 442, 1],
  ["Corey Dillon", "RB", "CIN", 2002, 16, 241.9, 0, 0, 0, 1311, 7, 43, 298, 0],
  ["Curtis Martin", "RB", "NYJ", 2002, 16, 238.6, 0, 0, 0, 1094, 7, 49, 362, 0],
  ["Michael Bennett", "RB", "MIN", 2002, 16, 231.7, 0, 0, 0, 1296, 5, 37, 351, 1],
  ["Warrick Dunn", "RB", "ATL", 2002, 15, 228.4, 0, 0, 0, 927, 7, 50, 377, 2],
  ["Garrison Hearst", "RB", "SF", 2002, 16, 226.9, 0, 0, 0, 972, 8, 48, 317, 1],
  ["James Stewart", "RB", "DET", 2002, 14, 217.4, 0, 0, 0, 1021, 4, 46, 333, 2],
  ["Edgerrin James", "RB", "IND", 2002, 14, 213.3, 0, 0, 0, 989, 2, 61, 354, 1],
  ["Marcel Shipp", "RB", "ARI", 2002, 14, 208.7, 0, 0, 0, 834, 6, 38, 413, 3],
  ["Antowain Smith", "RB", "NE", 2002, 16, 201.5, 0, 0, 0, 982, 6, 31, 243, 2],
  ["Michael Pittman", "RB", "TB", 2002, 16, 180.5, 0, 0, 0, 718, 1, 59, 477, 0],
  ["Jamel White", "RB", "CLE", 2002, 14, 173.2, 0, 0, 0, 470, 3, 63, 452, 0],
  ["Amos Zereoue", "RB", "PIT", 2002, 16, 172.3, 0, 0, 0, 762, 4, 42, 341, 0],
  ["Moe Williams", "RB", "MIN", 2002, 16, 159.5, 0, 0, 0, 414, 11, 27, 251, 0],
  ["Stephen Davis", "RB", "WAS", 2002, 12, 159.2, 0, 0, 0, 820, 7, 23, 142, 1],
  ["Emmitt Smith", "RB", "DAL", 2002, 16, 150.4, 0, 0, 0, 975, 5, 16, 89, 0],
  ["Marvin Harrison", "WR", "IND", 2002, 16, 384.2, 0, 0, 0, 10, 0, 143, 1722, 11],
  ["Hines Ward", "WR", "PIT", 2002, 16, 335.1, 0, 0, 0, 142, 0, 112, 1329, 12],
  ["Terrell Owens", "WR", "SF", 2002, 14, 321.9, 0, 0, 0, 79, 1, 100, 1300, 13],
  ["Randy Moss", "WR", "MIN", 2002, 16, 290.3, 13, 1, 0, 51, 0, 106, 1347, 7],
  ["Eric Moulds", "WR", "BUF", 2002, 16, 289.9, 0, 0, 0, 7, 0, 100, 1292, 10],
  ["Peerless Price", "WR", "BUF", 2002, 16, 269.9, 0, 0, 0, -13, 0, 94, 1252, 9],
  ["Amani Toomer", "WR", "NYG", 2002, 16, 264.5, 0, 0, 0, 2, 0, 82, 1343, 8],
  ["Joe Horn", "WR", "NO", 2002, 16, 263.4, 0, 0, 0, 2, 0, 88, 1312, 7],
  ["Marty Booker", "WR", "CHI", 2002, 16, 257.7, 44, 1, 0, 0, 0, 97, 1189, 6],
  ["Jerry Rice", "WR", "OAK", 2002, 16, 255.1, 0, 0, 0, 20, 0, 92, 1211, 7],
  ["Plaxico Burress", "WR", "PIT", 2002, 16, 252.5, 0, 0, 0, 0, 0, 78, 1325, 7],
  ["Laveranues Coles", "WR", "NYJ", 2002, 16, 251.3, 0, 0, 0, 39, 0, 89, 1264, 5],
  ["Torry Holt", "WR", "STL", 2002, 16, 245, 0, 0, 0, 18, 0, 91, 1302, 4],
  ["Koren Robinson", "WR", "SEA", 2002, 16, 237.6, 0, 0, 0, 56, 0, 78, 1240, 5],
  ["Donald Driver", "WR", "GB", 2002, 16, 235.4, 0, 0, 0, 70, 0, 70, 1064, 9],
  ["Jimmy Smith", "WR", "JAX", 2002, 16, 226.9, 0, 0, 0, 2, 0, 80, 1027, 7],
  ["Isaac Bruce", "WR", "STL", 2002, 16, 226.3, 0, 0, 0, 18, 0, 79, 1075, 7],
  ["Rod Smith", "WR", "DEN", 2002, 16, 220.6, 0, 0, 0, 9, 0, 89, 1027, 5],
  ["Rod Gardner", "WR", "WAS", 2002, 16, 219.7, 0, 0, 0, 1, 0, 71, 1006, 8],
  ["Keyshawn Johnson", "WR", "TB", 2002, 16, 218.8, 0, 0, 0, 0, 0, 76, 1088, 5],
  ["Chad Johnson", "WR", "CIN", 2002, 16, 215.6, 0, 0, 0, 0, 0, 69, 1166, 5],
  ["Derrick Mason", "WR", "TEN", 2002, 14, 208.2, 0, 0, 0, 0, 0, 79, 1012, 5],
  ["Troy Brown", "WR", "NE", 2002, 14, 205.4, 0, 0, 0, 14, 0, 97, 890, 3],
  ["Travis Taylor", "WR", "BAL", 2002, 16, 194.4, 0, 0, 0, 105, 0, 61, 869, 6],
  ["Quincy Morgan", "WR", "CLE", 2002, 16, 193.1, 0, 0, 0, 7, 0, 56, 964, 7],
  ["Joey Galloway", "WR", "DAL", 2002, 16, 188.9, 0, 0, 0, 31, 0, 61, 908, 6],
  ["Tim Brown", "WR", "OAK", 2002, 16, 187.9, 0, 0, 0, 19, 0, 81, 930, 2],
  ["Curtis Conway", "WR", "SD", 2002, 12, 185.5, 0, 0, 0, 53, 2, 57, 852, 5],
  ["Todd Pinkston", "WR", "PHI", 2002, 15, 180.3, 0, 0, 0, -15, 0, 60, 798, 7],
  ["Jerry Porter", "WR", "OAK", 2002, 16, 178.4, 0, 0, 0, 6, 0, 51, 688, 9],
  ["Tai Streets", "WR", "SF", 2002, 15, 177.6, 0, 0, 0, 0, 0, 72, 756, 5],
  ["James Thrash", "WR", "PHI", 2002, 16, 174.1, 0, 0, 0, 126, 2, 52, 635, 6],
  ["David Patten", "WR", "NE", 2002, 16, 174, 0, 0, 0, 6, 0, 61, 824, 5],
  ["Brian Finneran", "WR", "ATL", 2002, 16, 173.8, 0, 0, 0, 0, 0, 56, 838, 6],
  ["Ed McCaffrey", "WR", "DEN", 2002, 16, 171.5, 0, 0, 0, 22, 0, 69, 903, 2],
  ["Steve Smith", "WR", "CAR", 2002, 15, 170.8, 0, 0, 0, -4, 0, 54, 872, 3],
  ["Todd Heap", "TE", "BAL", 2002, 16, 193.4, 0, 0, 0, 38, 0, 68, 836, 6],
  ["Tony Gonzalez", "TE", "KC", 2002, 16, 182.3, 0, 0, 0, 0, 0, 63, 773, 7],
  ["Jeremy Shockey", "TE", "NYG", 2002, 15, 171.4, 0, 0, 0, 0, 0, 74, 894, 2],
  ["Shannon Sharpe", "TE", "DEN", 2002, 13, 147.6, 0, 0, 0, 0, 0, 61, 686, 3],
  ["Bubba Franks", "TE", "GB", 2002, 16, 145.4, 31, 1, 0, 0, 0, 54, 442, 7],
  ["Billy Miller", "TE", "HOU", 2002, 14, 130.3, 0, 0, 0, 0, 0, 51, 613, 3],
  ["Marcus Pollard", "TE", "IND", 2002, 15, 128.8, 0, 0, 0, 0, 0, 43, 478, 6],
  ["Kyle Brady", "TE", "JAX", 2002, 16, 113.1, 0, 0, 0, 0, 0, 43, 461, 4],
  ["Alge Crumpler", "TE", "ATL", 2002, 16, 111.5, 0, 0, 0, 0, 0, 36, 455, 5],
  ["Randy McMichael", "TE", "MIA", 2002, 16, 110.3, 0, 0, 0, 8, 0, 39, 485, 4],
  ["Itula Mili", "TE", "SEA", 2002, 15, 105.8, 0, 0, 0, 0, 0, 43, 508, 2],
  ["Stephen Alexander", "TE", "SD", 2002, 14, 102, 0, 0, 0, 0, 0, 45, 510, 1],
  ["Daunte Culpepper", "QB", "MIN", 2003, 14, 273.4, 3479, 25, 11, 422, 4, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2003, 16, 270.4, 4267, 29, 10, 29, 0, 1, -2, 0],
  ["Trent Green", "QB", "KC", 2003, 16, 251.9, 4039, 24, 12, 83, 2, 0, 0, 0],
  ["Matt Hasselbeck", "QB", "SEA", 2003, 16, 250.3, 3844, 26, 15, 125, 2, 0, 0, 0],
  ["Steve McNair", "QB", "TEN", 2003, 14, 243, 3246, 24, 7, 138, 4, 1, 4, 0],
  ["Aaron Brooks", "QB", "NO", 2003, 16, 230.1, 3546, 24, 8, 183, 2, 0, 0, 0],
  ["Jeff Garcia", "QB", "SF", 2003, 13, 226.3, 2704, 18, 13, 325, 7, 1, 6, 0],
  ["Brett Favre", "QB", "GB", 2003, 16, 221.9, 3361, 32, 21, 15, 0, 0, 0, 0],
  ["Jon Kitna", "QB", "CIN", 2003, 16, 221.9, 3605, 26, 15, 117, 0, 0, 0, 0],
  ["Donovan McNabb", "QB", "PHI", 2003, 16, 219.1, 3223, 16, 11, 359, 3, 1, -7, 0],
  ["Marc Bulger", "QB", "STL", 2003, 15, 217.3, 3845, 22, 22, 75, 4, 0, 0, 0],
  ["Brad Johnson", "QB", "TB", 2003, 16, 216.1, 3821, 26, 21, 33, 0, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2003, 16, 215.1, 3620, 23, 12, 63, 1, 0, 0, 0],
  ["Quincy Carter", "QB", "DAL", 2003, 16, 189.8, 3302, 17, 21, 257, 2, 0, 0, 0],
  ["Tommy Maddox", "QB", "PIT", 2003, 16, 171.8, 3414, 18, 17, 12, 0, 0, 0, 0],
  ["Jake Delhomme", "QB", "CAR", 2003, 16, 171.1, 3219, 19, 16, 43, 1, 0, 0, 0],
  ["Priest Holmes", "RB", "KC", 2003, 16, 445, 0, 0, 0, 1420, 27, 74, 690, 0],
  ["LaDainian Tomlinson", "RB", "SD", 2003, 16, 443.8, 21, 1, 0, 1645, 13, 100, 725, 4],
  ["Ahman Green", "RB", "GB", 2003, 16, 385, 0, 0, 0, 1883, 15, 50, 367, 5],
  ["Deuce McAllister", "RB", "NO", 2003, 16, 324.7, 0, 0, 0, 1641, 8, 69, 516, 0],
  ["Jamal Lewis", "RB", "BAL", 2003, 16, 322.8, 0, 0, 0, 2063, 14, 26, 205, 0],
  ["Clinton Portis", "RB", "DEN", 2003, 13, 312.5, 0, 0, 0, 1591, 14, 38, 314, 0],
  ["Shaun Alexander", "RB", "SEA", 2003, 16, 305, 0, 0, 0, 1435, 14, 42, 295, 2],
  ["Fred Taylor", "RB", "JAX", 2003, 16, 276.2, 0, 0, 0, 1572, 6, 48, 370, 1],
  ["Ricky Williams", "RB", "MIA", 2003, 16, 272.3, 0, 0, 0, 1372, 9, 50, 351, 1],
  ["Edgerrin James", "RB", "IND", 2003, 13, 265.9, 0, 0, 0, 1257, 11, 51, 292, 0],
  ["Moe Williams", "RB", "MIN", 2003, 16, 249.9, 0, 0, 0, 745, 5, 65, 644, 3],
  ["Tiki Barber", "RB", "NYG", 2003, 16, 244.6, 0, 0, 0, 1215, 2, 69, 461, 1],
  ["Travis Henry", "RB", "BUF", 2003, 15, 235.1, 0, 0, 1, 1353, 10, 28, 158, 1],
  ["Domanick Williams", "RB", "HOU", 2003, 14, 227.2, 0, 0, 0, 1031, 8, 47, 351, 0],
  ["Marshall Faulk", "RB", "STL", 2003, 11, 221.8, 0, 0, 0, 818, 10, 45, 290, 1],
  ["Michael Pittman", "RB", "TB", 2003, 16, 219.2, 0, 0, 0, 751, 0, 75, 591, 2],
  ["Stephen Davis", "RB", "CAR", 2003, 14, 216.3, 0, 0, 0, 1444, 8, 14, 159, 0],
  ["Brian Westbrook", "RB", "PHI", 2003, 15, 210.5, 0, 0, 0, 605, 7, 38, 340, 4],
  ["Curtis Martin", "RB", "NYJ", 2003, 16, 207, 0, 0, 0, 1308, 2, 42, 262, 0],
  ["Kevan Barlow", "RB", "SF", 2003, 16, 202.1, 0, 0, 0, 1024, 6, 35, 307, 1],
  ["Rudi Johnson", "RB", "CIN", 2003, 13, 186.3, 0, 0, 0, 967, 9, 21, 146, 0],
  ["Eddie George", "RB", "TEN", 2003, 16, 171.4, 0, 0, 0, 1031, 5, 22, 163, 0],
  ["Shawn Bryson", "RB", "DET", 2003, 16, 166.6, 0, 0, 0, 606, 3, 54, 340, 0],
  ["Charlie Garner", "RB", "OAK", 2003, 14, 165.9, 0, 0, 0, 553, 3, 48, 386, 1],
  ["Warrick Dunn", "RB", "ATL", 2003, 11, 165.8, 0, 0, 0, 672, 3, 37, 336, 2],
  ["T.J. Duckett", "RB", "ATL", 2003, 16, 160.3, 0, 0, 0, 779, 11, 11, 94, 0],
  ["Duce Staley", "RB", "PHI", 2003, 16, 157.9, 0, 0, 0, 457, 5, 36, 382, 2],
  ["Anthony Thomas", "RB", "CHI", 2003, 13, 151, 0, 0, 0, 1024, 6, 9, 36, 0],
  ["Troy Hambrick", "RB", "DAL", 2003, 16, 148.1, 0, 0, 0, 972, 5, 17, 99, 0],
  ["Kevin Faulk", "RB", "NE", 2003, 15, 147.8, 0, 0, 0, 638, 0, 48, 440, 0],
  ["Randy Moss", "WR", "MIN", 2003, 16, 376, 0, 0, 0, 18, 0, 111, 1632, 17],
  ["Torry Holt", "WR", "STL", 2003, 16, 359.1, 0, 0, 0, 5, 0, 117, 1696, 12],
  ["Chad Johnson", "WR", "CIN", 2003, 16, 285.5, 0, 0, 0, 0, 0, 90, 1355, 10],
  ["Anquan Boldin", "WR", "ARI", 2003, 16, 284.7, 0, 0, 1, 40, 0, 101, 1377, 8],
  ["Marvin Harrison", "WR", "IND", 2003, 15, 277.5, 0, 0, 0, 3, 0, 94, 1272, 10],
  ["Hines Ward", "WR", "PIT", 2003, 16, 277.4, 0, 0, 0, 61, 0, 95, 1163, 10],
  ["Derrick Mason", "WR", "TEN", 2003, 16, 274.4, 0, 0, 0, 11, 0, 95, 1303, 8],
  ["Steve Smith", "WR", "CAR", 2003, 16, 251.2, 0, 0, 0, 42, 0, 88, 1110, 7],
  ["Keenan McCardell", "WR", "TB", 2003, 16, 247.9, 0, 0, 0, 0, 0, 84, 1179, 8],
  ["Santana Moss", "WR", "NYJ", 2003, 16, 247.2, 0, 0, 0, 67, 0, 74, 1105, 10],
  ["Terrell Owens", "WR", "SF", 2003, 15, 244, 0, 0, 0, -2, 0, 80, 1102, 9],
  ["Laveranues Coles", "WR", "WAS", 2003, 16, 242.3, 0, 0, 0, 39, 0, 82, 1204, 6],
  ["Joe Horn", "WR", "NO", 2003, 15, 237.4, 14, 0, 0, 15, 0, 78, 973, 10],
  ["Darrell Jackson", "WR", "SEA", 2003, 15, 233.7, 0, 0, 0, 0, 0, 68, 1137, 9],
  ["Chris Chambers", "WR", "MIA", 2003, 16, 227.3, 0, 0, 0, 30, 0, 64, 963, 11],
  ["Peter Warrick", "WR", "CIN", 2003, 15, 225.6, 0, 0, 0, 143, 0, 80, 833, 7],
  ["Isaac Bruce", "WR", "STL", 2003, 14, 201.4, 66, 0, 0, 17, 0, 69, 981, 5],
  ["David Boston", "WR", "SD", 2003, 14, 199.8, 0, 0, 0, 18, 0, 70, 880, 7],
  ["Amani Toomer", "WR", "NYG", 2003, 16, 199.2, 0, 0, 0, 5, 0, 63, 1057, 5],
  ["Rod Smith", "WR", "DEN", 2003, 15, 195.3, 72, 0, 0, 98, 0, 74, 846, 3],
  ["Reggie Wayne", "WR", "IND", 2003, 15, 193.8, 0, 0, 0, 0, 0, 68, 838, 7],
  ["Andre Johnson", "WR", "HOU", 2003, 16, 186.6, 0, 0, 0, -10, 0, 66, 976, 4],
  ["Koren Robinson", "WR", "SEA", 2003, 15, 178.1, 0, 0, 0, 15, 0, 65, 896, 4],
  ["Justin McCareins", "WR", "TEN", 2003, 16, 177.6, 0, 0, 0, 13, 0, 47, 813, 7],
  ["Eddie Kennison", "WR", "KC", 2003, 16, 170.3, 0, 0, 0, 9, 0, 56, 854, 5],
  ["Plaxico Burress", "WR", "PIT", 2003, 16, 169.3, 0, 0, 0, -7, 0, 60, 860, 4],
  ["Peerless Price", "WR", "ATL", 2003, 16, 166.1, 0, 0, 0, 3, 0, 64, 838, 3],
  ["Javon Walker", "WR", "GB", 2003, 16, 164.7, 0, 0, 0, 1, 0, 41, 716, 9],
  ["Terry Glenn", "WR", "DAL", 2003, 13, 162.9, 0, 0, 0, 55, 0, 52, 754, 5],
  ["Jerry Rice", "WR", "OAK", 2003, 16, 159.1, 0, 0, 0, 0, 0, 63, 861, 2],
  ["Rod Gardner", "WR", "WAS", 2003, 16, 158.8, 46, 2, 0, 0, 0, 59, 600, 5],
  ["Jimmy Smith", "WR", "JAX", 2003, 12, 158.5, 0, 0, 0, 0, 0, 54, 805, 4],
  ["Bobby Engram", "WR", "SEA", 2003, 15, 158, 0, 0, 0, 0, 0, 52, 640, 6],
  ["Johnnie Morton", "WR", "KC", 2003, 15, 157.4, 0, 0, 0, 94, 0, 50, 740, 4],
  ["Deion Branch", "WR", "NE", 2003, 15, 156.4, 0, 0, 0, 11, 0, 57, 803, 3],
  ["Dennis Northcutt", "WR", "CLE", 2003, 15, 155.2, 0, 0, 0, 83, 0, 62, 729, 2],
  ["Tony Gonzalez", "TE", "KC", 2003, 16, 222.5, 0, 0, 0, 0, 0, 71, 915, 10],
  ["Shannon Sharpe", "TE", "DEN", 2003, 15, 187, 0, 0, 0, 0, 0, 62, 770, 8],
  ["Todd Heap", "TE", "BAL", 2003, 16, 154.4, 0, 0, 0, 21, 0, 57, 693, 3],
  ["Freddie Jones", "TE", "ARI", 2003, 15, 124.7, 0, 0, 0, 0, 0, 55, 517, 3],
  ["Randy McMichael", "TE", "MIA", 2003, 15, 120.8, 0, 0, 0, 0, 0, 49, 598, 2],
  ["Itula Mili", "TE", "SEA", 2003, 16, 119.2, 0, 0, 0, 0, 0, 46, 492, 4],
  ["Alge Crumpler", "TE", "ATL", 2003, 16, 115.2, 0, 0, 0, 0, 0, 44, 552, 3],
  ["Jeremy Shockey", "TE", "NYG", 2003, 9, 115.2, 0, 0, 0, 0, 0, 49, 562, 2],
  ["Marcus Pollard", "TE", "IND", 2003, 13, 112.1, 0, 0, 0, 0, 0, 40, 541, 3],
  ["Jimmy Kleinsasser", "TE", "MIN", 2003, 14, 111.6, 0, 0, 0, 15, 0, 46, 401, 4],
  ["Daniel Graham", "TE", "NE", 2003, 13, 102.9, 0, 0, 0, 0, 0, 38, 409, 4],
  ["Anthony Becht", "TE", "NYJ", 2003, 15, 101.6, 0, 0, 0, 0, 0, 40, 356, 4],
  ["Daunte Culpepper", "QB", "MIN", 2004, 16, 373.3, 4717, 39, 11, 406, 2, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2004, 16, 360.1, 4557, 49, 10, 38, 0, 0, 0, 0],
  ["Donovan McNabb", "QB", "PHI", 2004, 15, 291.1, 3875, 31, 8, 221, 3, 0, 0, 0],
  ["Trent Green", "QB", "KC", 2004, 16, 260.1, 4589, 27, 17, 85, 0, 0, 0, 0],
  ["Jake Plummer", "QB", "DEN", 2004, 16, 257.1, 4089, 27, 20, 215, 1, 0, 0, 0],
  ["Brett Favre", "QB", "GB", 2004, 16, 255, 4086, 30, 17, 36, 0, 0, 0, 0],
  ["Jake Delhomme", "QB", "CAR", 2004, 16, 248.5, 3886, 29, 15, 71, 1, 0, 0, 0],
  ["Aaron Brooks", "QB", "NO", 2004, 16, 247.4, 3810, 21, 16, 199, 4, 1, 1, 0],
  ["Drew Brees", "QB", "SD", 2004, 15, 243.7, 3159, 27, 7, 85, 2, 1, 38, 0],
  ["Marc Bulger", "QB", "STL", 2004, 14, 235.5, 3964, 21, 14, 89, 3, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2004, 16, 224.4, 3690, 28, 14, 28, 0, 0, 0, 0],
  ["Mike Vick", "QB", "ATL", 2004, 15, 218.7, 2313, 14, 12, 902, 3, 0, 0, 0],
  ["Matt Hasselbeck", "QB", "SEA", 2004, 14, 211, 3390, 22, 15, 94, 1, 0, 0, 0],
  ["David Carr", "QB", "HOU", 2004, 16, 203.9, 3539, 16, 14, 303, 0, 0, 0, 0],
  ["Byron Leftwich", "QB", "JAX", 2004, 14, 190.7, 2941, 15, 10, 148, 2, 1, -7, 0],
  ["Joey Harrington", "QB", "DET", 2004, 16, 187.4, 3047, 19, 12, 175, 0, 0, 0, 0],
  ["Tiki Barber", "RB", "NYG", 2004, 16, 347.6, 0, 0, 0, 1518, 13, 52, 578, 2],
  ["LaDainian Tomlinson", "RB", "SD", 2004, 15, 334.1, 38, 0, 0, 1335, 17, 53, 441, 1],
  ["Shaun Alexander", "RB", "SEA", 2004, 16, 322.8, 0, 0, 0, 1688, 16, 23, 170, 4],
  ["Domanick Williams", "RB", "HOU", 2004, 15, 322.6, 0, 0, 0, 1180, 13, 69, 596, 1],
  ["Curtis Martin", "RB", "NYJ", 2004, 16, 319.2, 0, 0, 0, 1697, 12, 41, 245, 2],
  ["Edgerrin James", "RB", "IND", 2004, 16, 306.1, 0, 0, 0, 1548, 9, 51, 483, 0],
  ["Brian Westbrook", "RB", "PHI", 2004, 13, 276.1, 0, 0, 0, 808, 3, 73, 703, 6],
  ["Corey Dillon", "RB", "NE", 2004, 15, 260.8, 0, 0, 0, 1635, 12, 15, 103, 1],
  ["Clinton Portis", "RB", "WAS", 2004, 15, 233.6, 15, 1, 0, 1315, 5, 40, 235, 2],
  ["Thomas Jones", "RB", "CHI", 2004, 14, 233.5, 0, 0, 0, 948, 7, 56, 427, 0],
  ["Rudi Johnson", "RB", "CIN", 2004, 16, 233.1, 0, 0, 0, 1457, 12, 15, 84, 0],
  ["Ahman Green", "RB", "GB", 2004, 15, 228.6, 20, 1, 0, 1163, 7, 40, 275, 1],
  ["Willis McGahee", "RB", "BUF", 2004, 15, 225.7, 0, 0, 0, 1128, 13, 22, 169, 0],
  ["Reuben Droughns", "RB", "DEN", 2004, 15, 222.1, 0, 0, 0, 1240, 6, 32, 241, 2],
  ["Michael Pittman", "RB", "TB", 2004, 13, 220.7, 0, 0, 0, 926, 7, 41, 391, 3],
  ["Warrick Dunn", "RB", "ATL", 2004, 16, 218.9, 0, 0, 0, 1106, 9, 29, 293, 0],
  ["Priest Holmes", "RB", "KC", 2004, 8, 212.9, 0, 0, 0, 892, 14, 19, 187, 1],
  ["Deuce McAllister", "RB", "NO", 2004, 14, 210.2, 0, 0, 0, 1074, 9, 34, 228, 0],
  ["Fred Taylor", "RB", "JAX", 2004, 14, 206.9, 0, 0, 0, 1224, 2, 36, 345, 1],
  ["Nick Goings", "RB", "CAR", 2004, 16, 206.5, 0, 0, 0, 821, 6, 45, 394, 1],
  ["Kevin Jones", "RB", "DET", 2004, 15, 193.3, 0, 0, 0, 1133, 5, 28, 180, 1],
  ["Jerome Bettis", "RB", "PIT", 2004, 14, 187.1, 10, 1, 0, 941, 13, 6, 46, 0],
  ["Marshall Faulk", "RB", "STL", 2004, 14, 184.4, 0, 0, 0, 774, 3, 50, 310, 1],
  ["Kevan Barlow", "RB", "SF", 2004, 15, 176.4, 0, 0, 0, 822, 7, 35, 212, 0],
  ["Emmitt Smith", "RB", "ARI", 2004, 15, 176, 21, 1, 0, 937, 9, 15, 105, 0],
  ["Larry Johnson", "RB", "KC", 2004, 8, 173.9, 0, 0, 0, 581, 9, 22, 278, 2],
  ["Chris Brown", "RB", "TEN", 2004, 11, 169.4, 0, 0, 0, 1067, 6, 20, 147, 0],
  ["Jamal Lewis", "RB", "BAL", 2004, 12, 164.2, 0, 0, 0, 1006, 7, 10, 116, 0],
  ["Derrick Blaylock", "RB", "KC", 2004, 12, 157.3, 0, 0, 0, 539, 8, 25, 244, 1],
  ["Onterrio Smith", "RB", "MIN", 2004, 11, 153.8, 0, 0, 0, 544, 2, 36, 394, 2],
  ["Muhsin Muhammad", "WR", "CAR", 2004, 16, 329, 0, 0, 0, 15, 0, 93, 1405, 16],
  ["Joe Horn", "WR", "NO", 2004, 16, 301.9, 0, 0, 0, 0, 0, 94, 1399, 11],
  ["Javon Walker", "WR", "GB", 2004, 16, 295, 0, 0, 0, 0, 0, 89, 1380, 12],
  ["Torry Holt", "WR", "STL", 2004, 16, 289.2, 0, 0, 0, 0, 0, 94, 1372, 10],
  ["Marvin Harrison", "WR", "IND", 2004, 16, 285.3, 0, 0, 0, 0, 0, 86, 1113, 15],
  ["Chad Johnson", "WR", "CIN", 2004, 16, 280.3, 0, 0, 0, 39, 0, 95, 1274, 9],
  ["Terrell Owens", "WR", "PHI", 2004, 14, 278.5, 0, 0, 0, -5, 0, 77, 1200, 14],
  ["Drew Bennett", "WR", "TEN", 2004, 15, 276.9, 26, 1, 0, 12, 0, 80, 1247, 11],
  ["Reggie Wayne", "WR", "IND", 2004, 16, 269.6, 0, 0, 0, -4, 0, 77, 1210, 12],
  ["Donald Driver", "WR", "GB", 2004, 16, 257.2, 0, 0, 0, 4, 0, 84, 1208, 9],
  ["Derrick Mason", "WR", "TEN", 2004, 16, 254.5, 0, 0, 0, -3, 0, 96, 1168, 7],
  ["Darrell Jackson", "WR", "SEA", 2004, 16, 249.7, 0, 0, 0, 0, 0, 87, 1207, 7],
  ["Isaac Bruce", "WR", "STL", 2004, 16, 246.2, 0, 0, 0, 0, 0, 89, 1292, 6],
  ["Michael Clayton", "WR", "TB", 2004, 16, 244.3, 0, 0, 0, 30, 0, 80, 1193, 7],
  ["Rod Smith", "WR", "DEN", 2004, 16, 238.7, 0, 0, 0, 33, 0, 79, 1144, 7],
  ["Nate Burleson", "WR", "MIN", 2004, 16, 235.5, 0, 0, 0, 49, 0, 68, 1006, 9],
  ["Brandon Stokley", "WR", "IND", 2004, 15, 233.7, 0, 0, 0, 0, 0, 68, 1077, 10],
  ["Andre Johnson", "WR", "HOU", 2004, 16, 228.4, 0, 0, 0, 12, 0, 79, 1142, 6],
  ["Jimmy Smith", "WR", "JAX", 2004, 16, 225.2, 0, 0, 0, 0, 0, 74, 1172, 6],
  ["Eric Moulds", "WR", "BUF", 2004, 16, 222.2, 0, 0, 0, 19, 0, 88, 1043, 5],
  ["Eddie Kennison", "WR", "KC", 2004, 14, 220.1, 0, 0, 0, 15, 0, 62, 1086, 8],
  ["Jerry Porter", "WR", "OAK", 2004, 16, 213.4, 0, 0, 0, -4, 0, 64, 998, 9],
  ["Hines Ward", "WR", "PIT", 2004, 16, 212.9, 0, 0, 0, 25, 1, 80, 1004, 4],
  ["Chris Chambers", "WR", "MIA", 2004, 15, 208.4, 0, 0, 0, 76, 0, 69, 898, 7],
  ["Ashley Lelie", "WR", "DEN", 2004, 16, 204.9, 0, 0, 0, 5, 0, 54, 1084, 7],
  ["Keyshawn Johnson", "WR", "DAL", 2004, 16, 202, 14, 0, 1, 13, 0, 70, 981, 6],
  ["Randy Moss", "WR", "MIN", 2004, 11, 201.2, 37, 0, 1, 0, 0, 49, 767, 13],
  ["T.J. Houshmandzadeh", "WR", "CIN", 2004, 15, 199.9, 0, 0, 0, 51, 0, 73, 978, 4],
  ["Lee Evans", "WR", "BUF", 2004, 15, 192.8, 0, 0, 0, 85, 0, 48, 843, 9],
  ["Laveranues Coles", "WR", "WAS", 2004, 16, 188.7, 0, 0, 0, -3, 0, 90, 950, 1],
  ["Larry Fitzgerald", "WR", "ARI", 2004, 16, 185.4, 0, 0, 0, 14, 0, 58, 780, 8],
  ["Roy Williams", "WR", "DET", 2004, 14, 181.8, 0, 0, 0, 1, 0, 54, 817, 8],
  ["Donte' Stallworth", "WR", "NO", 2004, 15, 168.4, 0, 0, 0, 37, 0, 58, 767, 5],
  ["David Patten", "WR", "NE", 2004, 15, 166.5, 0, 0, 0, 5, 0, 44, 800, 7],
  ["Antonio Bryant", "WR", "CLE", 2004, 15, 161.2, 0, 0, 0, 0, 0, 58, 812, 4],
  ["David Givens", "WR", "NE", 2004, 14, 161.2, 0, 0, 0, 0, 0, 56, 872, 3],
  ["Tony Gonzalez", "TE", "KC", 2004, 16, 270.3, 0, 0, 0, 5, 0, 102, 1258, 7],
  ["Antonio Gates", "TE", "SD", 2004, 15, 255.4, 0, 0, 0, 0, 0, 81, 964, 13],
  ["Jason Witten", "TE", "DAL", 2004, 16, 221, 0, 0, 0, 0, 0, 87, 980, 6],
  ["Randy McMichael", "TE", "MIA", 2004, 16, 178.1, 0, 0, 0, 0, 0, 73, 791, 4],
  ["Eric Johnson", "TE", "SF", 2004, 16, 174.5, 0, 0, 0, 0, 0, 82, 825, 2],
  ["Jermaine Wiggins", "TE", "MIN", 2004, 14, 165.5, 0, 0, 0, 0, 0, 71, 705, 4],
  ["Jeremy Shockey", "TE", "NYG", 2004, 15, 163.6, 0, 0, 0, 0, 0, 61, 666, 6],
  ["Alge Crumpler", "TE", "ATL", 2004, 14, 159.4, 0, 0, 0, 0, 0, 48, 774, 6],
  ["Bubba Franks", "TE", "GB", 2004, 15, 112.1, 0, 0, 0, 0, 0, 34, 361, 7],
  ["Daniel Graham", "TE", "NE", 2004, 12, 108.4, 0, 0, 0, 0, 0, 30, 364, 7],
  ["Jeb Putzier", "TE", "DEN", 2004, 14, 105.2, 0, 0, 0, 0, 0, 36, 572, 2],
  ["Chris Cooley", "TE", "WAS", 2004, 13, 104.4, 0, 0, 0, 0, 0, 37, 314, 6],
  ["Carson Palmer", "QB", "CIN", 2005, 16, 265.8, 3836, 32, 12, 44, 1, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2005, 16, 249.3, 4110, 26, 14, 89, 1, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2005, 16, 242.4, 3747, 28, 10, 45, 0, 0, 0, 0],
  ["Matt Hasselbeck", "QB", "SEA", 2005, 16, 230.6, 3455, 24, 10, 124, 1, 0, 0, 0],
  ["Eli Manning", "QB", "NYG", 2005, 16, 224.5, 3762, 24, 17, 80, 1, 0, 0, 0],
  ["Mike Vick", "QB", "ATL", 2005, 15, 219.1, 2412, 15, 13, 610, 6, 1, -14, 0],
  ["Jake Plummer", "QB", "DEN", 2005, 16, 218.2, 3366, 18, 7, 156, 2, 0, 0, 0],
  ["Trent Green", "QB", "KC", 2005, 16, 210.8, 4014, 17, 10, 82, 0, 0, 0, 0],
  ["Drew Brees", "QB", "SD", 2005, 16, 209.9, 3576, 24, 15, 49, 1, 0, 0, 0],
  ["Kerry Collins", "QB", "OAK", 2005, 15, 208.2, 3759, 20, 13, 38, 1, 0, 0, 0],
  ["Drew Bledsoe", "QB", "DAL", 2005, 16, 206.6, 3639, 23, 17, 50, 2, 0, 0, 0],
  ["Jake Delhomme", "QB", "CAR", 2005, 16, 197.9, 3421, 24, 16, 31, 1, 0, 0, 0],
  ["Mark Brunell", "QB", "WAS", 2005, 16, 195.1, 3050, 23, 10, 111, 0, 0, 0, 0],
  ["Steve McNair", "QB", "TEN", 2005, 14, 180.3, 3161, 16, 11, 139, 1, 0, 0, 0],
  ["Brett Favre", "QB", "GB", 2005, 16, 173.4, 3881, 20, 29, 62, 0, 0, 0, 0],
  ["Aaron Brooks", "QB", "NO", 2005, 13, 169.4, 2882, 13, 17, 281, 2, 0, 0, 0],
  ["Shaun Alexander", "RB", "SEA", 2005, 16, 376.8, 0, 0, 0, 1880, 27, 15, 78, 1],
  ["LaDainian Tomlinson", "RB", "SD", 2005, 16, 366.3, 47, 3, 0, 1464, 18, 51, 370, 2],
  ["Larry Johnson", "RB", "KC", 2005, 16, 360.3, 0, 0, 0, 1750, 20, 33, 343, 1],
  ["Tiki Barber", "RB", "NYG", 2005, 16, 359, 0, 0, 0, 1860, 9, 54, 530, 2],
  ["Edgerrin James", "RB", "IND", 2005, 15, 310.3, 0, 0, 0, 1506, 13, 44, 337, 1],
  ["LaMont Jordan", "RB", "OAK", 2005, 14, 294.8, 0, 0, 0, 1025, 9, 70, 563, 2],
  ["Clinton Portis", "RB", "WAS", 2005, 16, 271.9, 17, 1, 0, 1516, 11, 30, 216, 0],
  ["Rudi Johnson", "RB", "CIN", 2005, 16, 249.8, 0, 0, 0, 1458, 12, 23, 90, 0],
  ["Steven Jackson", "RB", "STL", 2005, 15, 233.6, 0, 0, 0, 1046, 8, 43, 320, 2],
  ["Brian Westbrook", "RB", "PHI", 2005, 12, 228, 0, 0, 0, 614, 3, 61, 616, 4],
  ["Thomas Jones", "RB", "CHI", 2005, 15, 223.8, 0, 0, 0, 1335, 9, 26, 143, 0],
  ["Warrick Dunn", "RB", "ATL", 2005, 16, 214.6, 0, 0, 0, 1416, 3, 29, 220, 1],
  ["Mike Anderson", "RB", "DEN", 2005, 15, 214.6, 0, 0, 0, 1014, 12, 18, 212, 1],
  ["Reuben Droughns", "RB", "CLE", 2005, 16, 209.1, 0, 0, 0, 1232, 2, 39, 369, 0],
  ["Domanick Williams", "RB", "HOU", 2005, 11, 204.3, 0, 0, 0, 976, 2, 39, 337, 4],
  ["Willis McGahee", "RB", "BUF", 2005, 16, 198.5, 0, 0, 0, 1247, 5, 28, 178, 0],
  ["Willie Parker", "RB", "PIT", 2005, 15, 190, 0, 0, 0, 1202, 4, 18, 218, 1],
  ["Corey Dillon", "RB", "NE", 2005, 11, 189.4, 0, 0, 0, 733, 12, 22, 181, 1],
  ["Julius Jones", "RB", "DAL", 2005, 13, 182.1, 0, 0, 0, 993, 5, 35, 218, 0],
  ["Chris Brown", "RB", "TEN", 2005, 15, 178.8, 0, 0, 0, 851, 5, 25, 327, 2],
  ["Cadillac Williams", "RB", "TB", 2005, 14, 177.9, 0, 0, 0, 1178, 6, 20, 81, 0],
  ["DeShaun Foster", "RB", "CAR", 2005, 15, 175.4, 0, 0, 0, 882, 2, 34, 372, 1],
  ["Ronnie Brown", "RB", "MIA", 2005, 15, 167.9, 0, 0, 0, 907, 4, 32, 232, 1],
  ["Tatum Bell", "RB", "DEN", 2005, 14, 166.5, 0, 0, 0, 921, 8, 18, 104, 0],
  ["Mewelde Moore", "RB", "MIN", 2005, 15, 159.1, 0, 0, 0, 662, 1, 37, 339, 2],
  ["Jamal Lewis", "RB", "BAL", 2005, 15, 155.7, 0, 0, 0, 906, 3, 32, 191, 1],
  ["Curtis Martin", "RB", "NYJ", 2005, 12, 137.3, 0, 0, 0, 735, 5, 24, 118, 0],
  ["Stephen Davis", "RB", "CAR", 2005, 13, 136.1, 0, 0, 0, 546, 12, 5, 45, 0],
  ["Ricky Williams", "RB", "MIA", 2005, 12, 134.6, 0, 0, 0, 743, 6, 17, 93, 0],
  ["Kevan Barlow", "RB", "SF", 2005, 12, 129.2, 0, 0, 0, 581, 3, 31, 241, 0],
  ["Steve Smith", "WR", "CAR", 2005, 16, 339.8, 0, 0, 0, 25, 1, 103, 1563, 12],
  ["Larry Fitzgerald", "WR", "ARI", 2005, 16, 308, 0, 0, 0, 41, 0, 103, 1409, 10],
  ["Chad Johnson", "WR", "CIN", 2005, 16, 297.5, 0, 0, 0, 33, 0, 97, 1432, 9],
  ["Anquan Boldin", "WR", "ARI", 2005, 14, 288.3, 0, 0, 0, 45, 0, 102, 1398, 7],
  ["Torry Holt", "WR", "STL", 2005, 14, 287.3, 0, 0, 0, 2, 0, 102, 1331, 9],
  ["Santana Moss", "WR", "WAS", 2005, 16, 284, 0, 0, 0, -3, 0, 84, 1483, 9],
  ["Joey Galloway", "WR", "TB", 2005, 14, 272.1, 0, 0, 0, 4, 0, 83, 1287, 10],
  ["Marvin Harrison", "WR", "IND", 2005, 15, 268.6, 0, 0, 0, 0, 0, 82, 1146, 12],
  ["Chris Chambers", "WR", "MIA", 2005, 16, 265, 0, 0, 0, 92, 0, 82, 1118, 11],
  ["Donald Driver", "WR", "GB", 2005, 16, 239.4, 0, 0, 0, 13, 0, 86, 1221, 5],
  ["Plaxico Burress", "WR", "NYG", 2005, 16, 237.4, 0, 0, 0, 0, 0, 76, 1214, 7],
  ["Hines Ward", "WR", "PIT", 2005, 15, 231.5, 0, 0, 0, 10, 0, 69, 975, 11],
  ["Rod Smith", "WR", "DEN", 2005, 16, 228.2, 0, 0, 0, 7, 0, 85, 1105, 6],
  ["T.J. Houshmandzadeh", "WR", "CIN", 2005, 14, 225.8, 0, 0, 0, 62, 1, 78, 956, 7],
  ["Terry Glenn", "WR", "DAL", 2005, 16, 223.2, 0, 0, 0, -4, 1, 62, 1136, 7],
  ["Reggie Wayne", "WR", "IND", 2005, 15, 218.5, 0, 0, 0, 0, 0, 83, 1055, 5],
  ["Keenan McCardell", "WR", "SD", 2005, 16, 215.9, 0, 0, 0, 2, 0, 70, 917, 9],
  ["Eddie Kennison", "WR", "KC", 2005, 15, 210.5, 0, 0, 0, 43, 0, 68, 1102, 5],
  ["Derrick Mason", "WR", "BAL", 2005, 16, 209.3, 0, 0, 0, 0, 0, 86, 1073, 3],
  ["Randy Moss", "WR", "OAK", 2005, 15, 208.5, 0, 0, 0, 0, 0, 60, 1005, 8],
  ["Jimmy Smith", "WR", "JAX", 2005, 16, 208.3, 0, 0, 0, 0, 0, 70, 1023, 6],
  ["Deion Branch", "WR", "NE", 2005, 16, 207.8, 0, 0, 0, 0, 0, 78, 998, 5],
  ["Donte' Stallworth", "WR", "NO", 2005, 15, 204.7, 0, 0, 0, 2, 0, 70, 945, 7],
  ["Jerry Porter", "WR", "OAK", 2005, 16, 199.4, 0, 0, 0, -8, 0, 76, 942, 5],
  ["Antonio Bryant", "WR", "CLE", 2005, 16, 192.2, 0, 0, 0, 3, 0, 69, 1009, 4],
  ["Laveranues Coles", "WR", "NYJ", 2005, 16, 187.5, 0, 0, 0, 0, 0, 73, 845, 5],
  ["Keyshawn Johnson", "WR", "DAL", 2005, 16, 187.2, 0, 0, 0, 3, 0, 71, 839, 6],
  ["Eric Moulds", "WR", "BUF", 2005, 14, 186.6, 0, 0, 0, 0, 0, 81, 816, 4],
  ["Joe Jurevicius", "WR", "SEA", 2005, 15, 184.4, 0, 0, 0, 0, 0, 55, 694, 10],
  ["Kevin Curtis", "WR", "STL", 2005, 16, 183.7, 0, 0, 0, 5, 1, 61, 822, 6],
  ["Amani Toomer", "WR", "NYG", 2005, 14, 170.4, 0, 0, 0, 0, 0, 60, 684, 7],
  ["Lee Evans", "WR", "BUF", 2005, 16, 169.1, 0, 0, 0, 38, 0, 49, 743, 7],
  ["Muhsin Muhammad", "WR", "CHI", 2005, 14, 163, 0, 0, 0, 0, 0, 64, 750, 4],
  ["Roy Williams", "WR", "DET", 2005, 12, 161.7, 0, 0, 0, 0, 0, 45, 687, 8],
  ["Terrell Owens", "WR", "PHI", 2005, 7, 159.5, 0, 0, 0, 2, 0, 47, 763, 6],
  ["Bobby Engram", "WR", "SEA", 2005, 13, 158.4, 0, 0, 0, 0, 0, 67, 774, 3],
  ["Antonio Gates", "TE", "SD", 2005, 15, 259.1, 0, 0, 0, 0, 0, 89, 1101, 10],
  ["Todd Heap", "TE", "BAL", 2005, 16, 200.5, 0, 0, 0, 0, 0, 75, 855, 7],
  ["Jeremy Shockey", "TE", "NYG", 2005, 15, 198.1, 0, 0, 0, 0, 0, 65, 891, 7],
  ["Chris Cooley", "TE", "WAS", 2005, 16, 188.4, 0, 0, 0, 0, 0, 71, 774, 7],
  ["Alge Crumpler", "TE", "ATL", 2005, 16, 182.7, 0, 0, 0, 0, 0, 65, 877, 5],
  ["Tony Gonzalez", "TE", "KC", 2005, 16, 180.5, 0, 0, 0, 0, 0, 78, 905, 2],
  ["Jason Witten", "TE", "DAL", 2005, 16, 177.7, 0, 0, 0, 0, 0, 66, 757, 6],
  ["Randy McMichael", "TE", "MIA", 2005, 15, 146.2, 0, 0, 0, 0, 0, 60, 582, 5],
  ["L.J. Smith", "TE", "PHI", 2005, 16, 145.2, 0, 0, 0, 0, 0, 61, 682, 3],
  ["Ben Troupe", "TE", "TEN", 2005, 13, 132, 0, 0, 0, 0, 0, 55, 530, 4],
  ["Jermaine Wiggins", "TE", "MIN", 2005, 15, 130.8, 0, 0, 0, 0, 0, 68, 568, 1],
  ["Jerramy Stevens", "TE", "SEA", 2005, 14, 130.4, 0, 0, 0, 0, 0, 45, 554, 5],
  ["Peyton Manning", "QB", "IND", 2006, 16, 309.5, 4397, 31, 9, 36, 4, 0, 0, 0],
  ["Mike Vick", "QB", "ATL", 2006, 16, 264, 2474, 20, 13, 1039, 2, 1, 1, 0],
  ["Drew Brees", "QB", "NO", 2006, 16, 260.2, 4424, 26, 11, 32, 0, 0, 0, 0],
  ["Marc Bulger", "QB", "STL", 2006, 16, 252.4, 4301, 24, 8, 44, 0, 0, 0, 0],
  ["Carson Palmer", "QB", "CIN", 2006, 16, 236.9, 4036, 28, 13, 35, 0, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2006, 16, 219.5, 3533, 24, 12, 102, 0, 0, 0, 0],
  ["Jon Kitna", "QB", "DET", 2006, 16, 217.9, 4208, 21, 22, 156, 2, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2006, 16, 208.8, 3387, 22, 9, 53, 0, 0, 0, 0],
  ["Vince Young", "QB", "TEN", 2006, 15, 203.3, 2199, 12, 13, 553, 7, 0, 0, 0],
  ["Donovan McNabb", "QB", "PHI", 2006, 10, 199.7, 2612, 18, 6, 212, 3, 0, 0, 0],
  ["Eli Manning", "QB", "NYG", 2006, 16, 191.9, 3244, 25, 18, 21, 0, 0, 0, 0],
  ["Brett Favre", "QB", "GB", 2006, 16, 190.2, 3885, 18, 18, 28, 1, 0, 0, 0],
  ["Ben Roethlisberger", "QB", "PIT", 2006, 15, 184.9, 3528, 18, 23, 98, 2, 0, 0, 0],
  ["Steve McNair", "QB", "BAL", 2006, 16, 177.9, 3050, 16, 12, 119, 1, 0, 0, 0],
  ["J.P. Losman", "QB", "BUF", 2006, 16, 176, 3050, 19, 14, 140, 1, 0, 0, 0],
  ["Tony Romo", "QB", "DAL", 2006, 13, 174.3, 2903, 19, 13, 102, 0, 0, 0, 0],
  ["LaDainian Tomlinson", "RB", "SD", 2006, 16, 481.1, 20, 2, 0, 1815, 28, 56, 508, 3],
  ["Steven Jackson", "RB", "STL", 2006, 16, 415.4, 0, 0, 0, 1528, 13, 90, 806, 3],
  ["Larry Johnson", "RB", "KC", 2006, 16, 370.9, 0, 0, 0, 1789, 17, 41, 410, 2],
  ["Brian Westbrook", "RB", "PHI", 2006, 15, 330.6, 0, 0, 0, 1217, 7, 77, 699, 4],
  ["Frank Gore", "RB", "SF", 2006, 16, 321, 0, 0, 0, 1695, 8, 61, 485, 1],
  ["Tiki Barber", "RB", "NYG", 2006, 16, 298.7, 0, 0, 0, 1662, 5, 58, 465, 0],
  ["Willie Parker", "RB", "PIT", 2006, 16, 288.6, 0, 0, 0, 1494, 13, 31, 222, 3],
  ["Maurice Jones-Drew", "RB", "JAX", 2006, 16, 277.7, 0, 0, 0, 941, 13, 46, 436, 2],
  ["Reggie Bush", "RB", "NO", 2006, 16, 267.6, 0, 0, 1, 558, 6, 89, 748, 2],
  ["Ladell Betts", "RB", "WAS", 2006, 16, 236.9, 0, 0, 0, 1154, 4, 53, 445, 1],
  ["Rudi Johnson", "RB", "CIN", 2006, 16, 234.2, 0, 0, 0, 1308, 12, 23, 124, 0],
  ["Deuce McAllister", "RB", "NO", 2006, 15, 225.9, 0, 0, 0, 1061, 12, 30, 198, 0],
  ["Joseph Addai", "RB", "IND", 2006, 16, 224.6, 0, 0, 0, 1081, 7, 40, 325, 1],
  ["Ahman Green", "RB", "GB", 2006, 14, 222.9, 0, 0, 0, 1059, 5, 47, 380, 1],
  ["Chester Taylor", "RB", "MIN", 2006, 15, 222.2, 0, 0, 0, 1214, 6, 42, 288, 0],
  ["Kevin Jones", "RB", "DET", 2006, 12, 219.9, 0, 0, 0, 689, 6, 61, 520, 2],
  ["Thomas Jones", "RB", "CHI", 2006, 16, 205.7, -4, 0, 0, 1205, 6, 36, 154, 0],
  ["Edgerrin James", "RB", "ARI", 2006, 16, 205.6, 0, 0, 0, 1159, 6, 38, 217, 0],
  ["Marion Barber", "RB", "DAL", 2006, 16, 204, 0, 0, 0, 654, 14, 23, 196, 2],
  ["Fred Taylor", "RB", "JAX", 2006, 15, 193.8, 0, 0, 0, 1146, 5, 23, 242, 1],
  ["Jamal Lewis", "RB", "BAL", 2006, 16, 192.7, 0, 0, 0, 1132, 9, 18, 115, 0],
  ["Travis Henry", "RB", "TEN", 2006, 14, 188.9, 0, 0, 0, 1211, 7, 18, 78, 0],
  ["Ronnie Brown", "RB", "MIA", 2006, 13, 185.1, 0, 0, 0, 1005, 5, 33, 276, 0],
  ["Corey Dillon", "RB", "NE", 2006, 16, 184.9, 0, 0, 0, 812, 13, 15, 147, 0],
  ["Warrick Dunn", "RB", "ATL", 2006, 16, 183, 0, 0, 0, 1140, 4, 22, 170, 1],
  ["Willis McGahee", "RB", "BUF", 2006, 14, 164.6, 0, 0, 0, 990, 6, 18, 156, 0],
  ["Laurence Maroney", "RB", "NE", 2006, 14, 155.9, 0, 0, 0, 745, 6, 22, 194, 1],
  ["Julius Jones", "RB", "DAL", 2006, 16, 153.6, 0, 0, 0, 1084, 4, 9, 142, 0],
  ["DeShaun Foster", "RB", "CAR", 2006, 14, 151.6, 0, 0, 0, 897, 3, 32, 159, 0],
  ["Mike Bell", "RB", "DEN", 2006, 14, 151.5, 0, 0, 0, 677, 8, 20, 158, 0],
  ["Marvin Harrison", "WR", "IND", 2006, 16, 301.6, 0, 0, 0, 0, 0, 95, 1366, 12],
  ["Terrell Owens", "WR", "DAL", 2006, 16, 283, 0, 0, 0, 0, 0, 85, 1180, 13],
  ["Reggie Wayne", "WR", "IND", 2006, 16, 273, 0, 0, 0, 0, 0, 86, 1310, 9],
  ["Torry Holt", "WR", "STL", 2006, 16, 269.8, 0, 0, 0, 0, 0, 93, 1188, 10],
  ["Donald Driver", "WR", "GB", 2006, 16, 269.4, 0, 0, 0, 16, 0, 91, 1288, 8],
  ["Chad Johnson", "WR", "CIN", 2006, 16, 266.4, 0, 0, 0, 24, 0, 87, 1370, 7],
  ["Steve Smith", "WR", "CAR", 2006, 14, 259.7, 0, 0, 0, 61, 1, 83, 1166, 8],
  ["Lee Evans", "WR", "BUF", 2006, 16, 259.1, 0, 0, 0, 0, 0, 82, 1291, 8],
  ["T.J. Houshmandzadeh", "WR", "CIN", 2006, 14, 252.7, 0, 0, 0, 6, 0, 90, 1081, 9],
  ["Roy Williams", "WR", "DET", 2006, 16, 251.2, 0, 0, 0, 2, 0, 82, 1310, 7],
  ["Andre Johnson", "WR", "HOU", 2006, 16, 249.1, 0, 0, 0, 14, 0, 103, 1147, 5],
  ["Javon Walker", "WR", "DEN", 2006, 16, 243.7, 0, 0, 0, 123, 1, 69, 1084, 8],
  ["Mike Furrey", "WR", "DET", 2006, 16, 240.6, 0, 0, 0, 0, 0, 98, 1086, 6],
  ["Laveranues Coles", "WR", "NYJ", 2006, 16, 238.2, 0, 0, 0, 14, 0, 91, 1098, 6],
  ["Anquan Boldin", "WR", "ARI", 2006, 16, 230.1, 0, 0, 0, 28, 0, 83, 1203, 4],
  ["Marques Colston", "WR", "NO", 2006, 12, 221.8, 0, 0, 0, 0, 0, 70, 1038, 8],
  ["Plaxico Burress", "WR", "NYG", 2006, 15, 219.8, 0, 0, 0, 0, 0, 63, 988, 10],
  ["Darrell Jackson", "WR", "SEA", 2006, 13, 218.6, 0, 0, 0, 0, 0, 63, 956, 10],
  ["Jerricho Cotchery", "WR", "NYJ", 2006, 16, 216.6, 0, 0, 0, 25, 0, 82, 961, 6],
  ["Terry Glenn", "WR", "DAL", 2006, 15, 211.8, 0, 0, 0, 11, 0, 70, 1047, 6],
  ["Joey Galloway", "WR", "TB", 2006, 14, 210.6, 0, 0, 0, 9, 0, 62, 1057, 7],
  ["Hines Ward", "WR", "PIT", 2006, 14, 208.5, 0, 0, 0, 30, 0, 74, 975, 6],
  ["Isaac Bruce", "WR", "STL", 2006, 16, 203.8, 0, 0, 0, 0, 0, 74, 1098, 3],
  ["Larry Fitzgerald", "WR", "ARI", 2006, 13, 198.6, 0, 0, 0, 5, 0, 68, 941, 6],
  ["Mark Clayton", "WR", "BAL", 2006, 16, 187.9, 0, 0, 0, -30, 0, 67, 939, 5],
  ["Reggie Brown", "WR", "PHI", 2006, 15, 187, 0, 0, 0, 24, 1, 47, 836, 8],
  ["Braylon Edwards", "WR", "CLE", 2006, 16, 185.1, 0, 0, 0, 12, 0, 60, 879, 6],
  ["Santana Moss", "WR", "WAS", 2006, 14, 180.2, 0, 0, 0, 82, 0, 55, 790, 6],
  ["Keyshawn Johnson", "WR", "CAR", 2006, 16, 177.9, 0, 0, 1, 4, 1, 70, 815, 4],
  ["Muhsin Muhammad", "WR", "CHI", 2006, 16, 174.3, 0, 0, 0, 0, 0, 60, 863, 5],
  ["Marty Booker", "WR", "MIA", 2006, 14, 171.6, 0, 0, 0, 19, 0, 55, 747, 6],
  ["Eddie Kennison", "WR", "KC", 2006, 16, 170.6, 0, 0, 0, 16, 0, 53, 860, 5],
  ["Bernard Berrian", "WR", "CHI", 2006, 14, 163, 0, 0, 0, 5, 0, 51, 775, 6],
  ["Reche Caldwell", "WR", "NE", 2006, 16, 161.5, 0, 0, 0, 5, 0, 61, 760, 4],
  ["Chris Chambers", "WR", "MIA", 2006, 16, 160.2, 0, 0, 0, 95, 0, 59, 677, 4],
  ["Derrick Mason", "WR", "BAL", 2006, 15, 154.6, 0, 0, 0, -4, 0, 68, 750, 2],
  ["Antonio Gates", "TE", "SD", 2006, 16, 217.4, 0, 0, 0, 0, 0, 71, 924, 9],
  ["Tony Gonzalez", "TE", "KC", 2006, 15, 195, 0, 0, 0, 0, 0, 73, 900, 5],
  ["Kellen Winslow", "TE", "CLE", 2006, 16, 194.5, 0, 0, 0, 0, 0, 89, 875, 3],
  ["Todd Heap", "TE", "BAL", 2006, 16, 185.5, 0, 0, 0, 0, 0, 73, 765, 6],
  ["Alge Crumpler", "TE", "ATL", 2006, 16, 182, 0, 0, 0, 0, 0, 56, 780, 8],
  ["Jeremy Shockey", "TE", "NYG", 2006, 15, 170.3, 0, 0, 0, 0, 0, 66, 623, 7],
  ["Chris Cooley", "TE", "WAS", 2006, 16, 168.4, 0, 0, 0, 0, 0, 57, 734, 6],
  ["Jason Witten", "TE", "DAL", 2006, 16, 145.4, 0, 0, 0, 0, 0, 64, 754, 1],
  ["Randy McMichael", "TE", "MIA", 2006, 16, 144, 0, 0, 0, 0, 0, 62, 640, 3],
  ["Desmond Clark", "TE", "CHI", 2006, 14, 143.6, 0, 0, 0, 0, 0, 45, 626, 6],
  ["L.J. Smith", "TE", "PHI", 2006, 14, 143.1, 0, 0, 0, 0, 0, 50, 611, 5],
  ["Benjamin Watson", "TE", "NE", 2006, 13, 131.7, 0, 0, 0, 0, 0, 50, 657, 3],
  ["Tom Brady", "QB", "NE", 2007, 16, 390, 4806, 50, 8, 98, 2, 0, 0, 0],
  ["Tony Romo", "QB", "DAL", 2007, 16, 295.6, 4211, 36, 19, 132, 2, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2007, 16, 275.1, 4040, 31, 14, -5, 3, 0, 0, 0],
  ["Ben Roethlisberger", "QB", "PIT", 2007, 15, 260.7, 3158, 32, 11, 204, 2, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2007, 16, 259.3, 4428, 28, 18, 52, 1, 2, 10, 0],
  ["Derek Anderson", "QB", "CLE", 2007, 16, 253.1, 3786, 29, 19, 77, 3, 0, 0, 0],
  ["Matt Hasselbeck", "QB", "SEA", 2007, 16, 246.3, 3966, 28, 12, 97, 0, 0, 0, 0],
  ["Brett Favre", "QB", "GB", 2007, 16, 243.5, 4157, 28, 15, 12, 0, 0, 0, 0],
  ["Carson Palmer", "QB", "CIN", 2007, 16, 228.2, 4130, 26, 20, 10, 0, 0, 0, 0],
  ["Donovan McNabb", "QB", "PHI", 2007, 14, 212.6, 3324, 20, 7, 236, 0, 0, 0, 0],
  ["Jay Cutler", "QB", "DEN", 2007, 16, 210.4, 3497, 20, 14, 205, 1, 0, 0, 0],
  ["Kurt Warner", "QB", "ARI", 2007, 14, 205.9, 3409, 27, 17, 15, 1, 0, 0, 0],
  ["Jon Kitna", "QB", "DET", 2007, 16, 190.8, 4066, 18, 21, 63, 0, 1, 9, 0],
  ["David Garrard", "QB", "JAX", 2007, 12, 188.6, 2509, 18, 3, 182, 1, 0, 0, 0],
  ["Eli Manning", "QB", "NYG", 2007, 16, 184.3, 3336, 23, 20, 69, 1, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2007, 16, 177.4, 3152, 21, 15, 33, 1, 0, 0, 0],
  ["Brian Westbrook", "RB", "PHI", 2007, 15, 370.4, 0, 0, 0, 1333, 7, 90, 771, 5],
  ["LaDainian Tomlinson", "RB", "SD", 2007, 16, 367.6, 17, 1, 0, 1474, 15, 60, 475, 3],
  ["Joseph Addai", "RB", "IND", 2007, 15, 276.6, 0, 0, 0, 1072, 12, 41, 364, 3],
  ["Clinton Portis", "RB", "WAS", 2007, 16, 272.7, 15, 1, 0, 1262, 11, 47, 389, 0],
  ["Adrian Peterson", "RB", "MIN", 2007, 14, 251.9, 0, 0, 0, 1341, 12, 19, 268, 1],
  ["Jamal Lewis", "RB", "CLE", 2007, 15, 247.1, 0, 0, 0, 1303, 9, 30, 248, 2],
  ["Marion Barber", "RB", "DAL", 2007, 16, 241.5, 0, 0, 0, 973, 10, 44, 282, 2],
  ["Frank Gore", "RB", "SF", 2007, 15, 236.8, 0, 0, 0, 1102, 5, 53, 436, 1],
  ["Earnest Graham", "RB", "TB", 2007, 15, 229.2, 0, 0, 0, 898, 10, 49, 324, 0],
  ["Willis McGahee", "RB", "BAL", 2007, 15, 228.8, 0, 0, 0, 1207, 7, 43, 231, 1],
  ["Maurice Jones-Drew", "RB", "JAX", 2007, 15, 213.5, 0, 0, 0, 768, 9, 40, 407, 0],
  ["Edgerrin James", "RB", "ARI", 2007, 16, 209.8, 0, 0, 0, 1232, 7, 25, 196, 0],
  ["Reggie Bush", "RB", "NO", 2007, 12, 208.8, 0, 0, 0, 581, 4, 73, 417, 2],
  ["Kenny Watson", "RB", "CIN", 2007, 15, 203.6, 0, 0, 0, 763, 7, 52, 373, 0],
  ["Steven Jackson", "RB", "STL", 2007, 12, 201.4, 2, 1, 0, 1002, 5, 38, 271, 1],
  ["Marshawn Lynch", "RB", "BUF", 2007, 13, 194.2, 8, 1, 0, 1115, 7, 18, 184, 0],
  ["Ryan Grant", "RB", "GB", 2007, 14, 186.3, 0, 0, 0, 956, 8, 30, 147, 0],
  ["Chester Taylor", "RB", "MIN", 2007, 14, 179.5, 0, 0, 0, 844, 7, 29, 281, 0],
  ["Willie Parker", "RB", "PIT", 2007, 15, 177, 0, 0, 0, 1316, 2, 23, 164, 0],
  ["LenDale White", "RB", "TEN", 2007, 16, 176.2, 0, 0, 0, 1108, 7, 20, 114, 0],
  ["Thomas Jones", "RB", "NYJ", 2007, 16, 173.6, 0, 0, 0, 1119, 1, 28, 217, 1],
  ["Ronnie Brown", "RB", "MIA", 2007, 7, 170.1, 0, 0, 0, 602, 4, 39, 389, 1],
  ["Brandon Jacobs", "RB", "NYG", 2007, 11, 169.5, 0, 0, 0, 1011, 4, 23, 174, 2],
  ["Justin Fargas", "RB", "OAK", 2007, 14, 164.7, 0, 0, 0, 1009, 4, 23, 188, 0],
  ["Fred Taylor", "RB", "JAX", 2007, 15, 163, 0, 0, 0, 1202, 5, 9, 58, 0],
  ["Adrian Peterson", "RB", "CHI", 2007, 16, 162.4, 9, 1, 0, 510, 3, 51, 420, 0],
  ["Kevin Jones", "RB", "DET", 2007, 13, 156.8, 0, 0, 0, 581, 8, 33, 197, 0],
  ["Warrick Dunn", "RB", "ATL", 2007, 16, 152.6, 0, 0, 0, 718, 4, 37, 238, 0],
  ["DeShaun Foster", "RB", "CAR", 2007, 16, 144.9, 0, 0, 0, 876, 3, 24, 173, 1],
  ["Ron Dayne", "RB", "HOU", 2007, 13, 141.5, 0, 0, 0, 773, 6, 17, 112, 0],
  ["Randy Moss", "WR", "NE", 2007, 16, 385.3, 0, 0, 0, 0, 0, 98, 1493, 23],
  ["Reggie Wayne", "WR", "IND", 2007, 16, 309.4, 0, 0, 0, 4, 0, 104, 1510, 10],
  ["Terrell Owens", "WR", "DAL", 2007, 15, 307, 0, 0, 0, 5, 0, 81, 1355, 15],
  ["Braylon Edwards", "WR", "CLE", 2007, 16, 300.9, 0, 0, 0, 0, 0, 80, 1289, 16],
  ["T.J. Houshmandzadeh", "WR", "CIN", 2007, 16, 297.7, 0, 0, 0, 14, 0, 112, 1143, 12],
  ["Larry Fitzgerald", "WR", "ARI", 2007, 15, 296.2, 0, 0, 0, 0, 0, 101, 1412, 10],
  ["Chad Johnson", "WR", "CIN", 2007, 16, 287.7, 0, 0, 0, 47, 0, 93, 1440, 8],
  ["Marques Colston", "WR", "NO", 2007, 16, 282.2, 0, 0, 0, 0, 0, 98, 1202, 11],
  ["Wes Welker", "WR", "NE", 2007, 16, 280.9, 0, 0, 0, 34, 0, 112, 1175, 8],
  ["Brandon Marshall", "WR", "DEN", 2007, 16, 280.2, 0, 0, 0, 57, 0, 102, 1325, 7],
  ["Torry Holt", "WR", "STL", 2007, 16, 255.9, 0, 0, 0, 0, 0, 93, 1189, 7],
  ["Plaxico Burress", "WR", "NYG", 2007, 16, 244.5, 0, 0, 0, 0, 0, 70, 1025, 12],
  ["Bobby Engram", "WR", "SEA", 2007, 16, 242.7, 0, 0, 0, 0, 0, 94, 1147, 6],
  ["Derrick Mason", "WR", "BAL", 2007, 16, 239.7, 0, 0, 0, 0, 0, 103, 1087, 5],
  ["Steve Smith", "WR", "CAR", 2007, 15, 235.8, 0, 0, 0, 66, 0, 87, 1002, 7],
  ["Roddy White", "WR", "ATL", 2007, 16, 235, 0, 0, 0, -2, 0, 83, 1202, 6],
  ["Kevin Curtis", "WR", "PHI", 2007, 16, 224, 0, 0, 0, 0, 0, 77, 1110, 6],
  ["Greg Jennings", "WR", "GB", 2007, 13, 217, 0, 0, 0, 0, 0, 53, 920, 12],
  ["Anquan Boldin", "WR", "ARI", 2007, 12, 209.7, 0, 0, 0, 14, 0, 71, 853, 9],
  ["Jerricho Cotchery", "WR", "NYJ", 2007, 15, 208.7, 0, 0, 0, 38, 0, 82, 1129, 2],
  ["Shaun McDonald", "WR", "DET", 2007, 16, 205.5, 0, 0, 0, 2, 0, 79, 943, 6],
  ["Dwayne Bowe", "WR", "KC", 2007, 15, 199.5, 0, 0, 0, 0, 0, 70, 995, 5],
  ["Donald Driver", "WR", "GB", 2007, 15, 199.2, 0, 0, 0, 4, 0, 82, 1048, 2],
  ["Santonio Holmes", "WR", "PIT", 2007, 13, 197.9, 0, 0, 0, 17, 0, 52, 942, 8],
  ["Joey Galloway", "WR", "TB", 2007, 15, 194.5, 0, 0, 0, 1, 0, 57, 1014, 6],
  ["Bernard Berrian", "WR", "CHI", 2007, 16, 193.1, 0, 0, 0, 3, 0, 70, 948, 5],
  ["Andre Johnson", "WR", "HOU", 2007, 9, 191.1, 0, 0, 0, 0, 0, 60, 851, 8],
  ["Hines Ward", "WR", "PIT", 2007, 13, 190.3, 0, 0, 0, 7, 0, 72, 736, 7],
  ["Chris Chambers", "WR", "SD", 2007, 16, 188.2, 0, 0, 0, 12, 0, 66, 970, 4],
  ["Nate Burleson", "WR", "SEA", 2007, 16, 183.8, 0, 0, 0, 4, 0, 50, 694, 9],
  ["Kevin Walter", "WR", "HOU", 2007, 15, 178, 0, 0, 0, 30, 0, 65, 800, 4],
  ["Roy Williams", "WR", "DET", 2007, 12, 174.7, 0, 0, 0, 1, 0, 63, 836, 5],
  ["Lee Evans", "WR", "BUF", 2007, 16, 169.9, 0, 0, 0, 0, 0, 55, 849, 5],
  ["Reggie Brown", "WR", "PHI", 2007, 16, 166.6, 0, 0, 0, 36, 0, 61, 780, 4],
  ["Patrick Crayton", "WR", "DAL", 2007, 13, 159.7, 0, 0, 0, 0, 0, 50, 697, 7],
  ["Calvin Johnson", "WR", "DET", 2007, 15, 158.8, 0, 0, 0, 52, 1, 48, 756, 4],
  ["Jason Witten", "TE", "DAL", 2007, 16, 250.5, 0, 0, 0, 0, 0, 96, 1145, 7],
  ["Tony Gonzalez", "TE", "KC", 2007, 16, 246.2, 0, 0, 0, 0, 0, 99, 1172, 5],
  ["Antonio Gates", "TE", "SD", 2007, 16, 227.4, 0, 0, 0, 0, 0, 75, 984, 9],
  ["Kellen Winslow", "TE", "CLE", 2007, 16, 222.6, 0, 0, 0, 0, 0, 82, 1106, 5],
  ["Chris Cooley", "TE", "WAS", 2007, 16, 194.6, 0, 0, 0, 0, 0, 66, 786, 8],
  ["Dallas Clark", "TE", "IND", 2007, 15, 188.5, 0, 0, 0, 29, 0, 58, 616, 11],
  ["Owen Daniels", "TE", "HOU", 2007, 16, 151.8, 0, 0, 0, 0, 0, 63, 768, 3],
  ["Heath Miller", "TE", "PIT", 2007, 15, 145.6, 0, 0, 0, 0, 0, 47, 566, 7],
  ["Donald Lee", "TE", "GB", 2007, 15, 139.5, 0, 0, 0, 0, 0, 48, 575, 6],
  ["Jeremy Shockey", "TE", "NYG", 2007, 14, 137.5, 0, 0, 0, 6, 0, 57, 619, 3],
  ["Tony Scheffler", "TE", "DEN", 2007, 12, 131.9, 0, 0, 0, 0, 0, 49, 549, 5],
  ["Vernon Davis", "TE", "SF", 2007, 14, 124.9, 0, 0, 0, 0, 0, 52, 509, 4],
  ["Drew Brees", "QB", "NO", 2008, 16, 302.7, 5069, 34, 17, -1, 0, 0, 0, 0],
  ["Aaron Rodgers", "QB", "GB", 2008, 16, 290.2, 4038, 28, 13, 207, 4, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2008, 16, 278.6, 4004, 34, 11, 84, 0, 0, 0, 0],
  ["Jay Cutler", "QB", "DEN", 2008, 16, 277, 4525, 25, 18, 200, 2, 0, 0, 0],
  ["Kurt Warner", "QB", "ARI", 2008, 16, 261.1, 4582, 30, 14, -2, 0, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2008, 16, 254.2, 4002, 27, 12, 21, 1, 0, 0, 0],
  ["Matt Cassel", "QB", "NE", 2008, 16, 244.8, 3693, 21, 11, 271, 2, 0, 0, 0],
  ["Donovan McNabb", "QB", "PHI", 2008, 16, 243.7, 3914, 23, 11, 151, 2, 0, 0, 0],
  ["Chad Pennington", "QB", "MIA", 2008, 16, 217.9, 3653, 19, 7, 58, 1, 0, 0, 0],
  ["Tyler Thigpen", "QB", "KC", 2008, 14, 217.6, 2608, 18, 12, 386, 3, 1, 37, 1],
  ["David Garrard", "QB", "JAX", 2008, 16, 217.4, 3620, 15, 13, 322, 2, 1, -6, 0],
  ["Tony Romo", "QB", "DAL", 2008, 13, 204, 3448, 26, 14, 41, 0, 0, 0, 0],
  ["Jason Campbell", "QB", "WAS", 2008, 16, 199.6, 3245, 13, 6, 258, 1, 0, 0, 0],
  ["Eli Manning", "QB", "NYG", 2008, 16, 198.5, 3238, 21, 10, 10, 1, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2008, 16, 196, 3440, 16, 11, 104, 1, 0, 0, 0],
  ["Brett Favre", "QB", "NYJ", 2008, 16, 191.2, 3472, 22, 22, 43, 1, 0, 0, 0],
  ["DeAngelo Williams", "RB", "CAR", 2008, 16, 307.9, 0, 0, 0, 1518, 18, 22, 121, 2],
  ["Matt Forte", "RB", "CHI", 2008, 16, 305.5, 0, 0, 0, 1231, 8, 64, 484, 4],
  ["Maurice Jones-Drew", "RB", "JAX", 2008, 16, 278.9, 0, 0, 0, 824, 12, 62, 565, 2],
  ["Michael Turner", "RB", "ATL", 2008, 16, 278, 0, 0, 0, 1699, 17, 6, 41, 0],
  ["LaDainian Tomlinson", "RB", "SD", 2008, 16, 277.1, 0, 0, 0, 1110, 11, 52, 421, 1],
  ["Thomas Jones", "RB", "NYJ", 2008, 16, 275.9, 0, 0, 0, 1312, 13, 36, 207, 2],
  ["Steve Slaton", "RB", "HOU", 2008, 16, 271.9, 0, 0, 0, 1282, 9, 50, 377, 1],
  ["Brian Westbrook", "RB", "PHI", 2008, 14, 269.8, 0, 0, 0, 936, 9, 54, 402, 5],
  ["Adrian Peterson", "RB", "MIN", 2008, 16, 261.2, 0, 0, 0, 1757, 10, 21, 125, 0],
  ["Chris Johnson", "RB", "TEN", 2008, 15, 249.8, 0, 0, 0, 1228, 9, 43, 260, 1],
  ["Clinton Portis", "RB", "WAS", 2008, 16, 246.5, 0, 0, 0, 1487, 9, 28, 218, 0],
  ["Marshawn Lynch", "RB", "BUF", 2008, 15, 233.7, 0, 0, 0, 1047, 8, 47, 300, 1],
  ["Marion Barber", "RB", "DAL", 2008, 15, 230.2, 0, 0, 0, 885, 7, 52, 417, 2],
  ["Frank Gore", "RB", "SF", 2008, 14, 227.9, 0, 0, 0, 1036, 6, 43, 373, 2],
  ["Steven Jackson", "RB", "STL", 2008, 12, 224.2, 0, 0, 0, 1043, 7, 40, 379, 1],
  ["Ronnie Brown", "RB", "MIA", 2008, 16, 213.2, 31, 1, 0, 916, 10, 33, 254, 0],
  ["Kevin Smith", "RB", "DET", 2008, 16, 211.1, 0, 0, 0, 975, 8, 39, 286, 0],
  ["Brandon Jacobs", "RB", "NYG", 2008, 13, 206.5, 0, 0, 0, 1089, 15, 6, 36, 0],
  ["Derrick Ward", "RB", "NYG", 2008, 16, 193.9, 0, 0, 0, 1025, 2, 41, 384, 0],
  ["Kevin Faulk", "RB", "NE", 2008, 15, 193.2, -2, 0, 0, 507, 3, 58, 486, 3],
  ["Pierre Thomas", "RB", "NO", 2008, 14, 191.9, 0, 0, 0, 625, 9, 31, 284, 3],
  ["Reggie Bush", "RB", "NO", 2008, 10, 186.4, 0, 0, 0, 404, 2, 52, 440, 4],
  ["Dominic Rhodes", "RB", "IND", 2008, 15, 185, 0, 0, 0, 538, 6, 45, 302, 3],
  ["Leon Washington", "RB", "NYJ", 2008, 16, 181.3, 0, 0, 0, 448, 6, 47, 355, 2],
  ["Ryan Grant", "RB", "GB", 2008, 16, 173.9, 0, 0, 0, 1203, 4, 18, 116, 1],
  ["LenDale White", "RB", "TEN", 2008, 16, 171.9, 0, 0, 0, 773, 15, 5, 16, 0],
  ["Warrick Dunn", "RB", "TB", 2008, 15, 170.6, 0, 0, 0, 786, 2, 47, 330, 0],
  ["Mewelde Moore", "RB", "PIT", 2008, 14, 166.8, 0, 0, 0, 588, 5, 40, 320, 1],
  ["Jamal Lewis", "RB", "CLE", 2008, 16, 163, 0, 0, 0, 1002, 4, 23, 178, 0],
  ["Chester Taylor", "RB", "MIN", 2008, 16, 161, 4, 1, 0, 399, 4, 45, 399, 2],
  ["Andre Johnson", "WR", "HOU", 2008, 16, 320.5, 0, 0, 0, 0, 0, 115, 1575, 8],
  ["Larry Fitzgerald", "WR", "ARI", 2008, 16, 311.4, 0, 0, 0, 0, 0, 96, 1434, 12],
  ["Calvin Johnson", "WR", "DET", 2008, 16, 281, 0, 0, 0, -1, 0, 78, 1331, 12],
  ["Roddy White", "WR", "ATL", 2008, 16, 266.6, 0, 0, 0, 4, 0, 88, 1382, 7],
  ["Greg Jennings", "WR", "GB", 2008, 16, 265.2, 0, 0, 0, 0, 0, 80, 1292, 9],
  ["Brandon Marshall", "WR", "DEN", 2008, 15, 260.1, 0, 0, 0, -4, 0, 104, 1265, 6],
  ["Anquan Boldin", "WR", "ARI", 2008, 12, 259.5, 0, 0, 0, 67, 0, 89, 1038, 11],
  ["Steve Smith", "WR", "CAR", 2008, 14, 257.7, 0, 0, 0, 40, 0, 78, 1417, 6],
  ["Antonio Bryant", "WR", "TB", 2008, 15, 250, 0, 0, 0, 22, 0, 83, 1248, 7],
  ["Wes Welker", "WR", "NE", 2008, 16, 249.1, 0, 0, 0, 26, 0, 112, 1165, 3],
  ["Terrell Owens", "WR", "DAL", 2008, 16, 235.5, 0, 0, 0, 33, 0, 69, 1052, 10],
  ["Reggie Wayne", "WR", "IND", 2008, 16, 234.5, 0, 0, 0, 0, 0, 82, 1145, 6],
  ["Randy Moss", "WR", "NE", 2008, 16, 231.8, 0, 0, 0, 0, 0, 69, 1008, 11],
  ["Dwayne Bowe", "WR", "KC", 2008, 16, 230.2, 0, 0, 0, 0, 0, 86, 1022, 7],
  ["Eddie Royal", "WR", "DEN", 2008, 15, 229.9, 0, 0, 0, 109, 0, 91, 980, 5],
  ["Lance Moore", "WR", "NO", 2008, 16, 229.8, 0, 0, 1, 0, 0, 79, 928, 10],
  ["Hines Ward", "WR", "PIT", 2008, 16, 228.7, 0, 0, 0, 0, 0, 82, 1047, 7],
  ["Santana Moss", "WR", "WAS", 2008, 15, 226.1, 0, 0, 0, 27, 0, 79, 1044, 6],
  ["Vincent Jackson", "WR", "SD", 2008, 15, 215.7, 0, 0, 0, 69, 0, 59, 1098, 7],
  ["Derrick Mason", "WR", "BAL", 2008, 16, 214, 0, 0, 0, 3, 0, 80, 1037, 5],
  ["T.J. Houshmandzadeh", "WR", "CIN", 2008, 14, 207.3, 0, 0, 0, 9, 0, 92, 904, 4],
  ["Donald Driver", "WR", "GB", 2008, 16, 205.6, 0, 0, 0, 4, 0, 74, 1012, 5],
  ["Kevin Walter", "WR", "HOU", 2008, 16, 200.2, 0, 0, 0, 23, 0, 60, 899, 8],
  ["Laveranues Coles", "WR", "NYJ", 2008, 16, 197.9, 0, 0, 0, 9, 0, 70, 850, 7],
  ["Steve Breaston", "WR", "ARI", 2008, 15, 196.1, 0, 0, 0, 8, 0, 77, 1003, 3],
  ["Bernard Berrian", "WR", "MIN", 2008, 14, 195, 0, 0, 0, 26, 0, 48, 964, 7],
  ["Jerricho Cotchery", "WR", "NYJ", 2008, 16, 187.6, 0, 0, 0, 8, 0, 71, 858, 5],
  ["Muhsin Muhammad", "WR", "CAR", 2008, 16, 185.3, 0, 0, 0, 0, 0, 65, 923, 5],
  ["Isaac Bruce", "WR", "SF", 2008, 15, 185, 0, 0, 0, -3, 0, 60, 833, 7],
  ["Lee Evans", "WR", "BUF", 2008, 15, 184.9, 0, 0, 0, 22, 0, 63, 1017, 3],
  ["DeSean Jackson", "WR", "PHI", 2008, 16, 184.8, 0, 0, 1, 96, 1, 62, 912, 2],
  ["Ted Ginn", "WR", "MIA", 2008, 16, 166.3, 0, 0, 0, 73, 2, 56, 790, 2],
  ["Santonio Holmes", "WR", "PIT", 2008, 15, 166, 0, 0, 0, 9, 0, 55, 821, 5],
  ["Braylon Edwards", "WR", "CLE", 2008, 16, 164.7, 0, 0, 0, 0, 0, 55, 877, 3],
  ["Torry Holt", "WR", "STL", 2008, 16, 161.6, 0, 0, 0, 0, 0, 64, 796, 3],
  ["Marques Colston", "WR", "NO", 2008, 10, 153, 0, 0, 0, 0, 0, 47, 760, 5],
  ["Tony Gonzalez", "TE", "KC", 2008, 16, 261.8, 0, 0, 0, 0, 0, 96, 1058, 10],
  ["Jason Witten", "TE", "DAL", 2008, 15, 201.9, 42, 0, 0, 0, 0, 81, 952, 4],
  ["Dallas Clark", "TE", "IND", 2008, 15, 195.8, 0, 0, 0, 0, 0, 77, 848, 6],
  ["Antonio Gates", "TE", "SD", 2008, 15, 176.4, 0, 0, 0, 0, 0, 60, 704, 8],
  ["Chris Cooley", "TE", "WAS", 2008, 16, 169.9, 0, 0, 0, 0, 0, 83, 849, 1],
  ["Owen Daniels", "TE", "HOU", 2008, 16, 166.2, 0, 0, 0, 0, 0, 70, 862, 2],
  ["John Carlson", "TE", "SEA", 2008, 15, 147.7, 0, 0, 0, 0, 0, 55, 627, 5],
  ["Visanthe Shiancoe", "TE", "MIN", 2008, 16, 143.6, 0, 0, 0, 0, 0, 42, 596, 7],
  ["Zach Miller", "TE", "OAK", 2008, 15, 139.8, 0, 0, 0, 0, 0, 56, 778, 1],
  ["Greg Olsen", "TE", "CHI", 2008, 15, 137.4, 0, 0, 0, 0, 0, 54, 574, 5],
  ["Bo Scaife", "TE", "TEN", 2008, 16, 126.2, 0, 0, 0, 0, 0, 58, 562, 2],
  ["Anthony Fasano", "TE", "MIA", 2008, 13, 121.4, 0, 0, 0, 0, 0, 34, 454, 7],
  ["Aaron Rodgers", "QB", "GB", 2009, 16, 343.8, 4434, 30, 7, 304, 5, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2009, 15, 293.4, 4388, 34, 11, 33, 2, 1, -4, 0],
  ["Brett Favre", "QB", "MIN", 2009, 16, 283.6, 4202, 33, 7, 7, 0, 1, -2, 0],
  ["Matt Schaub", "QB", "HOU", 2009, 16, 280.9, 4770, 29, 15, 61, 0, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2009, 16, 278.7, 4500, 33, 16, -13, 0, 0, 0, 0],
  ["Tony Romo", "QB", "DAL", 2009, 16, 273.8, 4483, 26, 9, 105, 1, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2009, 16, 270.3, 4398, 28, 13, 44, 1, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2009, 16, 269.2, 4254, 28, 9, 50, 1, 0, 0, 0],
  ["Ben Roethlisberger", "QB", "PIT", 2009, 15, 267, 4328, 26, 12, 79, 2, 0, 0, 0],
  ["Donovan McNabb", "QB", "PHI", 2009, 14, 235.3, 3553, 22, 10, 141, 2, 1, 1, 0],
  ["Eli Manning", "QB", "NYG", 2009, 16, 231.3, 4021, 27, 14, 65, 0, 0, 0, 0],
  ["Jay Cutler", "QB", "CHI", 2009, 16, 227.8, 3666, 27, 26, 172, 1, 0, 0, 0],
  ["David Garrard", "QB", "JAX", 2009, 16, 220.2, 3597, 15, 10, 323, 3, 0, 0, 0],
  ["Kurt Warner", "QB", "ARI", 2009, 15, 219.3, 3758, 27, 14, 10, 0, 0, 0, 0],
  ["Jason Campbell", "QB", "WAS", 2009, 16, 218.3, 3618, 20, 15, 236, 1, 0, 0, 0],
  ["Kyle Orton", "QB", "DEN", 2009, 16, 215.2, 3802, 21, 12, 71, 0, 0, 0, 0],
  ["Chris Johnson", "RB", "TEN", 2009, 16, 392.9, 0, 0, 0, 2006, 14, 50, 503, 2],
  ["Ray Rice", "RB", "BAL", 2009, 16, 326.1, 0, 0, 0, 1339, 7, 78, 702, 1],
  ["Maurice Jones-Drew", "RB", "JAX", 2009, 16, 323.5, 0, 0, 0, 1391, 15, 53, 374, 1],
  ["Adrian Peterson", "RB", "MIN", 2009, 16, 321.5, 0, 0, 0, 1389, 18, 43, 436, 0],
  ["Frank Gore", "RB", "SF", 2009, 14, 278.6, 0, 0, 0, 1120, 10, 52, 406, 3],
  ["Joseph Addai", "RB", "IND", 2009, 15, 248.3, 22, 1, 0, 828, 10, 51, 336, 3],
  ["Ricky Williams", "RB", "MIA", 2009, 16, 247.5, 0, 0, 1, 1121, 11, 35, 264, 2],
  ["Steven Jackson", "RB", "STL", 2009, 15, 243.8, 0, 0, 0, 1424, 4, 50, 314, 0],
  ["Thomas Jones", "RB", "NYJ", 2009, 16, 240, 0, 0, 0, 1402, 14, 10, 58, 0],
  ["Ryan Grant", "RB", "GB", 2009, 16, 234, 0, 0, 0, 1253, 11, 25, 197, 0],
  ["Jamaal Charles", "RB", "KC", 2009, 15, 233.7, 0, 0, 0, 1120, 7, 40, 297, 1],
  ["Matt Forte", "RB", "CHI", 2009, 16, 217, 0, 0, 0, 929, 4, 57, 471, 0],
  ["Fred Jackson", "RB", "BUF", 2009, 16, 214.4, 27, 1, 0, 1062, 2, 46, 371, 2],
  ["Jonathan Stewart", "RB", "CAR", 2009, 16, 207.2, 0, 0, 0, 1133, 10, 18, 139, 1],
  ["Tim Hightower", "RB", "ARI", 2009, 16, 205.6, 0, 0, 0, 598, 8, 63, 428, 0],
  ["DeAngelo Williams", "RB", "CAR", 2009, 13, 203.9, 0, 0, 0, 1117, 7, 29, 252, 0],
  ["Rashard Mendenhall", "RB", "PIT", 2009, 15, 203.9, 0, 0, 0, 1108, 7, 25, 261, 1],
  ["Pierre Thomas", "RB", "NO", 2009, 14, 194.5, 0, 0, 0, 793, 6, 39, 302, 2],
  ["Knowshon Moreno", "RB", "DEN", 2009, 16, 190, 0, 0, 0, 947, 7, 28, 213, 2],
  ["Cedric Benson", "RB", "CIN", 2009, 13, 189.2, 0, 0, 0, 1251, 6, 17, 111, 0],
  ["Kevin Smith", "RB", "DET", 2009, 13, 181.6, 0, 0, 0, 747, 4, 40, 409, 1],
  ["Jerome Harrison", "RB", "CLE", 2009, 14, 180.2, 0, 0, 0, 862, 5, 34, 220, 2],
  ["Marion Barber", "RB", "DAL", 2009, 15, 179.3, 0, 0, 0, 932, 7, 26, 221, 0],
  ["Darren Sproles", "RB", "SD", 2009, 16, 177, 0, 0, 0, 343, 3, 45, 497, 4],
  ["LaDainian Tomlinson", "RB", "SD", 2009, 14, 176.4, 0, 0, 0, 730, 12, 20, 154, 0],
  ["Cadillac Williams", "RB", "TB", 2009, 16, 174.5, 0, 0, 0, 816, 4, 29, 219, 3],
  ["Justin Forsett", "RB", "SEA", 2009, 16, 165.9, 0, 0, 0, 619, 4, 41, 350, 1],
  ["Reggie Bush", "RB", "NO", 2009, 14, 165.5, 0, 0, 0, 390, 5, 47, 335, 3],
  ["Steve Slaton", "RB", "HOU", 2009, 11, 161.4, 0, 0, 0, 437, 3, 44, 417, 4],
  ["Willis McGahee", "RB", "BAL", 2009, 15, 159.9, 0, 0, 0, 544, 12, 15, 85, 2],
  ["Andre Johnson", "WR", "HOU", 2009, 16, 314.9, 0, 0, 0, 10, 0, 101, 1569, 9],
  ["Randy Moss", "WR", "NE", 2009, 16, 287.4, 0, 0, 0, 0, 0, 83, 1264, 13],
  ["Wes Welker", "WR", "NE", 2009, 14, 285.4, 0, 0, 0, 36, 0, 123, 1348, 4],
  ["Reggie Wayne", "WR", "IND", 2009, 16, 284.4, 0, 0, 1, 0, 0, 100, 1264, 10],
  ["Larry Fitzgerald", "WR", "ARI", 2009, 16, 284.2, 0, 0, 0, 0, 0, 97, 1092, 13],
  ["Miles Austin", "WR", "DAL", 2009, 16, 278.8, 0, 0, 0, -2, 0, 81, 1320, 11],
  ["Brandon Marshall", "WR", "DEN", 2009, 15, 276.9, 0, 0, 0, 39, 0, 101, 1120, 10],
  ["Steve Smith", "WR", "NYG", 2009, 16, 271, 0, 0, 0, 0, 0, 107, 1220, 7],
  ["Roddy White", "WR", "ATL", 2009, 16, 266.5, 0, 0, 0, 2, 0, 85, 1153, 11],
  ["DeSean Jackson", "WR", "PHI", 2009, 15, 263.4, 0, 0, 0, 137, 1, 63, 1167, 9],
  ["Sidney Rice", "WR", "MIN", 2009, 16, 261.2, 0, 0, 0, 0, 0, 84, 1312, 8],
  ["Hines Ward", "WR", "PIT", 2009, 16, 245.7, 0, 0, 0, 0, 0, 95, 1167, 6],
  ["Vincent Jackson", "WR", "SD", 2009, 15, 239.8, 0, 0, 0, 11, 0, 68, 1167, 9],
  ["Santonio Holmes", "WR", "PIT", 2009, 16, 232.4, 0, 0, 1, 6, 0, 79, 1248, 5],
  ["Marques Colston", "WR", "NO", 2009, 16, 230, 0, 0, 0, 6, 0, 70, 1074, 9],
  ["Chad Johnson", "WR", "CIN", 2009, 16, 229.9, 0, 0, 0, 32, 0, 72, 1047, 9],
  ["Derrick Mason", "WR", "BAL", 2009, 16, 218, 0, 0, 0, 2, 0, 73, 1028, 7],
  ["Anquan Boldin", "WR", "ARI", 2009, 15, 214.6, 0, 0, 0, 7, 0, 85, 1029, 5],
  ["Donald Driver", "WR", "GB", 2009, 16, 211.4, 0, 0, 0, 13, 0, 70, 1061, 6],
  ["Steve Smith", "WR", "CAR", 2009, 15, 209.4, 0, 0, 0, 22, 0, 65, 982, 7],
  ["Greg Jennings", "WR", "GB", 2009, 16, 209, 0, 0, 0, 0, 0, 69, 1120, 4],
  ["Percy Harvin", "WR", "MIN", 2009, 15, 200.5, 0, 0, 0, 135, 0, 60, 790, 6],
  ["Calvin Johnson", "WR", "DET", 2009, 14, 198.7, 0, 0, 0, 73, 0, 67, 984, 5],
  ["Mike Sims-Walker", "WR", "JAX", 2009, 15, 189.9, 0, 0, 0, 0, 0, 63, 869, 7],
  ["T.J. Houshmandzadeh", "WR", "SEA", 2009, 16, 186.1, 0, 0, 0, 0, 0, 79, 911, 3],
  ["Terrell Owens", "WR", "BUF", 2009, 16, 179.3, 0, 0, 0, 54, 1, 55, 829, 5],
  ["Robert Meachem", "WR", "NO", 2009, 15, 177.4, 0, 0, 0, 82, 0, 45, 722, 9],
  ["Santana Moss", "WR", "WAS", 2009, 16, 177, 0, 0, 0, 8, 0, 70, 902, 3],
  ["Austin Collie", "WR", "IND", 2009, 16, 169.7, 0, 0, 0, 1, 0, 60, 676, 7],
  ["Mario Manningham", "WR", "NYG", 2009, 14, 167.2, 0, 0, 0, 0, 0, 57, 822, 5],
  ["Jerricho Cotchery", "WR", "NYJ", 2009, 14, 163.8, 0, 0, 0, 7, 1, 57, 821, 3],
  ["Hakeem Nicks", "WR", "NYG", 2009, 14, 162.8, 0, 0, 0, 8, 0, 47, 790, 6],
  ["Davone Bess", "WR", "MIA", 2009, 16, 160.9, 0, 0, 0, 11, 0, 76, 758, 2],
  ["Nate Burleson", "WR", "SEA", 2009, 13, 158.6, 0, 0, 0, 4, 0, 63, 812, 3],
  ["Jeremy Maclin", "WR", "PHI", 2009, 13, 154.5, 0, 0, 0, -7, 0, 55, 762, 4],
  ["Mike Wallace", "WR", "PIT", 2009, 16, 153.4, 0, 0, 0, 48, 0, 39, 756, 6],
  ["Dallas Clark", "TE", "IND", 2009, 16, 271.7, 0, 0, 0, 11, 0, 100, 1106, 10],
  ["Vernon Davis", "TE", "SF", 2009, 16, 252.5, 0, 0, 0, 0, 0, 78, 965, 13],
  ["Antonio Gates", "TE", "SD", 2009, 16, 242.7, 0, 0, 0, 0, 0, 79, 1157, 8],
  ["Brent Celek", "TE", "PHI", 2009, 16, 221.1, 0, 0, 0, 0, 0, 76, 971, 8],
  ["Jason Witten", "TE", "DAL", 2009, 16, 209, 0, 0, 0, 0, 0, 94, 1030, 2],
  ["Tony Gonzalez", "TE", "ATL", 2009, 16, 205.7, 0, 0, 0, 0, 0, 83, 867, 6],
  ["Kellen Winslow", "TE", "TB", 2009, 16, 196.4, 0, 0, 0, 7, 0, 77, 887, 5],
  ["Heath Miller", "TE", "PIT", 2009, 16, 190.9, 0, 0, 0, 0, 0, 76, 789, 6],
  ["Visanthe Shiancoe", "TE", "MIN", 2009, 16, 178.6, 0, 0, 0, 0, 0, 56, 566, 11],
  ["Greg Olsen", "TE", "CHI", 2009, 16, 169.2, 0, 0, 0, 0, 0, 60, 612, 8],
  ["Zach Miller", "TE", "OAK", 2009, 15, 164.5, 0, 0, 0, 0, 0, 66, 805, 3],
  ["Jermichael Finley", "TE", "GB", 2009, 12, 150.6, 0, 0, 0, 0, 0, 55, 676, 5],
  ["Mike Vick", "QB", "PHI", 2010, 12, 310.3, 3018, 21, 6, 676, 9, 0, 0, 0],
  ["Aaron Rodgers", "QB", "GB", 2010, 15, 304.5, 3922, 28, 11, 356, 4, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2010, 16, 299, 3900, 36, 4, 30, 1, 0, 0, 0],
  ["Peyton Manning", "QB", "IND", 2010, 16, 285.8, 4700, 33, 17, 18, 0, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2010, 16, 281.6, 4710, 30, 13, 52, 0, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2010, 16, 270.2, 4620, 33, 22, -3, 0, 1, 7, 0],
  ["Josh Freeman", "QB", "TB", 2010, 16, 258.4, 3451, 25, 6, 364, 0, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2010, 16, 252.4, 3705, 28, 9, 122, 0, 0, 0, 0],
  ["Matt Schaub", "QB", "HOU", 2010, 16, 245.6, 4370, 24, 12, 28, 0, 0, 0, 0],
  ["Joe Flacco", "QB", "BAL", 2010, 16, 231.3, 3622, 25, 10, 84, 1, 0, 0, 0],
  ["Eli Manning", "QB", "NYG", 2010, 16, 231.1, 4002, 31, 25, 70, 0, 0, 0, 0],
  ["Matt Cassel", "QB", "KC", 2010, 15, 229.1, 3116, 27, 7, 125, 0, 0, 0, 0],
  ["Carson Palmer", "QB", "CIN", 2010, 16, 223.8, 3970, 26, 20, 50, 0, 0, 0, 0],
  ["David Garrard", "QB", "JAX", 2010, 14, 220.4, 2734, 23, 15, 270, 5, 0, 0, 0],
  ["Jay Cutler", "QB", "CHI", 2010, 15, 210.2, 3274, 23, 16, 232, 1, 0, 0, 0],
  ["Kyle Orton", "QB", "DEN", 2010, 13, 209.9, 3652, 20, 9, 98, 0, 0, 0, 0],
  ["Arian Foster", "RB", "HOU", 2010, 16, 391.8, 0, 0, 0, 1614, 16, 66, 604, 2],
  ["LeSean McCoy", "RB", "PHI", 2010, 15, 297.2, 0, 0, 0, 1080, 7, 78, 592, 2],
  ["Peyton Hillis", "RB", "CLE", 2010, 16, 294.9, 13, 0, 0, 1177, 11, 61, 477, 2],
  ["Jamaal Charles", "RB", "KC", 2010, 16, 282.5, 0, 0, 0, 1467, 5, 45, 468, 3],
  ["Ray Rice", "RB", "BAL", 2010, 16, 276.6, 0, 0, 0, 1220, 5, 63, 556, 1],
  ["Adrian Peterson", "RB", "MIN", 2010, 15, 275.9, 0, 0, 0, 1298, 12, 36, 341, 1],
  ["Chris Johnson", "RB", "TEN", 2010, 16, 272.9, 0, 0, 0, 1364, 11, 44, 245, 1],
  ["Darren McFadden", "RB", "OAK", 2010, 13, 267.4, 0, 0, 0, 1157, 7, 47, 507, 3],
  ["Matt Forte", "RB", "CHI", 2010, 16, 264.6, 0, 0, 0, 1069, 6, 51, 547, 3],
  ["Steven Jackson", "RB", "STL", 2010, 16, 242.4, 0, 0, 0, 1241, 6, 46, 383, 0],
  ["Rashard Mendenhall", "RB", "PIT", 2010, 16, 241, 0, 0, 0, 1273, 13, 23, 167, 0],
  ["Ahmad Bradshaw", "RB", "NYG", 2010, 16, 239.9, 0, 0, 0, 1235, 8, 47, 314, 0],
  ["Maurice Jones-Drew", "RB", "JAX", 2010, 14, 234.1, 0, 0, 1, 1324, 5, 34, 317, 2],
  ["Michael Turner", "RB", "ATL", 2010, 16, 225.6, 0, 0, 0, 1371, 12, 12, 85, 0],
  ["LaDainian Tomlinson", "RB", "NYJ", 2010, 15, 216.2, 0, 0, 0, 914, 6, 52, 368, 0],
  ["Frank Gore", "RB", "SF", 2010, 11, 202.5, 0, 0, 0, 853, 3, 46, 452, 2],
  ["BenJarvus Green-Ellis", "RB", "NE", 2010, 16, 199.3, 0, 0, 0, 1008, 13, 12, 85, 0],
  ["Jahvid Best", "RB", "DET", 2010, 15, 197, 0, 0, 0, 563, 4, 58, 487, 2],
  ["Cedric Benson", "RB", "CIN", 2010, 16, 196.9, 0, 0, 0, 1111, 7, 28, 178, 1],
  ["Knowshon Moreno", "RB", "DEN", 2010, 13, 196.1, 0, 0, 0, 779, 5, 37, 372, 3],
  ["Fred Jackson", "RB", "BUF", 2010, 16, 183.2, 0, 0, 0, 927, 5, 31, 215, 2],
  ["Felix Jones", "RB", "DAL", 2010, 16, 183, 0, 0, 0, 800, 1, 48, 450, 1],
  ["Brandon Jackson", "RB", "GB", 2010, 16, 171.5, 0, 0, 0, 703, 3, 43, 342, 1],
  ["Danny Woodhead", "RB", "NE", 2010, 14, 160.6, 0, 0, 0, 547, 5, 34, 379, 1],
  ["Ronnie Brown", "RB", "MIA", 2010, 16, 156.6, 0, 0, 0, 734, 5, 33, 242, 0],
  ["Michael Bush", "RB", "OAK", 2010, 14, 150.9, 0, 0, 0, 655, 8, 18, 194, 0],
  ["Thomas Jones", "RB", "KC", 2010, 16, 149.8, 0, 0, 0, 896, 6, 14, 122, 0],
  ["Darren Sproles", "RB", "SD", 2010, 16, 148, 0, 0, 0, 270, 0, 59, 520, 2],
  ["Brandon Jacobs", "RB", "NYG", 2010, 16, 145.2, 0, 0, 0, 823, 9, 7, 59, 0],
  ["Cadillac Williams", "RB", "TB", 2010, 16, 141.2, 0, 0, 0, 437, 2, 46, 355, 1],
  ["Roddy White", "WR", "ATL", 2010, 16, 316.2, 0, 0, 0, 3, 0, 115, 1389, 10],
  ["Brandon Lloyd", "WR", "DEN", 2010, 16, 286, 0, 0, 0, -18, 0, 77, 1448, 11],
  ["Reggie Wayne", "WR", "IND", 2010, 16, 280.5, 0, 0, 0, 0, 0, 111, 1355, 6],
  ["Dwayne Bowe", "WR", "KC", 2010, 16, 278.6, 0, 0, 0, 4, 0, 72, 1162, 15],
  ["Greg Jennings", "WR", "GB", 2010, 16, 274.4, 0, 0, 0, -1, 0, 76, 1265, 12],
  ["Calvin Johnson", "WR", "DET", 2010, 15, 266.2, 0, 0, 0, 32, 0, 77, 1120, 12],
  ["Andre Johnson", "WR", "HOU", 2010, 13, 256.6, 0, 0, 0, 10, 0, 86, 1216, 8],
  ["Hakeem Nicks", "WR", "NYG", 2010, 13, 250.2, 0, 0, 0, 0, 0, 79, 1052, 11],
  ["Mike Wallace", "WR", "PIT", 2010, 16, 249.6, 0, 0, 0, 39, 0, 60, 1257, 10],
  ["Steve Johnson", "WR", "BUF", 2010, 16, 247.3, 0, 0, 0, 0, 0, 82, 1073, 10],
  ["Larry Fitzgerald", "WR", "ARI", 2010, 16, 241.7, 0, 0, 0, 0, 0, 90, 1137, 6],
  ["Santana Moss", "WR", "WAS", 2010, 16, 235.9, 0, 0, 0, -6, 0, 93, 1115, 6],
  ["Miles Austin", "WR", "DAL", 2010, 16, 228.4, 0, 0, 0, 93, 1, 69, 1041, 7],
  ["Marques Colston", "WR", "NO", 2010, 15, 228.4, 0, 0, 0, 1, 0, 84, 1023, 7],
  ["Jeremy Maclin", "WR", "PHI", 2010, 16, 228, 0, 0, 0, 36, 0, 70, 964, 10],
  ["Terrell Owens", "WR", "CIN", 2010, 13, 224.3, 0, 0, 0, 0, 0, 72, 983, 9],
  ["Mike Williams", "WR", "TB", 2010, 16, 223.4, 0, 0, 0, 0, 0, 65, 964, 11],
  ["Wes Welker", "WR", "NE", 2010, 15, 212.8, 0, 0, 0, 0, 0, 86, 848, 7],
  ["Percy Harvin", "WR", "MIN", 2010, 14, 212.5, 0, 0, 0, 107, 1, 71, 868, 5],
  ["DeSean Jackson", "WR", "PHI", 2010, 14, 209, 0, 0, 0, 104, 1, 47, 1056, 6],
  ["Mario Manningham", "WR", "NYG", 2010, 16, 206.6, 0, 0, 0, 2, 0, 60, 944, 9],
  ["Brandon Marshall", "WR", "MIA", 2010, 14, 203.7, 0, 0, 0, 3, 0, 86, 1014, 3],
  ["Davone Bess", "WR", "MIA", 2010, 16, 191.7, 0, 0, 0, 0, 0, 80, 817, 5],
  ["Mike Thomas", "WR", "JAX", 2010, 16, 189.4, 0, 0, 0, 114, 0, 66, 820, 4],
  ["Lance Moore", "WR", "NO", 2010, 15, 188.3, 0, 0, 0, 0, 0, 66, 763, 8],
  ["Anquan Boldin", "WR", "BAL", 2010, 16, 187.7, -6, 0, 0, 2, 0, 64, 837, 7],
  ["Braylon Edwards", "WR", "NYJ", 2010, 16, 185.8, 0, 0, 0, 4, 0, 53, 904, 7],
  ["Pierre Garcon", "WR", "IND", 2010, 14, 184.2, 0, 0, 0, 6, 0, 68, 816, 6],
  ["Derrick Mason", "WR", "BAL", 2010, 16, 183.2, 0, 0, 0, 0, 0, 61, 802, 7],
  ["Deion Branch", "WR", "NE", 2010, 15, 178.8, 0, 0, 0, 0, 0, 61, 818, 6],
  ["Danny Amendola", "WR", "STL", 2010, 16, 178, 0, 0, 0, 81, 0, 85, 689, 3],
  ["Johnny Knox", "WR", "CHI", 2010, 16, 175.2, 0, 0, 0, 2, 0, 51, 960, 5],
  ["Chad Johnson", "WR", "CIN", 2010, 14, 174.1, 0, 0, 0, 0, 0, 67, 831, 4],
  ["Kenny Britt", "WR", "TEN", 2010, 11, 173.5, 0, 0, 0, 0, 0, 42, 775, 9],
  ["Austin Collie", "WR", "IND", 2010, 9, 166.7, 0, 0, 0, 0, 0, 57, 617, 8],
  ["Michael Crabtree", "WR", "SF", 2010, 16, 165.1, 0, 0, 0, 0, 0, 55, 741, 6],
  ["Jason Witten", "TE", "DAL", 2010, 16, 248.2, 0, 0, 0, 0, 0, 94, 1002, 9],
  ["Vernon Davis", "TE", "SF", 2010, 16, 191.4, 0, 0, 0, 0, 0, 56, 914, 7],
  ["Antonio Gates", "TE", "SD", 2010, 10, 188.2, 0, 0, 0, 0, 0, 50, 782, 10],
  ["Marcedes Lewis", "TE", "JAX", 2010, 16, 184, 0, 0, 0, 0, 0, 58, 700, 10],
  ["Chris Cooley", "TE", "WAS", 2010, 16, 179.9, 0, 0, 0, 0, 0, 77, 849, 3],
  ["Tony Gonzalez", "TE", "ATL", 2010, 16, 171.6, 0, 0, 0, 0, 0, 70, 656, 6],
  ["Kellen Winslow", "TE", "TB", 2010, 16, 169, 0, 0, 0, 0, 0, 66, 730, 5],
  ["Brandon Pettigrew", "TE", "DET", 2010, 16, 167.2, 0, 0, 0, 0, 0, 71, 722, 4],
  ["Benjamin Watson", "TE", "CLE", 2010, 16, 162.2, 0, 0, 0, -1, 0, 68, 763, 3],
  ["Zach Miller", "TE", "OAK", 2010, 15, 158.5, 0, 0, 0, 0, 0, 60, 685, 5],
  ["Rob Gronkowski", "TE", "NE", 2010, 16, 154.6, 0, 0, 0, 0, 0, 42, 546, 10],
  ["Jacob Tamme", "TE", "IND", 2010, 10, 154.1, 0, 0, 0, 0, 0, 67, 631, 4],
  ["Aaron Rodgers", "QB", "GB", 2011, 15, 397.1, 4636, 45, 6, 257, 3, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2011, 16, 394, 5535, 46, 14, 86, 1, 0, 0, 0],
  ["Cam Newton", "QB", "CAR", 2011, 16, 370.3, 4051, 21, 17, 706, 14, 1, 27, 0],
  ["Tom Brady", "QB", "NE", 2011, 16, 366.3, 5235, 39, 12, 109, 3, 0, 0, 0],
  ["Matthew Stafford", "QB", "DET", 2011, 16, 345.8, 5100, 41, 16, 78, 0, 0, 0, 0],
  ["Eli Manning", "QB", "NYG", 2011, 16, 280.8, 4933, 29, 16, 15, 1, 0, 0, 0],
  ["Tony Romo", "QB", "DAL", 2011, 16, 276, 4184, 31, 10, 46, 1, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2011, 16, 273.5, 4177, 29, 12, 84, 2, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2011, 16, 254.6, 4624, 27, 20, 36, 1, 0, 0, 0],
  ["Mark Sanchez", "QB", "NYJ", 2011, 16, 237.3, 3474, 26, 18, 103, 6, 0, 0, 0],
  ["Mike Vick", "QB", "PHI", 2011, 13, 233, 3303, 18, 14, 589, 1, 0, 0, 0],
  ["Ryan Fitzpatrick", "QB", "BUF", 2011, 16, 222.8, 3832, 24, 23, 215, 0, 0, 0, 0],
  ["Ben Roethlisberger", "QB", "PIT", 2011, 15, 216.1, 4077, 21, 14, 70, 0, 0, 0, 0],
  ["Alex Smith", "QB", "SF", 2011, 16, 211.7, 3144, 17, 5, 179, 2, 0, 0, 0],
  ["Andy Dalton", "QB", "CIN", 2011, 16, 207.1, 3398, 20, 13, 152, 1, 0, 0, 0],
  ["Josh Freeman", "QB", "TB", 2011, 15, 205.5, 3592, 16, 22, 238, 4, 0, 0, 0],
  ["Ray Rice", "RB", "BAL", 2011, 16, 372.8, 1, 1, 0, 1364, 12, 76, 704, 3],
  ["LeSean McCoy", "RB", "PHI", 2011, 15, 328.4, 0, 0, 0, 1309, 17, 48, 315, 3],
  ["Maurice Jones-Drew", "RB", "JAX", 2011, 16, 305, 0, 0, 0, 1606, 8, 43, 374, 3],
  ["Arian Foster", "RB", "HOU", 2011, 13, 303.1, 0, 0, 0, 1224, 10, 53, 617, 2],
  ["Darren Sproles", "RB", "NO", 2011, 16, 277.4, 0, 0, 0, 604, 2, 86, 710, 7],
  ["Marshawn Lynch", "RB", "SEA", 2011, 15, 243.6, 0, 0, 0, 1204, 12, 28, 212, 1],
  ["Ryan Mathews", "RB", "SD", 2011, 14, 236.6, 0, 0, 0, 1091, 6, 50, 455, 0],
  ["Michael Turner", "RB", "ATL", 2011, 16, 229.8, 0, 0, 0, 1340, 11, 17, 168, 0],
  ["Chris Johnson", "RB", "TEN", 2011, 16, 225.5, 0, 0, 0, 1047, 4, 57, 418, 0],
  ["Steven Jackson", "RB", "STL", 2011, 15, 223.8, 0, 0, 0, 1145, 5, 42, 333, 1],
  ["Michael Bush", "RB", "OAK", 2011, 16, 222.5, 0, 0, 0, 977, 7, 37, 418, 1],
  ["Matt Forte", "RB", "CHI", 2011, 12, 220.7, 0, 0, 0, 997, 3, 52, 490, 1],
  ["Reggie Bush", "RB", "MIA", 2011, 15, 219.2, 0, 0, 0, 1086, 6, 43, 296, 1],
  ["Fred Jackson", "RB", "BUF", 2011, 10, 208.6, 0, 0, 0, 934, 6, 39, 442, 0],
  ["Adrian Peterson", "RB", "MIN", 2011, 12, 206.9, 0, 0, 0, 970, 12, 18, 139, 1],
  ["Jonathan Stewart", "RB", "CAR", 2011, 16, 194.4, 0, 0, 0, 761, 4, 47, 413, 1],
  ["Frank Gore", "RB", "SF", 2011, 16, 193.5, 0, 0, 0, 1211, 8, 17, 114, 0],
  ["Ahmad Bradshaw", "RB", "NYG", 2011, 12, 192.6, 0, 0, 0, 659, 9, 34, 267, 2],
  ["Shonn Greene", "RB", "NYJ", 2011, 16, 192.5, 0, 0, 0, 1054, 6, 30, 211, 0],
  ["Pierre Thomas", "RB", "NO", 2011, 16, 182.7, 0, 0, 0, 562, 5, 50, 425, 1],
  ["Rashard Mendenhall", "RB", "PIT", 2011, 15, 178.2, 0, 0, 0, 928, 9, 18, 154, 0],
  ["Beanie Wells", "RB", "ARI", 2011, 14, 175.9, 0, 0, 0, 1047, 10, 10, 52, 0],
  ["Roy Helu", "RB", "WAS", 2011, 15, 164.9, 0, 0, 0, 640, 2, 49, 379, 1],
  ["Willis McGahee", "RB", "DEN", 2011, 15, 163, 0, 0, 0, 1199, 4, 12, 51, 1],
  ["Cedric Benson", "RB", "CIN", 2011, 15, 161.9, 0, 0, 0, 1067, 6, 15, 82, 0],
  ["C.J. Spiller", "RB", "BUF", 2011, 16, 158, 0, 0, 0, 561, 4, 39, 269, 2],
  ["BenJarvus Green-Ellis", "RB", "NE", 2011, 16, 157.6, 0, 0, 0, 667, 11, 9, 159, 0],
  ["DeAngelo Williams", "RB", "CAR", 2011, 16, 155.1, 0, 0, 0, 836, 7, 16, 135, 0],
  ["DeMarco Murray", "RB", "DAL", 2011, 13, 146, 0, 0, 0, 897, 2, 26, 183, 0],
  ["Ben Tate", "RB", "HOU", 2011, 15, 135, 0, 0, 0, 942, 4, 13, 98, 0],
  ["Calvin Johnson", "WR", "DET", 2011, 16, 360.7, 0, 0, 0, 11, 0, 97, 1686, 16],
  ["Wes Welker", "WR", "NE", 2011, 16, 335.9, 0, 0, 0, 30, 0, 122, 1569, 9],
  ["Victor Cruz", "WR", "NYG", 2011, 16, 287.9, 0, 0, 0, 3, 0, 82, 1536, 9],
  ["Jordy Nelson", "WR", "GB", 2011, 16, 284.3, 0, 0, 0, 0, 0, 68, 1263, 15],
  ["Roddy White", "WR", "ATL", 2011, 16, 277.6, 0, 0, 0, 0, 0, 100, 1296, 8],
  ["Larry Fitzgerald", "WR", "ARI", 2011, 16, 269.1, 0, 0, 0, 0, 0, 80, 1411, 8],
  ["Percy Harvin", "WR", "MIN", 2011, 16, 268.2, 0, 0, 0, 345, 2, 87, 967, 6],
  ["Steve Smith", "WR", "CAR", 2011, 16, 264, 0, 0, 0, 56, 0, 79, 1394, 7],
  ["Marques Colston", "WR", "NO", 2011, 14, 244.4, 0, 0, 0, 0, 0, 82, 1164, 8],
  ["Mike Wallace", "WR", "PIT", 2011, 16, 243, 0, 0, 0, 57, 0, 72, 1193, 8],
  ["Brandon Marshall", "WR", "MIA", 2011, 16, 237.7, 0, 0, 0, 13, 0, 81, 1214, 6],
  ["Hakeem Nicks", "WR", "NYG", 2011, 15, 237.2, 0, 0, 0, 0, 0, 76, 1192, 7],
  ["Vincent Jackson", "WR", "SD", 2011, 16, 229.7, 0, 0, 0, 51, 0, 60, 1106, 9],
  ["Dwayne Bowe", "WR", "KC", 2011, 16, 228.1, 0, 0, 0, 12, 0, 81, 1159, 5],
  ["Nate Washington", "WR", "TEN", 2011, 16, 224.8, 0, 0, 0, 5, 1, 74, 1023, 7],
  ["Steve Johnson", "WR", "BUF", 2011, 16, 218.4, 0, 0, 0, 0, 0, 76, 1004, 7],
  ["A.J. Green", "WR", "CIN", 2011, 15, 218, 0, 0, 0, 53, 0, 65, 1057, 7],
  ["Greg Jennings", "WR", "GB", 2011, 13, 215.9, 0, 0, 0, 0, 0, 67, 949, 9],
  ["Dez Bryant", "WR", "DAL", 2011, 15, 208.3, 0, 0, 0, 5, 0, 63, 928, 9],
  ["Laurent Robinson", "WR", "DAL", 2011, 14, 205.8, 0, 0, 0, 0, 0, 54, 858, 11],
  ["Antonio Brown", "WR", "PIT", 2011, 16, 201.9, 0, 0, 0, 41, 0, 69, 1108, 2],
  ["Julio Jones", "WR", "ATL", 2011, 12, 201.5, 0, 0, 0, 56, 0, 54, 959, 8],
  ["Pierre Garcon", "WR", "IND", 2011, 16, 199.5, 0, 0, 0, 28, 0, 70, 947, 6],
  ["Brandon Lloyd", "WR", "STL", 2011, 15, 196.6, 0, 0, 0, 0, 0, 70, 966, 5],
  ["Reggie Wayne", "WR", "IND", 2011, 16, 195, 0, 0, 0, 0, 0, 75, 960, 4],
  ["Jabar Gaffney", "WR", "WAS", 2011, 16, 190.7, 0, 0, 0, 0, 0, 68, 947, 5],
  ["Michael Crabtree", "WR", "SF", 2011, 15, 186, 0, 0, 0, 6, 0, 72, 874, 4],
  ["Darrius Heyward-Bey", "WR", "OAK", 2011, 14, 183.5, 0, 0, 0, 0, 0, 64, 975, 4],
  ["DeSean Jackson", "WR", "PHI", 2011, 15, 182.2, 0, 0, 0, 41, 0, 58, 961, 4],
  ["Torrey Smith", "WR", "BAL", 2011, 15, 180, 0, 0, 0, 39, 0, 50, 841, 7],
  ["Jeremy Maclin", "WR", "PHI", 2011, 13, 177, 0, 0, 0, 1, 0, 63, 859, 5],
  ["Nate Burleson", "WR", "DET", 2011, 16, 175.6, 0, 0, 0, 85, 0, 74, 771, 3],
  ["Lance Moore", "WR", "NO", 2011, 14, 166.7, 0, 0, 0, 0, 0, 52, 627, 8],
  ["Santonio Holmes", "WR", "NYJ", 2011, 16, 165.1, 0, 0, 0, 27, 0, 51, 654, 8],
  ["Anquan Boldin", "WR", "BAL", 2011, 14, 163.7, 0, 0, 0, 0, 0, 57, 887, 3],
  ["Malcom Floyd", "WR", "SD", 2011, 12, 158.6, 0, 0, 0, 0, 0, 43, 856, 5],
  ["Rob Gronkowski", "TE", "NE", 2011, 16, 330.9, 0, 0, 0, 2, 1, 90, 1327, 17],
  ["Jimmy Graham", "TE", "NO", 2011, 16, 294, 0, 0, 0, 0, 0, 99, 1310, 11],
  ["Aaron Hernandez", "TE", "NE", 2011, 14, 214.5, 0, 0, 0, 45, 0, 79, 910, 7],
  ["Tony Gonzalez", "TE", "ATL", 2011, 16, 209.5, 0, 0, 0, 0, 0, 80, 875, 7],
  ["Jason Witten", "TE", "DAL", 2011, 16, 203.2, 0, 0, 0, 0, 0, 79, 942, 5],
  ["Tim Tebow", "TE", "DEN", 2011, 13, 199.2, 1729, 12, 6, 660, 6, 0, 0, 0],
  ["Brandon Pettigrew", "TE", "DET", 2011, 16, 190.7, 0, 0, 0, 0, 0, 83, 777, 5],
  ["Antonio Gates", "TE", "SD", 2011, 13, 183.8, 0, 0, 0, 0, 0, 64, 778, 7],
  ["Vernon Davis", "TE", "SF", 2011, 16, 179.7, 0, 0, 0, -5, 0, 67, 792, 6],
  ["Jermichael Finley", "TE", "GB", 2011, 16, 179.7, 0, 0, 0, 0, 0, 55, 767, 8],
  ["Dustin Keller", "TE", "NYJ", 2011, 16, 174.5, 0, 0, 0, 0, 0, 65, 815, 5],
  ["Brent Celek", "TE", "PHI", 2011, 16, 173.1, 0, 0, 0, 0, 0, 62, 811, 5],
  ["Drew Brees", "QB", "NO", 2012, 16, 345.6, 5177, 43, 19, 5, 1, 0, 0, 0],
  ["Aaron Rodgers", "QB", "GB", 2012, 16, 344.6, 4295, 39, 8, 259, 2, 1, -1, 0],
  ["Tom Brady", "QB", "NE", 2012, 16, 344.3, 4827, 35, 8, 32, 4, 0, 0, 0],
  ["Cam Newton", "QB", "CAR", 2012, 16, 322.9, 3869, 19, 12, 741, 8, 0, 0, 0],
  ["Robert Griffin", "QB", "WAS", 2012, 15, 317.5, 3200, 20, 5, 815, 7, 0, 0, 0],
  ["Peyton Manning", "QB", "DEN", 2012, 16, 311, 4659, 37, 11, 6, 0, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2012, 16, 304.9, 4719, 32, 14, 141, 1, 0, 0, 0],
  ["Tony Romo", "QB", "DAL", 2012, 16, 279.9, 4903, 28, 19, 49, 1, 1, -1, 0],
  ["Matthew Stafford", "QB", "DET", 2012, 16, 276.6, 4967, 20, 17, 126, 4, 1, 3, 0],
  ["Andrew Luck", "QB", "IND", 2012, 16, 276.5, 4374, 23, 18, 255, 5, 0, 0, 0],
  ["Russell Wilson", "QB", "SEA", 2012, 16, 275.6, 3118, 26, 10, 489, 4, 0, 0, 0],
  ["Andy Dalton", "QB", "CIN", 2012, 16, 250.8, 3669, 27, 16, 120, 4, 0, 0, 0],
  ["Josh Freeman", "QB", "TB", 2012, 16, 248.5, 4065, 27, 17, 139, 0, 0, 0, 0],
  ["Joe Flacco", "QB", "BAL", 2012, 16, 234.9, 3817, 22, 10, 22, 3, 0, 0, 0],
  ["Eli Manning", "QB", "NYG", 2012, 16, 232.9, 3948, 26, 15, 30, 0, 0, 0, 0],
  ["Sam Bradford", "QB", "STL", 2012, 16, 230.5, 3702, 21, 13, 124, 1, 0, 0, 0],
  ["Adrian Peterson", "RB", "MIN", 2012, 16, 347.4, 0, 0, 0, 2097, 12, 40, 217, 1],
  ["Doug Martin", "RB", "TB", 2012, 16, 311.6, 0, 0, 0, 1454, 11, 49, 472, 1],
  ["Arian Foster", "RB", "HOU", 2012, 16, 302.1, 0, 0, 0, 1424, 15, 40, 217, 2],
  ["Ray Rice", "RB", "BAL", 2012, 16, 283.1, 0, 0, 0, 1143, 9, 61, 478, 1],
  ["Marshawn Lynch", "RB", "SEA", 2012, 16, 269.6, 0, 0, 0, 1590, 11, 23, 196, 1],
  ["C.J. Spiller", "RB", "BUF", 2012, 16, 255.3, 0, 0, 0, 1244, 6, 43, 459, 2],
  ["Alfred Morris", "RB", "WAS", 2012, 16, 252, 0, 0, 0, 1613, 13, 11, 77, 0],
  ["Jamaal Charles", "RB", "KC", 2012, 16, 239.5, 0, 0, 0, 1509, 5, 35, 236, 1],
  ["Frank Gore", "RB", "SF", 2012, 16, 224.8, 0, 0, 0, 1214, 8, 28, 234, 1],
  ["Matt Forte", "RB", "CHI", 2012, 15, 221.4, 0, 0, 0, 1094, 5, 44, 340, 1],
  ["Darren Sproles", "RB", "NO", 2012, 13, 216.1, 0, 0, 0, 244, 1, 75, 667, 7],
  ["Chris Johnson", "RB", "TEN", 2012, 16, 211.5, 0, 0, 0, 1243, 6, 36, 232, 0],
  ["Reggie Bush", "RB", "MIA", 2012, 16, 206.8, 0, 0, 0, 986, 6, 35, 292, 2],
  ["Stevan Ridley", "RB", "NE", 2012, 16, 205.4, 0, 0, 0, 1263, 12, 6, 51, 0],
  ["Steven Jackson", "RB", "STL", 2012, 16, 200.6, 0, 0, 0, 1045, 4, 38, 321, 0],
  ["LeSean McCoy", "RB", "PHI", 2012, 12, 199.3, 0, 0, 0, 840, 2, 54, 373, 3],
  ["Shonn Greene", "RB", "NYJ", 2012, 16, 186.4, 0, 0, 0, 1063, 8, 19, 151, 0],
  ["Mikel Leshoure", "RB", "DET", 2012, 14, 183.2, 0, 0, 0, 798, 9, 34, 214, 0],
  ["Ahmad Bradshaw", "RB", "NYG", 2012, 14, 179, 0, 0, 0, 1015, 6, 23, 245, 0],
  ["Michael Turner", "RB", "ATL", 2012, 16, 175.8, 0, 0, 0, 800, 10, 19, 128, 1],
  ["BenJarvus Green-Ellis", "RB", "CIN", 2012, 15, 173.8, 0, 0, 0, 1094, 6, 22, 104, 0],
  ["Joique Bell", "RB", "DET", 2012, 16, 157.9, 0, 0, 0, 414, 3, 52, 485, 0],
  ["Danny Woodhead", "RB", "NE", 2012, 15, 156.7, 0, 0, 0, 301, 4, 40, 446, 3],
  ["Darren McFadden", "RB", "OAK", 2012, 12, 152.5, 0, 0, 0, 707, 2, 42, 258, 1],
  ["DeMarco Murray", "RB", "DAL", 2012, 10, 146.4, 0, 0, 0, 663, 4, 35, 251, 0],
  ["DeAngelo Williams", "RB", "CAR", 2012, 16, 143.4, 0, 0, 0, 737, 5, 13, 187, 2],
  ["Jacquizz Rodgers", "RB", "ATL", 2012, 16, 141.4, 0, 0, 0, 362, 1, 53, 402, 1],
  ["Willis McGahee", "RB", "DEN", 2012, 10, 139.2, 0, 0, 0, 731, 4, 26, 221, 0],
  ["Ryan Mathews", "RB", "SD", 2012, 12, 136.9, 0, 0, 0, 707, 1, 39, 252, 0],
  ["Pierre Thomas", "RB", "NO", 2012, 15, 133.7, 0, 0, 0, 473, 1, 39, 354, 1],
  ["Calvin Johnson", "WR", "DET", 2012, 16, 342.4, 0, 0, 0, 0, 0, 122, 1964, 5],
  ["Brandon Marshall", "WR", "CHI", 2012, 16, 334.6, 0, 0, 0, -2, 0, 118, 1508, 11],
  ["A.J. Green", "WR", "CIN", 2012, 16, 299.8, 0, 0, 0, 38, 0, 97, 1350, 11],
  ["Dez Bryant", "WR", "DAL", 2012, 16, 298.6, 0, 0, 0, -5, 0, 90, 1371, 12],
  ["Andre Johnson", "WR", "HOU", 2012, 16, 295.8, 0, 0, 0, 0, 0, 112, 1598, 4],
  ["Demaryius Thomas", "WR", "DEN", 2012, 16, 291.4, 0, 0, 0, 0, 0, 94, 1434, 10],
  ["Wes Welker", "WR", "NE", 2012, 16, 289.4, 0, 0, 0, 20, 0, 118, 1354, 6],
  ["Eric Decker", "WR", "DEN", 2012, 16, 269.4, 0, 0, 0, 0, 0, 85, 1064, 13],
  ["Roddy White", "WR", "ATL", 2012, 16, 269.1, 0, 0, 0, 0, 0, 92, 1351, 7],
  ["Reggie Wayne", "WR", "IND", 2012, 16, 269, 0, 0, 0, -5, 0, 106, 1355, 5],
  ["Julio Jones", "WR", "ATL", 2012, 16, 261.8, 0, 0, 0, 30, 0, 79, 1198, 10],
  ["Vincent Jackson", "WR", "TB", 2012, 16, 260.4, 0, 0, 0, 0, 0, 72, 1384, 8],
  ["Marques Colston", "WR", "NO", 2012, 16, 256.4, 0, 0, 0, 0, 0, 83, 1154, 10],
  ["Victor Cruz", "WR", "NYG", 2012, 16, 255.2, 0, 0, 0, 0, 0, 86, 1092, 10],
  ["Michael Crabtree", "WR", "SF", 2012, 16, 250.3, 0, 0, 0, 8, 0, 85, 1105, 9],
  ["Randall Cobb", "WR", "GB", 2012, 15, 242.6, 0, 0, 0, 132, 0, 80, 954, 8],
  ["James Jones", "WR", "GB", 2012, 15, 226.4, 0, 0, 0, 0, 0, 64, 784, 14],
  ["Mike Williams", "WR", "TB", 2012, 16, 217.7, 28, 0, 0, 0, 0, 63, 996, 9],
  ["Steve Johnson", "WR", "BUF", 2012, 16, 217.6, 0, 0, 0, 0, 0, 79, 1046, 6],
  ["Steve Smith", "WR", "CAR", 2012, 16, 215.1, 0, 0, 0, 27, 0, 73, 1174, 4],
  ["Lance Moore", "WR", "NO", 2012, 15, 205.1, 0, 0, 0, 0, 0, 65, 1041, 6],
  ["Jeremy Maclin", "WR", "PHI", 2012, 15, 194.7, 0, 0, 0, 0, 0, 69, 857, 7],
  ["Miles Austin", "WR", "DAL", 2012, 16, 194.3, 0, 0, 0, 0, 0, 66, 943, 6],
  ["Mike Wallace", "WR", "PIT", 2012, 15, 194.3, 0, 0, 0, 7, 0, 64, 836, 8],
  ["Cecil Shorts", "WR", "JAX", 2012, 14, 192.5, 0, 0, 0, -4, 0, 55, 979, 7],
  ["Brandon Lloyd", "WR", "NE", 2012, 16, 189.1, 0, 0, 0, 0, 0, 74, 911, 4],
  ["T.Y. Hilton", "WR", "IND", 2012, 15, 187, 0, 0, 0, 29, 0, 50, 861, 7],
  ["Brian Hartline", "WR", "MIA", 2012, 15, 186.3, 0, 0, 0, 0, 0, 74, 1083, 1],
  ["Justin Blackmon", "WR", "JAX", 2012, 16, 184.8, 0, 0, 0, 23, 0, 64, 865, 5],
  ["Anquan Boldin", "WR", "BAL", 2012, 15, 183.4, 0, 0, 0, 3, 0, 65, 921, 4],
  ["Torrey Smith", "WR", "BAL", 2012, 16, 183.4, 0, 0, 0, 9, 0, 49, 855, 8],
  ["Larry Fitzgerald", "WR", "ARI", 2012, 16, 174.8, 0, 0, 0, 0, 0, 71, 798, 4],
  ["Antonio Brown", "WR", "PIT", 2012, 13, 173.1, 0, 0, 1, 24, 0, 66, 787, 5],
  ["Andre Roberts", "WR", "ARI", 2012, 15, 172.8, 0, 0, 0, 29, 0, 64, 759, 5],
  ["Sidney Rice", "WR", "SEA", 2012, 16, 168.4, 25, 0, 0, 6, 0, 50, 748, 7],
  ["Jordy Nelson", "WR", "GB", 2012, 12, 167.5, 0, 0, 0, 0, 0, 49, 745, 7],
  ["Jimmy Graham", "TE", "NO", 2012, 15, 237.2, 0, 0, 0, 0, 0, 85, 982, 9],
  ["Tony Gonzalez", "TE", "ATL", 2012, 16, 234, 0, 0, 0, 0, 0, 93, 930, 8],
  ["Jason Witten", "TE", "DAL", 2012, 16, 231.9, 0, 0, 0, 0, 0, 110, 1039, 3],
  ["Heath Miller", "TE", "PIT", 2012, 15, 202.6, 0, 0, 0, 0, 0, 71, 816, 8],
  ["Rob Gronkowski", "TE", "NE", 2012, 11, 198, 0, 0, 0, 0, 0, 55, 790, 11],
  ["Brandon Myers", "TE", "OAK", 2012, 16, 183.6, 0, 0, 0, 0, 0, 79, 806, 4],
  ["Greg Olsen", "TE", "CAR", 2012, 16, 183.3, 0, 0, 0, 0, 0, 69, 843, 5],
  ["Dennis Pitta", "TE", "BAL", 2012, 16, 169.9, 0, 0, 0, 0, 0, 61, 669, 7],
  ["Owen Daniels", "TE", "HOU", 2012, 15, 169.6, 0, 0, 0, 0, 0, 62, 716, 6],
  ["Jermaine Gresham", "TE", "CIN", 2012, 16, 165.7, 0, 0, 0, 0, 0, 64, 737, 5],
  ["Kyle Rudolph", "TE", "MIN", 2012, 16, 158.3, 0, 0, 0, 0, 0, 53, 493, 9],
  ["Martellus Bennett", "TE", "NYG", 2012, 16, 147.6, 0, 0, 0, 0, 0, 55, 626, 5],
  ["Peyton Manning", "QB", "DEN", 2013, 16, 410, 5477, 55, 10, -31, 1, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2013, 16, 357.7, 5162, 39, 12, 52, 3, 0, 0, 0],
  ["Cam Newton", "QB", "CAR", 2013, 16, 297.7, 3379, 24, 13, 585, 6, 0, 0, 0],
  ["Andrew Luck", "QB", "IND", 2013, 16, 292.6, 3822, 23, 9, 377, 4, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2013, 16, 288.3, 4478, 32, 11, 72, 0, 0, 0, 0],
  ["Andy Dalton", "QB", "CIN", 2013, 16, 288, 4293, 33, 20, 183, 2, 0, 0, 0],
  ["Matthew Stafford", "QB", "DET", 2013, 16, 278.9, 4650, 29, 19, 69, 2, 0, 0, 0],
  ["Russell Wilson", "QB", "SEA", 2013, 16, 270.2, 3357, 26, 9, 539, 1, 0, 0, 0],
  ["Colin Kaepernick", "QB", "SF", 2013, 16, 264.3, 3197, 21, 8, 524, 4, 0, 0, 0],
  ["Tony Romo", "QB", "DAL", 2013, 15, 260.9, 3828, 31, 10, 38, 0, 0, 0, 0],
  ["Nick Foles", "QB", "PHI", 2013, 13, 259.7, 2891, 27, 2, 221, 3, 0, 0, 0],
  ["Ben Roethlisberger", "QB", "PIT", 2013, 16, 258.3, 4261, 28, 14, 99, 1, 0, 0, 0],
  ["Alex Smith", "QB", "KC", 2013, 15, 254.2, 3313, 23, 7, 431, 1, 1, -4, 0],
  ["Tom Brady", "QB", "NE", 2013, 16, 251.5, 4343, 25, 11, 18, 0, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2013, 16, 248.1, 4515, 26, 17, 55, 0, 0, 0, 0],
  ["Ryan Tannehill", "QB", "MIA", 2013, 16, 238.3, 3913, 24, 17, 238, 1, 0, 0, 0],
  ["Jamaal Charles", "RB", "KC", 2013, 15, 378, 0, 0, 0, 1287, 12, 70, 693, 7],
  ["Matt Forte", "RB", "CHI", 2013, 16, 337.3, 0, 0, 0, 1339, 9, 74, 594, 3],
  ["LeSean McCoy", "RB", "PHI", 2013, 16, 330.6, 0, 0, 0, 1607, 9, 52, 539, 2],
  ["Knowshon Moreno", "RB", "DEN", 2013, 16, 296.6, 0, 0, 0, 1038, 10, 60, 548, 3],
  ["Marshawn Lynch", "RB", "SEA", 2013, 16, 275.3, 0, 0, 0, 1257, 12, 36, 316, 2],
  ["DeMarco Murray", "RB", "DAL", 2013, 14, 258.1, 0, 0, 0, 1121, 9, 53, 350, 1],
  ["Eddie Lacy", "RB", "GB", 2013, 15, 242.5, 0, 0, 0, 1178, 11, 35, 257, 0],
  ["Chris Johnson", "RB", "TEN", 2013, 16, 240.2, 0, 0, 0, 1077, 6, 42, 345, 4],
  ["Reggie Bush", "RB", "DET", 2013, 14, 239.2, 0, 0, 0, 1006, 4, 54, 506, 3],
  ["Fred Jackson", "RB", "BUF", 2013, 16, 234.7, 0, 0, 0, 890, 9, 47, 387, 1],
  ["Adrian Peterson", "RB", "MIN", 2013, 14, 232.7, 0, 0, 0, 1266, 10, 29, 171, 1],
  ["Danny Woodhead", "RB", "SD", 2013, 16, 223.4, 0, 0, 0, 429, 2, 76, 605, 6],
  ["Giovani Bernard", "RB", "CIN", 2013, 16, 222.9, 0, 0, 0, 695, 5, 56, 514, 3],
  ["Le'Veon Bell", "RB", "PIT", 2013, 13, 216.9, 0, 0, 0, 860, 8, 45, 399, 0],
  ["Joique Bell", "RB", "DET", 2013, 16, 216.7, 0, 0, 0, 650, 8, 53, 547, 0],
  ["Pierre Thomas", "RB", "NO", 2013, 16, 213.2, 0, 0, 0, 549, 2, 77, 513, 3],
  ["Ryan Mathews", "RB", "SD", 2013, 16, 210.4, 0, 0, 0, 1255, 6, 26, 189, 1],
  ["Frank Gore", "RB", "SF", 2013, 16, 190.9, 0, 0, 0, 1128, 9, 16, 141, 0],
  ["Maurice Jones-Drew", "RB", "JAX", 2013, 15, 187, 8, 1, 0, 803, 5, 43, 314, 0],
  ["Zac Stacy", "RB", "STL", 2013, 13, 183.4, 0, 0, 0, 973, 7, 26, 141, 1],
  ["Alfred Morris", "RB", "WAS", 2013, 16, 178.3, 0, 0, 0, 1275, 7, 9, 78, 0],
  ["Ray Rice", "RB", "BAL", 2013, 15, 178.1, 0, 0, 0, 660, 4, 58, 321, 0],
  ["Darren Sproles", "RB", "NO", 2013, 15, 175.4, 0, 0, 0, 220, 2, 71, 604, 2],
  ["Rashad Jennings", "RB", "OAK", 2013, 15, 174.5, 0, 0, 0, 733, 6, 36, 292, 0],
  ["Andre Ellington", "RB", "ARI", 2013, 15, 165.3, 0, 0, 0, 652, 3, 39, 371, 1],
  ["DeAngelo Williams", "RB", "CAR", 2013, 15, 163.6, 0, 0, 0, 843, 3, 26, 333, 1],
  ["Cordarrelle Patterson", "RB", "MIN", 2013, 16, 161.7, 0, 0, 0, 158, 3, 45, 469, 4],
  ["C.J. Spiller", "RB", "BUF", 2013, 15, 154.8, 0, 0, 0, 933, 2, 33, 185, 0],
  ["Donald Brown", "RB", "IND", 2013, 15, 150.1, 0, 0, 0, 537, 6, 27, 214, 2],
  ["Steven Jackson", "RB", "ATL", 2013, 12, 148.4, 0, 0, 0, 543, 6, 33, 191, 1],
  ["Demaryius Thomas", "WR", "DEN", 2013, 16, 319, 0, 0, 0, 0, 0, 92, 1430, 14],
  ["Antonio Brown", "WR", "PIT", 2013, 16, 314.9, 15, 0, 0, 4, 0, 110, 1499, 8],
  ["Josh Gordon", "WR", "CLE", 2013, 14, 314.4, 0, 0, 0, 88, 0, 87, 1646, 9],
  ["A.J. Green", "WR", "CIN", 2013, 16, 306.6, 0, 0, 0, 0, 0, 98, 1426, 11],
  ["Brandon Marshall", "WR", "CHI", 2013, 16, 305.5, 0, 0, 0, 0, 0, 100, 1295, 12],
  ["Calvin Johnson", "WR", "DET", 2013, 14, 303.2, 0, 0, 0, 0, 0, 84, 1492, 12],
  ["Dez Bryant", "WR", "DAL", 2013, 16, 292.4, 0, 0, 0, 1, 0, 93, 1233, 13],
  ["Alshon Jeffery", "WR", "CHI", 2013, 16, 283.6, 0, 0, 0, 105, 0, 89, 1421, 7],
  ["Eric Decker", "WR", "DEN", 2013, 16, 279.8, 0, 0, 0, 0, 0, 87, 1288, 11],
  ["Andre Johnson", "WR", "HOU", 2013, 16, 279.7, 0, 0, 0, 0, 0, 109, 1407, 5],
  ["Pierre Garcon", "WR", "WAS", 2013, 16, 277.5, 0, 0, 0, 19, 0, 113, 1346, 5],
  ["DeSean Jackson", "WR", "PHI", 2013, 16, 269.4, 0, 0, 0, 2, 0, 82, 1332, 9],
  ["Jordy Nelson", "WR", "GB", 2013, 16, 264.4, 0, 0, 0, 0, 0, 85, 1314, 8],
  ["Julian Edelman", "WR", "NE", 2013, 16, 251.7, 0, 0, 0, 11, 0, 105, 1056, 6],
  ["Anquan Boldin", "WR", "SF", 2013, 16, 246, 0, 0, 0, 11, 0, 85, 1179, 7],
  ["Vincent Jackson", "WR", "TB", 2013, 16, 242.4, 0, 0, 0, 0, 0, 78, 1224, 7],
  ["Larry Fitzgerald", "WR", "ARI", 2013, 16, 236.2, 0, 0, 0, 8, 0, 82, 954, 10],
  ["Keenan Allen", "WR", "SD", 2013, 15, 221.6, 0, 0, 0, 0, 0, 71, 1046, 8],
  ["T.Y. Hilton", "WR", "IND", 2013, 16, 220.9, 0, 0, 0, 6, 0, 82, 1083, 5],
  ["Kendall Wright", "WR", "TEN", 2013, 16, 213.9, 0, 0, 0, 0, 0, 94, 1079, 2],
  ["Wes Welker", "WR", "DEN", 2013, 13, 210.8, 0, 0, 0, 0, 0, 73, 778, 10],
  ["Torrey Smith", "WR", "BAL", 2013, 16, 203.8, 0, 0, 0, 0, 0, 65, 1128, 4],
  ["Harry Douglas", "WR", "ATL", 2013, 16, 201.7, 0, 0, 0, 0, 0, 85, 1067, 2],
  ["Brian Hartline", "WR", "MIA", 2013, 16, 201.6, 0, 0, 0, 0, 0, 76, 1016, 4],
  ["Marques Colston", "WR", "NO", 2013, 15, 199.3, 0, 0, 0, 0, 0, 75, 943, 5],
  ["Mike Wallace", "WR", "MIA", 2013, 16, 199.3, 0, 0, 0, 33, 0, 73, 930, 5],
  ["Michael Floyd", "WR", "ARI", 2013, 16, 199.1, 0, 0, 0, 0, 0, 65, 1041, 5],
  ["Victor Cruz", "WR", "NYG", 2013, 14, 194.8, 0, 0, 0, 0, 0, 73, 998, 4],
  ["Marvin Jones", "WR", "CIN", 2013, 16, 188.7, 0, 0, 0, 65, 0, 51, 712, 10],
  ["Golden Tate", "WR", "SEA", 2013, 16, 186.9, 0, 0, 0, 31, 0, 64, 898, 5],
  ["Riley Cooper", "WR", "PHI", 2013, 16, 182.5, 0, 0, 0, 0, 0, 47, 835, 8],
  ["Emmanuel Sanders", "WR", "PIT", 2013, 16, 181.5, 0, 0, 0, 25, 0, 67, 740, 6],
  ["Rod Streater", "WR", "OAK", 2013, 16, 172.5, 0, 0, 0, 17, 0, 60, 888, 4],
  ["Greg Jennings", "WR", "MIN", 2013, 15, 172.4, 0, 0, 0, 0, 0, 68, 804, 4],
  ["Nate Washington", "WR", "TEN", 2013, 16, 167.9, 0, 0, 0, 0, 0, 58, 919, 3],
  ["Jerricho Cotchery", "WR", "PIT", 2013, 15, 165.7, 0, 0, 0, -5, 0, 46, 602, 10],
  ["Jimmy Graham", "TE", "NO", 2013, 16, 303.5, 0, 0, 0, 0, 0, 86, 1215, 16],
  ["Tony Gonzalez", "TE", "ATL", 2013, 16, 218.9, 0, 0, 0, 0, 0, 83, 859, 8],
  ["Julius Thomas", "TE", "DEN", 2013, 14, 215.8, 0, 0, 0, 0, 0, 65, 788, 12],
  ["Jordan Cameron", "TE", "CLE", 2013, 15, 213.7, 0, 0, 0, 0, 0, 80, 917, 7],
  ["Vernon Davis", "TE", "SF", 2013, 15, 213, 0, 0, 0, 0, 0, 52, 850, 13],
  ["Jason Witten", "TE", "DAL", 2013, 16, 206.1, 0, 0, 0, 0, 0, 73, 851, 8],
  ["Greg Olsen", "TE", "CAR", 2013, 16, 190.6, 0, 0, 0, 0, 0, 73, 816, 6],
  ["Charles Clay", "TE", "MIA", 2013, 16, 188.4, 0, 0, 0, 15, 1, 69, 759, 6],
  ["Antonio Gates", "TE", "SD", 2013, 16, 184.2, 0, 0, 0, 0, 0, 77, 872, 4],
  ["Martellus Bennett", "TE", "CHI", 2013, 16, 168.9, 0, 0, 0, 0, 0, 65, 759, 5],
  ["Delanie Walker", "TE", "TEN", 2013, 15, 153.1, 0, 0, 0, 0, 0, 60, 571, 6],
  ["Jared Cook", "TE", "STL", 2013, 16, 146.1, 0, 0, 0, 0, 0, 51, 671, 5],
  ["Aaron Rodgers", "QB", "GB", 2014, 16, 354.1, 4381, 38, 5, 269, 2, 0, 0, 0],
  ["Andrew Luck", "QB", "IND", 2014, 16, 351.7, 4761, 40, 16, 273, 3, 0, 0, 0],
  ["Russell Wilson", "QB", "SEA", 2014, 16, 328.6, 3475, 20, 7, 849, 6, 1, 17, 0],
  ["Peyton Manning", "QB", "DEN", 2014, 16, 312.7, 4727, 39, 15, -24, 0, 0, 0, 0],
  ["Ben Roethlisberger", "QB", "PIT", 2014, 16, 306.8, 4952, 32, 9, 27, 0, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2014, 16, 304, 4952, 33, 17, 68, 1, 1, 1, 0],
  ["Matt Ryan", "QB", "ATL", 2014, 16, 284.3, 4694, 28, 14, 145, 0, 0, 0, 0],
  ["Ryan Tannehill", "QB", "MIA", 2014, 16, 279.5, 4045, 27, 12, 311, 1, 1, -4, 0],
  ["Tom Brady", "QB", "NE", 2014, 16, 278.1, 4109, 33, 9, 57, 0, 0, 0, 0],
  ["Eli Manning", "QB", "NYG", 2014, 16, 269.5, 4410, 30, 14, 31, 1, 0, 0, 0],
  ["Tony Romo", "QB", "DAL", 2014, 15, 266.3, 3705, 34, 9, 61, 0, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2014, 16, 265.6, 4286, 31, 18, 102, 0, 0, 0, 0],
  ["Joe Flacco", "QB", "BAL", 2014, 16, 262.4, 3986, 27, 12, 70, 2, 0, 0, 0],
  ["Jay Cutler", "QB", "CHI", 2014, 15, 255.6, 3812, 28, 18, 191, 2, 0, 0, 0],
  ["Matthew Stafford", "QB", "DET", 2014, 16, 251.6, 4257, 22, 12, 93, 2, 0, 0, 0],
  ["Colin Kaepernick", "QB", "SF", 2014, 16, 250.7, 3369, 19, 10, 639, 1, 0, 0, 0],
  ["Le'Veon Bell", "RB", "PIT", 2014, 16, 370.5, 0, 0, 0, 1361, 8, 83, 854, 3],
  ["DeMarco Murray", "RB", "DAL", 2014, 16, 351.1, 0, 0, 0, 1845, 13, 57, 416, 0],
  ["Matt Forte", "RB", "CHI", 2014, 16, 346.6, 0, 0, 0, 1038, 6, 102, 808, 4],
  ["Marshawn Lynch", "RB", "SEA", 2014, 16, 302.3, 0, 0, 0, 1306, 13, 37, 367, 4],
  ["Arian Foster", "RB", "HOU", 2014, 13, 273.5, 5, 1, 0, 1246, 8, 38, 327, 5],
  ["Eddie Lacy", "RB", "GB", 2014, 16, 272.6, 0, 0, 0, 1139, 9, 42, 427, 4],
  ["Jamaal Charles", "RB", "KC", 2014, 15, 250.4, 0, 0, 0, 1033, 9, 40, 291, 5],
  ["Justin Forsett", "RB", "BAL", 2014, 16, 246.9, 0, 0, 0, 1266, 8, 44, 263, 0],
  ["Lamar Miller", "RB", "MIA", 2014, 16, 223.4, 0, 0, 0, 1099, 8, 38, 275, 1],
  ["C.J. Anderson", "RB", "DEN", 2014, 14, 211.3, 0, 0, 0, 849, 8, 34, 324, 2],
  ["Jeremy Hill", "RB", "CIN", 2014, 16, 210.9, 0, 0, 0, 1124, 9, 27, 215, 0],
  ["LeSean McCoy", "RB", "PHI", 2014, 16, 199.4, 0, 0, 0, 1319, 5, 28, 155, 0],
  ["Joique Bell", "RB", "DET", 2014, 15, 198.2, 0, 0, 0, 860, 7, 34, 322, 1],
  ["Matt Asiata", "RB", "MIN", 2014, 15, 194.2, 0, 0, 0, 570, 9, 44, 312, 1],
  ["Mark Ingram", "RB", "NO", 2014, 13, 191.9, 0, 0, 0, 964, 9, 29, 145, 0],
  ["Fred Jackson", "RB", "BUF", 2014, 14, 188.6, 0, 0, 0, 525, 2, 66, 501, 1],
  ["Alfred Morris", "RB", "WAS", 2014, 16, 187.9, 0, 0, 0, 1074, 8, 17, 155, 0],
  ["Giovani Bernard", "RB", "CIN", 2014, 13, 187.9, 0, 0, 0, 680, 5, 43, 349, 2],
  ["Andre Ellington", "RB", "ARI", 2014, 12, 177.5, 0, 0, 0, 660, 3, 46, 395, 2],
  ["Shane Vereen", "RB", "NE", 2014, 16, 165.8, 0, 0, 0, 391, 2, 52, 447, 3],
  ["Frank Gore", "RB", "SF", 2014, 16, 158.7, 0, 0, 0, 1106, 4, 11, 111, 1],
  ["Darren Sproles", "RB", "PHI", 2014, 15, 157.6, 0, 0, 0, 329, 6, 40, 387, 0],
  ["Ahmad Bradshaw", "RB", "IND", 2014, 10, 154.5, 0, 0, 0, 425, 2, 38, 300, 6],
  ["Chris Ivory", "RB", "NYJ", 2014, 16, 152.4, 0, 0, 0, 821, 6, 18, 123, 1],
  ["Jonathan Stewart", "RB", "CAR", 2014, 13, 146, 0, 0, 0, 809, 3, 25, 181, 1],
  ["Branden Oliver", "RB", "SD", 2014, 14, 145.3, 0, 0, 0, 582, 3, 36, 271, 1],
  ["Andre Williams", "RB", "NYG", 2014, 16, 145.1, 0, 0, 0, 721, 7, 18, 130, 0],
  ["Steven Jackson", "RB", "ATL", 2014, 15, 141.5, 0, 0, 0, 707, 6, 20, 148, 0],
  ["Rashad Jennings", "RB", "NYG", 2014, 11, 138.5, 0, 0, 0, 639, 4, 30, 226, 0],
  ["Tre Mason", "RB", "STL", 2014, 12, 135.3, 0, 0, 0, 765, 4, 16, 148, 1],
  ["Antonio Brown", "WR", "PIT", 2014, 16, 388.9, 20, 1, 0, 13, 0, 129, 1698, 13],
  ["Demaryius Thomas", "WR", "DEN", 2014, 16, 340.9, 0, 0, 0, 0, 0, 111, 1619, 11],
  ["Jordy Nelson", "WR", "GB", 2014, 16, 327.9, 0, 0, 0, 0, 0, 98, 1519, 13],
  ["Dez Bryant", "WR", "DAL", 2014, 16, 316, 0, 0, 0, 0, 0, 88, 1320, 16],
  ["Emmanuel Sanders", "WR", "DEN", 2014, 16, 301.8, 0, 0, 0, 44, 0, 101, 1404, 9],
  ["Julio Jones", "WR", "ATL", 2014, 15, 297.4, 0, 0, 0, 1, 0, 104, 1593, 6],
  ["Odell Beckham", "WR", "NYG", 2014, 12, 297, 0, 0, 0, 35, 0, 91, 1305, 12],
  ["Randall Cobb", "WR", "GB", 2014, 16, 295.4, 0, 0, 0, 37, 0, 91, 1287, 12],
  ["Jeremy Maclin", "WR", "PHI", 2014, 16, 276.8, 0, 0, 0, 0, 0, 85, 1318, 10],
  ["Alshon Jeffery", "WR", "CHI", 2014, 16, 261.6, 0, 0, 0, 33, 0, 85, 1133, 10],
  ["Golden Tate", "WR", "DET", 2014, 16, 259.1, 0, 0, 0, 30, 0, 99, 1331, 4],
  ["T.Y. Hilton", "WR", "IND", 2014, 15, 258.5, 0, 0, 0, 20, 0, 82, 1345, 7],
  ["Mike Evans", "WR", "TB", 2014, 15, 245.1, 0, 0, 0, 0, 0, 68, 1051, 12],
  ["DeAndre Hopkins", "WR", "HOU", 2014, 16, 231, 0, 0, 0, 0, 0, 76, 1210, 6],
  ["Julian Edelman", "WR", "NE", 2014, 14, 228.6, 0, 0, 0, 94, 0, 92, 972, 4],
  ["Calvin Johnson", "WR", "DET", 2014, 13, 226.7, 0, 0, 0, 0, 0, 71, 1077, 8],
  ["Kelvin Benjamin", "WR", "CAR", 2014, 16, 225.8, 0, 0, 0, 0, 0, 73, 1008, 9],
  ["Anquan Boldin", "WR", "SF", 2014, 16, 219.6, 0, 0, 0, 4, 0, 83, 1062, 5],
  ["Steve Smith", "WR", "BAL", 2014, 16, 219.5, 0, 0, 0, 0, 0, 79, 1065, 6],
  ["Mike Wallace", "WR", "MIA", 2014, 16, 212.8, 0, 0, 0, 16, 0, 67, 862, 10],
  ["Roddy White", "WR", "ATL", 2014, 14, 212.1, 0, 0, 0, 0, 0, 80, 921, 7],
  ["Brandon LaFell", "WR", "NE", 2014, 15, 210.6, 0, 0, 0, 13, 0, 74, 953, 7],
  ["DeSean Jackson", "WR", "WAS", 2014, 15, 209.6, 0, 0, 0, 7, 0, 56, 1169, 6],
  ["A.J. Green", "WR", "CIN", 2014, 12, 205.3, 0, 0, 0, 2, 0, 69, 1041, 6],
  ["Eric Decker", "WR", "NYJ", 2014, 15, 200.2, 0, 0, 0, 0, 0, 74, 962, 5],
  ["Sammy Watkins", "WR", "BUF", 2014, 16, 198, 0, 0, 0, 8, 0, 65, 982, 6],
  ["Torrey Smith", "WR", "BAL", 2014, 15, 191.7, 0, 0, 0, 0, 0, 49, 767, 11],
  ["Andre Johnson", "WR", "HOU", 2014, 15, 190.6, 0, 0, 0, 0, 0, 85, 936, 3],
  ["Jarvis Landry", "WR", "MIA", 2014, 16, 189.4, 0, 0, 0, -4, 0, 84, 758, 5],
  ["Rueben Randle", "WR", "NYG", 2014, 16, 182.8, 0, 0, 0, 0, 0, 71, 938, 3],
  ["Eddie Royal", "WR", "SD", 2014, 16, 181.2, 0, 0, 0, 14, 0, 62, 778, 7],
  ["Vincent Jackson", "WR", "TB", 2014, 16, 180.2, 0, 0, 0, 0, 0, 70, 1002, 2],
  ["Mohamed Sanu", "WR", "CIN", 2014, 16, 179.3, 79, 1, 0, 51, 0, 56, 790, 5],
  ["Brandon Marshall", "WR", "CHI", 2014, 13, 179.1, 0, 0, 0, 0, 0, 61, 721, 8],
  ["Keenan Allen", "WR", "SD", 2014, 14, 177.3, 0, 0, 0, 0, 0, 77, 783, 4],
  ["Marques Colston", "WR", "NO", 2014, 15, 177.2, 0, 0, 0, 0, 0, 59, 902, 5],
  ["Rob Gronkowski", "TE", "NE", 2014, 15, 266.4, 0, 0, 0, 0, 0, 82, 1124, 12],
  ["Jimmy Graham", "TE", "NO", 2014, 15, 229.9, 0, 0, 0, 0, 0, 85, 889, 10],
  ["Antonio Gates", "TE", "SD", 2014, 16, 223.1, 0, 0, 0, 0, 0, 69, 821, 12],
  ["Martellus Bennett", "TE", "CHI", 2014, 16, 221.6, 0, 0, 0, 0, 0, 90, 916, 6],
  ["Greg Olsen", "TE", "CAR", 2014, 16, 220.8, 0, 0, 0, 0, 0, 84, 1008, 6],
  ["Jordan Matthews", "TE", "PHI", 2014, 16, 202.2, 0, 0, 0, 0, 0, 67, 872, 8],
  ["Travis Kelce", "TE", "KC", 2014, 16, 177.2, 0, 0, 0, 0, 0, 67, 862, 5],
  ["Coby Fleener", "TE", "IND", 2014, 16, 176.4, 0, 0, 0, 0, 0, 51, 774, 8],
  ["Delanie Walker", "TE", "TEN", 2014, 15, 176, 0, 0, 0, 0, 0, 63, 890, 4],
  ["Jason Witten", "TE", "DAL", 2014, 16, 164.3, 0, 0, 0, 0, 0, 64, 703, 5],
  ["Julius Thomas", "TE", "DEN", 2014, 12, 163.9, 0, 0, 0, 0, 0, 43, 489, 12],
  ["Heath Miller", "TE", "PIT", 2014, 16, 160.1, 0, 0, 0, 0, 0, 66, 761, 3],
  ["Cam Newton", "QB", "CAR", 2015, 16, 389.1, 3837, 35, 10, 636, 10, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2015, 16, 344.7, 4770, 36, 7, 53, 3, 1, 36, 0],
  ["Russell Wilson", "QB", "SEA", 2015, 16, 336.3, 4024, 34, 8, 553, 1, 0, 0, 0],
  ["Blake Bortles", "QB", "JAX", 2015, 16, 316.1, 4428, 35, 18, 310, 2, 0, 0, 0],
  ["Carson Palmer", "QB", "ARI", 2015, 16, 309.2, 4671, 35, 11, 24, 1, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2015, 15, 304.2, 4870, 32, 11, 14, 1, 0, 0, 0],
  ["Aaron Rodgers", "QB", "GB", 2015, 16, 301.2, 3821, 31, 8, 344, 1, 0, 0, 0],
  ["Kirk Cousins", "QB", "WAS", 2015, 16, 293.4, 4166, 29, 11, 48, 5, 0, 0, 0],
  ["Matthew Stafford", "QB", "DET", 2015, 16, 290.8, 4262, 32, 13, 159, 1, 1, -6, 0],
  ["Eli Manning", "QB", "NYG", 2015, 16, 287.4, 4432, 35, 14, 61, 0, 0, 0, 0],
  ["Ryan Fitzpatrick", "QB", "NYJ", 2015, 16, 285.2, 3905, 31, 15, 270, 2, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2015, 16, 284.5, 4792, 29, 13, 28, 0, 0, 0, 0],
  ["Jameis Winston", "QB", "TB", 2015, 16, 275, 4042, 22, 15, 213, 6, 0, 0, 0],
  ["Tyrod Taylor", "QB", "BUF", 2015, 14, 271.6, 3035, 20, 6, 568, 4, 1, 4, 0],
  ["Derek Carr", "QB", "OAK", 2015, 16, 271.3, 3987, 32, 13, 138, 0, 0, 0, 0],
  ["Alex Smith", "QB", "KC", 2015, 16, 271.2, 3486, 20, 7, 498, 2, 0, 0, 0],
  ["Devonta Freeman", "RB", "ATL", 2015, 15, 316.4, 0, 0, 0, 1056, 11, 73, 578, 3],
  ["Adrian Peterson", "RB", "MIN", 2015, 16, 260.7, 0, 0, 0, 1485, 11, 30, 222, 0],
  ["Danny Woodhead", "RB", "SD", 2015, 16, 243.1, 0, 0, 0, 336, 3, 80, 755, 6],
  ["DeAngelo Williams", "RB", "PIT", 2015, 16, 233.4, 0, 0, 0, 907, 11, 40, 367, 0],
  ["Doug Martin", "RB", "TB", 2015, 16, 232.3, 0, 0, 0, 1402, 6, 33, 271, 1],
  ["Lamar Miller", "RB", "MIA", 2015, 16, 231.9, 0, 0, 0, 872, 8, 47, 397, 2],
  ["David Johnson", "RB", "ARI", 2015, 16, 217.8, 0, 0, 0, 581, 8, 36, 457, 4],
  ["Matt Forte", "RB", "CHI", 2015, 13, 214.7, 0, 0, 0, 898, 4, 44, 389, 3],
  ["Todd Gurley", "RB", "STL", 2015, 13, 208.4, 0, 0, 0, 1106, 10, 21, 188, 0],
  ["Latavius Murray", "RB", "OAK", 2015, 16, 204.8, 0, 0, 0, 1066, 6, 41, 232, 0],
  ["Mark Ingram", "RB", "NO", 2015, 12, 203.4, 0, 0, 0, 769, 6, 50, 405, 0],
  ["Chris Ivory", "RB", "NYJ", 2015, 15, 202.7, 0, 0, 0, 1070, 7, 30, 217, 1],
  ["Darren McFadden", "RB", "DAL", 2015, 16, 197.7, 0, 0, 0, 1089, 3, 40, 328, 0],
  ["Frank Gore", "RB", "IND", 2015, 16, 193.4, 0, 0, 0, 967, 6, 34, 267, 1],
  ["DeMarco Murray", "RB", "PHI", 2015, 15, 184.4, 0, 0, 0, 702, 6, 44, 322, 1],
  ["Giovani Bernard", "RB", "CIN", 2015, 16, 181.2, 0, 0, 0, 730, 2, 49, 472, 0],
  ["Charles Sims", "RB", "TB", 2015, 16, 180, 0, 0, 0, 529, 0, 51, 561, 4],
  ["Theo Riddick", "RB", "DET", 2015, 16, 179, 0, 0, 0, 133, 0, 80, 697, 3],
  ["LeSean McCoy", "RB", "BUF", 2015, 12, 178.7, 0, 0, 0, 895, 3, 32, 292, 2],
  ["Jeremy Hill", "RB", "CIN", 2015, 16, 170.3, 0, 0, 0, 794, 11, 15, 79, 1],
  ["James Starks", "RB", "GB", 2015, 16, 166.3, 0, 0, 0, 601, 2, 43, 392, 3],
  ["Rashad Jennings", "RB", "NYG", 2015, 16, 164.9, 0, 0, 0, 863, 3, 29, 296, 1],
  ["Duke Johnson", "RB", "CLE", 2015, 16, 164.3, 0, 0, 0, 379, 0, 61, 534, 2],
  ["Jonathan Stewart", "RB", "CAR", 2015, 13, 162.8, 0, 0, 0, 989, 6, 16, 99, 1],
  ["Darren Sproles", "RB", "PHI", 2015, 16, 161.5, 0, 0, 0, 317, 3, 55, 388, 1],
  ["Ronnie Hillman", "RB", "DEN", 2015, 16, 161.4, 0, 0, 0, 863, 7, 24, 111, 0],
  ["Shane Vereen", "RB", "NYG", 2015, 16, 158.4, 0, 0, 0, 260, 0, 59, 494, 4],
  ["T.J. Yeldon", "RB", "JAX", 2015, 12, 155.9, 0, 0, 0, 740, 2, 36, 279, 1],
  ["Jeremy Langford", "RB", "CHI", 2015, 15, 147.6, 0, 0, 0, 537, 6, 22, 279, 1],
  ["Javorius Allen", "RB", "BAL", 2015, 16, 145.7, 0, 0, 0, 514, 1, 45, 353, 2],
  ["Antonio Brown", "WR", "PIT", 2015, 16, 390.2, 0, 0, 0, 28, 0, 136, 1834, 10],
  ["Julio Jones", "WR", "ATL", 2015, 16, 369.1, 0, 0, 0, 0, 0, 136, 1871, 8],
  ["Brandon Marshall", "WR", "NYJ", 2015, 16, 339.2, 0, 0, 0, 0, 0, 109, 1502, 14],
  ["DeAndre Hopkins", "WR", "HOU", 2015, 16, 331.1, 0, 0, 0, 0, 0, 111, 1521, 11],
  ["Odell Beckham", "WR", "NYG", 2015, 15, 319.3, 0, 0, 0, 3, 0, 96, 1450, 13],
  ["Allen Robinson", "WR", "JAX", 2015, 16, 304, 0, 0, 0, 0, 0, 80, 1400, 14],
  ["Larry Fitzgerald", "WR", "ARI", 2015, 16, 280.5, 0, 0, 0, 0, 0, 109, 1215, 9],
  ["Jarvis Landry", "WR", "MIA", 2015, 16, 275.4, 9, 0, 0, 113, 1, 110, 1157, 4],
  ["A.J. Green", "WR", "CIN", 2015, 16, 273.7, 0, 0, 0, 0, 0, 86, 1297, 10],
  ["Doug Baldwin", "WR", "SEA", 2015, 16, 268.9, 0, 0, 0, 0, 0, 78, 1069, 14],
  ["Demaryius Thomas", "WR", "DEN", 2015, 16, 267.4, 0, 0, 0, 0, 0, 105, 1304, 6],
  ["Calvin Johnson", "WR", "DET", 2015, 16, 263.4, 0, 0, 0, 0, 0, 88, 1214, 9],
  ["Brandin Cooks", "WR", "NO", 2015, 16, 253.6, 0, 0, 0, 18, 0, 84, 1138, 9],
  ["Eric Decker", "WR", "NYJ", 2015, 15, 252.7, 0, 0, 0, 0, 0, 80, 1027, 12],
  ["Jeremy Maclin", "WR", "KC", 2015, 15, 243.2, 0, 0, 0, 14, 0, 87, 1088, 8],
  ["Michael Crabtree", "WR", "OAK", 2015, 16, 231.2, 0, 0, 0, 0, 0, 85, 922, 9],
  ["Emmanuel Sanders", "WR", "DEN", 2015, 15, 226.4, 0, 0, 0, 29, 0, 76, 1135, 6],
  ["Allen Hurns", "WR", "JAX", 2015, 15, 225.1, 0, 0, 0, 0, 0, 64, 1031, 10],
  ["Sammy Watkins", "WR", "BUF", 2015, 13, 218.8, 0, 0, 0, 1, 0, 60, 1047, 9],
  ["Amari Cooper", "WR", "OAK", 2015, 16, 213.9, 0, 0, 0, -3, 0, 72, 1082, 6],
  ["T.Y. Hilton", "WR", "IND", 2015, 16, 211.4, 0, 0, 0, 0, 0, 69, 1124, 5],
  ["Mike Evans", "WR", "TB", 2015, 15, 210.6, 0, 0, 0, 0, 0, 74, 1206, 3],
  ["Golden Tate", "WR", "DET", 2015, 16, 209.4, 0, 0, 0, 41, 0, 90, 813, 6],
  ["John Brown", "WR", "ARI", 2015, 15, 207.5, 0, 0, 0, 22, 0, 65, 1003, 7],
  ["Randall Cobb", "WR", "GB", 2015, 16, 202.9, 0, 0, 0, 50, 0, 79, 829, 6],
  ["Tavon Austin", "WR", "STL", 2015, 16, 200.7, 0, 0, 0, 434, 4, 52, 473, 5],
  ["Travis Benjamin", "WR", "CLE", 2015, 16, 199.8, 0, 0, 0, 12, 0, 68, 966, 5],
  ["Kamar Aiken", "WR", "BAL", 2015, 16, 197.4, 0, 0, 0, 0, 0, 75, 944, 5],
  ["James Jones", "WR", "GB", 2015, 16, 191, 0, 0, 0, 0, 0, 50, 890, 8],
  ["Pierre Garcon", "WR", "WAS", 2015, 16, 185.7, 0, 0, 0, 0, 0, 72, 777, 6],
  ["Rueben Randle", "WR", "NYG", 2015, 16, 185.1, 0, 0, 0, 0, 0, 57, 801, 8],
  ["Ted Ginn", "WR", "CAR", 2015, 14, 183.9, 0, 0, 0, 60, 0, 44, 739, 10],
  ["Willie Snead", "WR", "NO", 2015, 15, 183.4, 0, 0, 0, 0, 0, 69, 984, 3],
  ["Marvin Jones", "WR", "CIN", 2015, 16, 173.9, 0, 0, 0, 33, 0, 65, 816, 4],
  ["Donte Moncrief", "WR", "IND", 2015, 16, 173.3, 0, 0, 0, 0, 0, 64, 733, 6],
  ["Michael Floyd", "WR", "ARI", 2015, 15, 172.9, 0, 0, 0, 0, 0, 52, 849, 6],
  ["Rob Gronkowski", "TE", "NE", 2015, 15, 255.6, 0, 0, 0, 0, 0, 72, 1176, 11],
  ["Delanie Walker", "TE", "TEN", 2015, 15, 244.4, 0, 0, 0, 36, 0, 94, 1088, 6],
  ["Jordan Reed", "TE", "WAS", 2015, 14, 244.2, 0, 0, 0, 0, 0, 87, 952, 11],
  ["Gary Barnidge", "TE", "CLE", 2015, 16, 237.3, 0, 0, 0, 0, 0, 79, 1043, 9],
  ["Jordan Matthews", "TE", "PHI", 2015, 16, 230.7, 0, 0, 0, 0, 0, 85, 997, 8],
  ["Greg Olsen", "TE", "CAR", 2015, 16, 227.4, 0, 0, 0, 0, 0, 77, 1104, 7],
  ["Tyler Eifert", "TE", "CIN", 2015, 13, 191.5, 0, 0, 0, 0, 0, 52, 615, 13],
  ["Benjamin Watson", "TE", "NO", 2015, 16, 190.5, 0, 0, 0, 0, 0, 74, 825, 6],
  ["Travis Kelce", "TE", "KC", 2015, 16, 189.5, 0, 0, 0, 0, 0, 72, 875, 5],
  ["Zach Ertz", "TE", "PHI", 2015, 15, 170.3, 0, 0, 0, 0, 0, 75, 853, 2],
  ["Jason Witten", "TE", "DAL", 2015, 16, 164.3, 0, 0, 0, 0, 0, 77, 713, 3],
  ["Richard Rodgers", "TE", "GB", 2015, 16, 161.7, 0, 0, 0, 11, 0, 58, 526, 8],
  ["Aaron Rodgers", "QB", "GB", 2016, 16, 380, 4428, 40, 7, 369, 4, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2016, 16, 347.5, 4944, 38, 7, 117, 0, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2016, 16, 332.3, 5208, 37, 15, 20, 2, 0, 0, 0],
  ["Andrew Luck", "QB", "IND", 2016, 15, 307.7, 4240, 31, 13, 341, 2, 0, 0, 0],
  ["Kirk Cousins", "QB", "WAS", 2016, 16, 300.3, 4917, 25, 12, 96, 4, 0, 0, 0],
  ["Dak Prescott", "QB", "DAL", 2016, 16, 286.9, 3667, 23, 4, 282, 6, 0, 0, 0],
  ["Matthew Stafford", "QB", "DET", 2016, 16, 279.8, 4327, 24, 10, 207, 2, 0, 0, 0],
  ["Blake Bortles", "QB", "JAX", 2016, 16, 271.1, 3905, 23, 16, 359, 3, 1, 20, 1],
  ["Tyrod Taylor", "QB", "BUF", 2016, 15, 270.9, 3023, 17, 6, 580, 6, 0, 0, 0],
  ["Russell Wilson", "QB", "SEA", 2016, 16, 270.1, 4219, 21, 11, 259, 1, 2, 14, 1],
  ["Derek Carr", "QB", "OAK", 2016, 15, 268.5, 3937, 28, 6, 70, 0, 0, 0, 0],
  ["Andy Dalton", "QB", "CIN", 2016, 16, 260.6, 4206, 18, 8, 184, 4, 0, 0, 0],
  ["Marcus Mariota", "QB", "TEN", 2016, 15, 259.9, 3426, 26, 9, 349, 2, 0, 0, 0],
  ["Philip Rivers", "QB", "SD", 2016, 16, 258.9, 4386, 33, 21, 35, 0, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2016, 12, 258.6, 3554, 28, 2, 64, 0, 0, 0, 0],
  ["Jameis Winston", "QB", "TB", 2016, 16, 256.1, 4090, 28, 18, 165, 1, 0, 0, 0],
  ["David Johnson", "RB", "ARI", 2016, 16, 407.8, 0, 0, 0, 1239, 16, 80, 879, 4],
  ["Ezekiel Elliott", "RB", "DAL", 2016, 15, 325.4, 0, 0, 0, 1631, 15, 32, 363, 1],
  ["Le'Veon Bell", "RB", "PIT", 2016, 12, 317.4, 0, 0, 0, 1268, 7, 75, 616, 2],
  ["LeSean McCoy", "RB", "BUF", 2016, 15, 298.3, 0, 0, 0, 1267, 13, 50, 356, 1],
  ["DeMarco Murray", "RB", "TEN", 2016, 16, 293.8, 10, 1, 0, 1287, 9, 53, 377, 3],
  ["Devonta Freeman", "RB", "ATL", 2016, 16, 284.1, 0, 0, 0, 1079, 11, 54, 462, 2],
  ["Melvin Gordon", "RB", "SD", 2016, 13, 250.6, 0, 0, 0, 997, 10, 41, 419, 2],
  ["Mark Ingram", "RB", "NO", 2016, 16, 242.2, 0, 0, 0, 1043, 6, 46, 319, 4],
  ["LeGarrette Blount", "RB", "NE", 2016, 16, 232.9, 0, 0, 0, 1161, 18, 7, 38, 0],
  ["Jordan Howard", "RB", "CHI", 2016, 15, 230.1, 0, 0, 0, 1313, 6, 29, 298, 1],
  ["Jay Ajayi", "RB", "MIA", 2016, 15, 215.3, 0, 0, 0, 1272, 8, 27, 151, 0],
  ["Frank Gore", "RB", "IND", 2016, 16, 214.2, 0, 0, 0, 1025, 4, 38, 277, 4],
  ["Latavius Murray", "RB", "OAK", 2016, 14, 208.2, 0, 0, 0, 788, 12, 33, 264, 0],
  ["Isaiah Crowell", "RB", "CLE", 2016, 16, 205.1, 0, 0, 0, 952, 7, 40, 319, 0],
  ["Todd Gurley", "RB", "LAR", 2016, 16, 198.2, 0, 0, 0, 885, 6, 43, 327, 0],
  ["Bilal Powell", "RB", "NYJ", 2016, 16, 197, 0, 0, 0, 722, 3, 58, 388, 2],
  ["Spencer Ware", "RB", "KC", 2016, 14, 195.8, 0, 0, 0, 921, 3, 33, 447, 2],
  ["Carlos Hyde", "RB", "SF", 2016, 13, 192.1, 0, 0, 0, 988, 6, 27, 163, 3],
  ["Lamar Miller", "RB", "HOU", 2016, 14, 191.1, 0, 0, 0, 1073, 5, 31, 188, 1],
  ["Tevin Coleman", "RB", "ATL", 2016, 13, 191.1, 0, 0, 0, 520, 8, 31, 421, 3],
  ["Matt Forte", "RB", "NYJ", 2016, 14, 183.6, 0, 0, 0, 813, 7, 30, 263, 1],
  ["Jeremy Hill", "RB", "CIN", 2016, 15, 176.3, 0, 0, 0, 839, 9, 21, 174, 0],
  ["Terrance West", "RB", "BAL", 2016, 16, 171, 0, 0, 0, 774, 5, 34, 236, 1],
  ["Darren Sproles", "RB", "PHI", 2016, 15, 162.5, 0, 0, 0, 438, 2, 52, 427, 2],
  ["Theo Riddick", "RB", "DET", 2016, 10, 161.8, 0, 0, 0, 357, 1, 53, 371, 5],
  ["James White", "RB", "NE", 2016, 16, 161.7, 0, 0, 0, 166, 0, 60, 551, 5],
  ["Jerick McKinnon", "RB", "MIN", 2016, 15, 148.4, 0, 0, 0, 539, 2, 43, 255, 2],
  ["Chris Thompson", "RB", "WAS", 2016, 16, 147.5, 0, 0, 0, 356, 3, 49, 349, 2],
  ["Jonathan Stewart", "RB", "CAR", 2016, 13, 146.4, 0, 0, 0, 824, 9, 8, 60, 0],
  ["Ryan Mathews", "RB", "PHI", 2016, 13, 144.6, 0, 0, 0, 661, 8, 13, 115, 1],
  ["Antonio Brown", "WR", "PIT", 2016, 15, 307.3, 0, 0, 0, 9, 0, 106, 1284, 12],
  ["Jordy Nelson", "WR", "GB", 2016, 16, 304.7, 0, 0, 0, 0, 0, 97, 1257, 14],
  ["Mike Evans", "WR", "TB", 2016, 16, 304.1, 0, 0, 0, 0, 0, 96, 1321, 12],
  ["Odell Beckham", "WR", "NYG", 2016, 16, 296.6, 0, 0, 0, 9, 0, 101, 1367, 10],
  ["T.Y. Hilton", "WR", "IND", 2016, 16, 273.8, 0, 0, 0, 0, 0, 91, 1448, 6],
  ["Julio Jones", "WR", "ATL", 2016, 14, 259.9, 0, 0, 0, 0, 0, 83, 1409, 6],
  ["Michael Thomas", "WR", "NO", 2016, 15, 255.7, 0, 0, 0, 0, 0, 92, 1137, 9],
  ["Doug Baldwin", "WR", "SEA", 2016, 16, 253.6, 15, 1, 0, 2, 0, 94, 1128, 7],
  ["Davante Adams", "WR", "GB", 2016, 16, 246.7, 0, 0, 0, 0, 0, 75, 997, 12],
  ["Brandin Cooks", "WR", "NO", 2016, 15, 246.3, 0, 0, 0, 30, 0, 78, 1173, 8],
  ["Larry Fitzgerald", "WR", "ARI", 2016, 16, 243.8, 0, 0, 0, 5, 0, 107, 1023, 6],
  ["Michael Crabtree", "WR", "OAK", 2016, 16, 239.3, 0, 0, 0, 0, 0, 89, 1003, 8],
  ["Jarvis Landry", "WR", "MIA", 2016, 16, 233.3, 0, 0, 0, 17, 0, 94, 1136, 4],
  ["Julian Edelman", "WR", "NE", 2016, 16, 232.3, 0, 0, 0, 57, 0, 98, 1106, 3],
  ["Amari Cooper", "WR", "OAK", 2016, 16, 232.3, 0, 0, 0, 0, 0, 83, 1153, 5],
  ["Demaryius Thomas", "WR", "DEN", 2016, 16, 226.3, 0, 0, 0, 0, 0, 90, 1083, 5],
  ["Golden Tate", "WR", "DET", 2016, 16, 223.1, 0, 0, 0, 4, 0, 91, 1077, 4],
  ["Tyreek Hill", "WR", "KC", 2016, 16, 219, 0, 0, 0, 267, 3, 61, 593, 6],
  ["Tyrell Williams", "WR", "SD", 2016, 16, 216.9, 0, 0, 0, 0, 0, 69, 1059, 7],
  ["Terrelle Pryor", "WR", "CLE", 2016, 16, 213.4, 41, 0, 0, 21, 1, 77, 1007, 4],
  ["Emmanuel Sanders", "WR", "DEN", 2016, 15, 212.6, 0, 0, 0, 4, 0, 79, 1032, 5],
  ["Rishard Matthews", "WR", "TEN", 2016, 16, 211.5, 0, 0, 0, 0, 0, 65, 945, 9],
  ["Mike Wallace", "WR", "BAL", 2016, 16, 202.8, 0, 0, 0, 31, 0, 72, 1017, 4],
  ["Pierre Garcon", "WR", "WAS", 2016, 16, 201.1, 0, 0, 0, 0, 0, 79, 1041, 3],
  ["Allen Robinson", "WR", "JAX", 2016, 16, 199.3, 0, 0, 0, 0, 0, 73, 883, 6],
  ["Jamison Crowder", "WR", "WAS", 2016, 16, 197.5, 0, 0, 0, -2, 0, 67, 847, 7],
  ["DeAndre Hopkins", "WR", "HOU", 2016, 16, 197.4, 0, 0, 0, 0, 0, 78, 954, 4],
  ["Adam Thielen", "WR", "MIN", 2016, 16, 197.2, 0, 0, 0, 15, 0, 69, 967, 5],
  ["Kelvin Benjamin", "WR", "CAR", 2016, 16, 197.1, 0, 0, 0, 0, 0, 63, 941, 7],
  ["Kenny Britt", "WR", "LAR", 2016, 15, 196.2, 0, 0, 0, 0, 0, 68, 1002, 5],
  ["Stefon Diggs", "WR", "MIN", 2016, 13, 193.3, 0, 0, 0, 10, 0, 84, 903, 3],
  ["Willie Snead", "WR", "NO", 2016, 15, 191.5, 50, 1, 0, 0, 0, 72, 895, 4],
  ["Cole Beasley", "WR", "DAL", 2016, 16, 189, 0, 0, 0, 7, 0, 75, 833, 5],
  ["A.J. Green", "WR", "CIN", 2016, 10, 186.4, 0, 0, 0, 0, 0, 66, 964, 4],
  ["Brandon LaFell", "WR", "CIN", 2016, 16, 186, 0, 0, 0, -2, 0, 64, 862, 6],
  ["Sterling Shepard", "WR", "NYG", 2016, 16, 184.4, 0, 0, 0, 31, 0, 65, 683, 8],
  ["Travis Kelce", "TE", "KC", 2016, 16, 223, 0, 0, 0, -5, 0, 85, 1125, 4],
  ["Kyle Rudolph", "TE", "MIN", 2016, 16, 209, 0, 0, 0, 0, 0, 83, 840, 7],
  ["Greg Olsen", "TE", "CAR", 2016, 16, 207.3, 0, 0, 0, 0, 0, 80, 1073, 3],
  ["Jimmy Graham", "TE", "SEA", 2016, 16, 189.3, 0, 0, 0, 0, 0, 65, 923, 6],
  ["Delanie Walker", "TE", "TEN", 2016, 15, 188.1, 0, 0, 0, 11, 0, 65, 800, 7],
  ["Zach Ertz", "TE", "PHI", 2016, 14, 183.6, 0, 0, 0, 0, 0, 78, 816, 4],
  ["Jordan Matthews", "TE", "PHI", 2016, 14, 171.4, 0, 0, 0, 0, 0, 73, 804, 3],
  ["Cameron Brate", "TE", "TB", 2016, 15, 171, 0, 0, 0, 0, 0, 57, 660, 8],
  ["Dennis Pitta", "TE", "BAL", 2016, 16, 168.9, 0, 0, 0, 0, 0, 86, 729, 2],
  ["Jordan Reed", "TE", "WAS", 2016, 12, 168.6, 0, 0, 0, 0, 0, 66, 686, 6],
  ["Martellus Bennett", "TE", "NE", 2016, 16, 168.1, 0, 0, 0, 10, 0, 55, 701, 7],
  ["Jason Witten", "TE", "DAL", 2016, 15, 152.3, 0, 0, 0, 0, 0, 69, 673, 3],
  ["Russell Wilson", "QB", "SEA", 2017, 16, 347.9, 3983, 34, 11, 586, 3, 0, 0, 0],
  ["Cam Newton", "QB", "CAR", 2017, 16, 299.5, 3302, 22, 16, 754, 6, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2017, 16, 295.9, 4577, 32, 8, 28, 0, 0, 0, 0],
  ["Alex Smith", "QB", "KC", 2017, 15, 295.2, 4042, 26, 5, 355, 1, 0, 0, 0],
  ["Carson Wentz", "QB", "PHI", 2017, 13, 283.7, 3296, 33, 7, 299, 0, 0, 0, 0],
  ["Kirk Cousins", "QB", "WAS", 2017, 16, 277.6, 4093, 27, 13, 179, 4, 0, 0, 0],
  ["Matthew Stafford", "QB", "DET", 2017, 16, 273.6, 4446, 29, 10, 98, 0, 0, 0, 0],
  ["Philip Rivers", "QB", "LAC", 2017, 16, 270.4, 4515, 28, 10, -2, 0, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2017, 16, 262.6, 4334, 23, 8, 12, 2, 0, 0, 0],
  ["Ben Roethlisberger", "QB", "PIT", 2017, 15, 261.1, 4259, 28, 14, 47, 0, 0, 0, 0],
  ["Dak Prescott", "QB", "DAL", 2017, 16, 260.7, 3324, 22, 13, 357, 6, 0, 0, 0],
  ["Jared Goff", "QB", "LAR", 2017, 15, 255.3, 3804, 28, 7, 51, 1, 0, 0, 0],
  ["Blake Bortles", "QB", "JAX", 2017, 16, 249.7, 3687, 21, 13, 322, 2, 0, 0, 0],
  ["Case Keenum", "QB", "MIN", 2017, 15, 237.9, 3547, 22, 7, 160, 1, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2017, 16, 228.1, 4095, 20, 12, 143, 0, 0, 0, 0],
  ["Tyrod Taylor", "QB", "BUF", 2017, 15, 222.7, 2799, 14, 4, 427, 4, 0, 0, 0],
  ["Todd Gurley", "RB", "LAR", 2017, 15, 385.3, 0, 0, 0, 1305, 13, 64, 788, 6],
  ["Le'Veon Bell", "RB", "PIT", 2017, 15, 343.4, 0, 0, 0, 1291, 9, 86, 663, 2],
  ["Alvin Kamara", "RB", "NO", 2017, 16, 320.4, 0, 0, 0, 728, 8, 81, 826, 5],
  ["Kareem Hunt", "RB", "KC", 2017, 16, 295.2, 0, 0, 0, 1327, 8, 53, 455, 3],
  ["Melvin Gordon", "RB", "LAC", 2017, 16, 288.1, 0, 0, 0, 1105, 8, 58, 476, 4],
  ["Mark Ingram", "RB", "NO", 2017, 16, 278, 0, 0, 0, 1124, 12, 58, 416, 0],
  ["LeSean McCoy", "RB", "BUF", 2017, 16, 263.6, 0, 0, 0, 1138, 6, 59, 448, 2],
  ["Carlos Hyde", "RB", "SF", 2017, 16, 233.8, 0, 0, 0, 938, 8, 59, 350, 0],
  ["Leonard Fournette", "RB", "JAX", 2017, 13, 230.2, 0, 0, 0, 1040, 9, 36, 302, 1],
  ["Christian McCaffrey", "RB", "CAR", 2017, 16, 228.6, 0, 0, 0, 435, 2, 80, 651, 5],
  ["Duke Johnson", "RB", "CLE", 2017, 16, 216.1, 0, 0, 0, 348, 4, 74, 693, 3],
  ["Ezekiel Elliott", "RB", "DAL", 2017, 10, 203.2, 0, 0, 0, 983, 7, 26, 269, 2],
  ["Dion Lewis", "RB", "NE", 2017, 16, 203, 0, 0, 0, 896, 6, 32, 214, 3],
  ["Devonta Freeman", "RB", "ATL", 2017, 14, 200.2, 0, 0, 0, 865, 7, 36, 317, 1],
  ["Jordan Howard", "RB", "CHI", 2017, 16, 199.7, 0, 0, 0, 1122, 9, 23, 125, 0],
  ["Lamar Miller", "RB", "HOU", 2017, 16, 193.5, 0, 0, 0, 888, 3, 36, 327, 3],
  ["Jerick McKinnon", "RB", "MIN", 2017, 16, 178.1, 0, 0, 0, 570, 3, 51, 421, 2],
  ["C.J. Anderson", "RB", "DEN", 2017, 16, 175.1, 0, 0, 0, 1007, 3, 28, 224, 1],
  ["Frank Gore", "RB", "IND", 2017, 16, 173.6, 0, 0, 0, 961, 3, 29, 245, 1],
  ["DeMarco Murray", "RB", "TEN", 2017, 15, 171.5, 0, 0, 0, 659, 6, 39, 266, 1],
  ["Alex Collins", "RB", "BAL", 2017, 15, 171, 0, 0, 0, 973, 6, 23, 187, 0],
  ["Tevin Coleman", "RB", "ATL", 2017, 15, 167.7, 0, 0, 0, 628, 5, 27, 299, 3],
  ["Javorius Allen", "RB", "BAL", 2017, 16, 166.1, 0, 0, 0, 591, 4, 46, 250, 2],
  ["Marshawn Lynch", "RB", "OAK", 2017, 15, 164.2, 0, 0, 0, 891, 7, 20, 151, 0],
  ["Latavius Murray", "RB", "MIN", 2017, 16, 157.5, 0, 0, 0, 842, 8, 15, 103, 0],
  ["Chris Thompson", "RB", "WAS", 2017, 10, 155.4, 0, 0, 0, 294, 2, 39, 510, 4],
  ["Theo Riddick", "RB", "DET", 2017, 16, 154, 0, 0, 0, 286, 3, 53, 444, 2],
  ["Tarik Cohen", "RB", "CHI", 2017, 16, 152.1, 21, 1, 0, 370, 2, 53, 353, 1],
  ["Giovani Bernard", "RB", "CIN", 2017, 16, 150.9, 0, 0, 0, 458, 2, 43, 381, 2],
  ["Bilal Powell", "RB", "NYJ", 2017, 15, 145.2, 0, 0, 0, 772, 5, 23, 170, 0],
  ["Antonio Brown", "WR", "PIT", 2017, 14, 310.3, 0, 0, 0, 0, 0, 101, 1533, 9],
  ["DeAndre Hopkins", "WR", "HOU", 2017, 15, 309.8, 0, 0, 0, 0, 0, 96, 1378, 13],
  ["Keenan Allen", "WR", "LAC", 2017, 16, 278.2, 0, 0, 0, 9, 0, 102, 1393, 6],
  ["Larry Fitzgerald", "WR", "ARI", 2017, 16, 261.4, 21, 0, 0, 0, 0, 109, 1156, 6],
  ["Jarvis Landry", "WR", "MIA", 2017, 16, 260, 0, 0, 0, -7, 0, 112, 987, 9],
  ["Michael Thomas", "WR", "NO", 2017, 16, 258.5, 0, 0, 0, 0, 0, 104, 1245, 5],
  ["Julio Jones", "WR", "ATL", 2017, 16, 251.9, 0, 0, 0, 15, 0, 88, 1444, 3],
  ["Tyreek Hill", "WR", "KC", 2017, 15, 245.2, 0, 0, 1, 59, 0, 75, 1183, 7],
  ["Adam Thielen", "WR", "MIN", 2017, 16, 239.7, 0, 0, 0, 11, 0, 91, 1276, 4],
  ["A.J. Green", "WR", "CIN", 2017, 16, 226.8, 0, 0, 0, 0, 0, 75, 1078, 8],
  ["Marvin Jones", "WR", "DET", 2017, 16, 225.1, 0, 0, 0, 0, 0, 61, 1101, 9],
  ["Golden Tate", "WR", "DET", 2017, 16, 224.5, 0, 0, 0, 22, 0, 92, 1003, 5],
  ["Doug Baldwin", "WR", "SEA", 2017, 16, 223.3, 0, 0, 0, -8, 0, 75, 991, 8],
  ["Davante Adams", "WR", "GB", 2017, 14, 222.5, 0, 0, 0, 0, 0, 74, 885, 10],
  ["Brandin Cooks", "WR", "NE", 2017, 16, 221.2, 0, 0, 0, 40, 0, 65, 1082, 7],
  ["Demaryius Thomas", "WR", "DEN", 2017, 16, 205.9, 0, 0, 0, 0, 0, 83, 949, 5],
  ["Mike Evans", "WR", "TB", 2017, 15, 203.1, 0, 0, 0, 0, 0, 71, 1001, 5],
  ["Robbie Chosen", "WR", "NYJ", 2017, 16, 200, 0, 0, 0, 9, 0, 63, 941, 7],
  ["Stefon Diggs", "WR", "MIN", 2017, 14, 198.2, 0, 0, 0, 13, 0, 64, 849, 8],
  ["JuJu Smith-Schuster", "WR", "PIT", 2017, 13, 197.7, 0, 0, 0, 0, 0, 58, 917, 7],
  ["Alshon Jeffery", "WR", "PHI", 2017, 16, 195.9, 0, 0, 0, 0, 0, 57, 789, 9],
  ["Nelson Agholor", "WR", "PHI", 2017, 16, 187.5, 0, 0, 0, 7, 0, 62, 768, 8],
  ["Dez Bryant", "WR", "DAL", 2017, 16, 186.4, 0, 0, 0, -4, 0, 69, 838, 6],
  ["Cooper Kupp", "WR", "LAR", 2017, 15, 176.9, 0, 0, 0, 0, 0, 62, 869, 5],
  ["Jermaine Kearse", "WR", "NYJ", 2017, 16, 176, 0, 0, 0, 0, 0, 65, 810, 5],
  ["T.Y. Hilton", "WR", "IND", 2017, 16, 175.6, 0, 0, 0, 0, 0, 57, 966, 4],
  ["Kenny Stills", "WR", "MIA", 2017, 16, 174.7, 0, 0, 0, 0, 0, 58, 847, 6],
  ["Mohamed Sanu", "WR", "ATL", 2017, 15, 174.3, 51, 1, 0, 10, 0, 67, 703, 5],
  ["Michael Crabtree", "WR", "OAK", 2017, 13, 171.8, 0, 0, 0, 0, 0, 58, 618, 8],
  ["Marquise Goodwin", "WR", "SF", 2017, 16, 168.6, 0, 0, 0, 44, 0, 56, 962, 2],
  ["Jamison Crowder", "WR", "WAS", 2017, 15, 166.3, 0, 0, 0, 34, 0, 66, 789, 3],
  ["Robert Woods", "WR", "LAR", 2017, 12, 163.3, 0, 0, 0, 12, 0, 56, 781, 5],
  ["Ted Ginn", "WR", "NO", 2017, 15, 159.6, 0, 0, 0, 39, 0, 53, 787, 4],
  ["Randall Cobb", "WR", "GB", 2017, 14, 159.4, 10, 0, 0, 17, 0, 66, 653, 4],
  ["Amari Cooper", "WR", "OAK", 2017, 14, 158.4, 0, 0, 0, 4, 0, 48, 680, 7],
  ["Rishard Matthews", "WR", "TEN", 2017, 14, 156.2, 0, 0, 0, -3, 0, 53, 795, 4],
  ["Travis Kelce", "TE", "KC", 2017, 15, 233.5, 0, 0, 1, 7, 0, 83, 1038, 8],
  ["Rob Gronkowski", "TE", "NE", 2017, 13, 227.4, 0, 0, 0, 0, 0, 69, 1084, 8],
  ["Zach Ertz", "TE", "PHI", 2017, 14, 202.4, 0, 0, 0, 0, 0, 74, 824, 8],
  ["Devin Funchess", "TE", "CAR", 2017, 16, 195, 0, 0, 0, 0, 0, 63, 840, 8],
  ["Delanie Walker", "TE", "TEN", 2017, 16, 174.5, 0, 0, 0, -2, 1, 74, 807, 3],
  ["Evan Engram", "TE", "NYG", 2017, 15, 173.6, 0, 0, 0, 14, 0, 64, 722, 6],
  ["Jimmy Graham", "TE", "SEA", 2017, 16, 171, 0, 0, 0, 0, 0, 57, 520, 10],
  ["Jack Doyle", "TE", "IND", 2017, 15, 169, 0, 0, 0, 0, 0, 80, 690, 4],
  ["Kyle Rudolph", "TE", "MIN", 2017, 16, 158.2, 0, 0, 0, 0, 0, 57, 532, 8],
  ["Jason Witten", "TE", "DAL", 2017, 16, 147, 0, 0, 0, 0, 0, 63, 560, 5],
  ["Cameron Brate", "TE", "TB", 2017, 16, 143.1, 0, 0, 0, 0, 0, 48, 591, 6],
  ["Benjamin Watson", "TE", "BAL", 2017, 16, 137.2, 0, 0, 0, 0, 0, 61, 522, 4],
  ["Patrick Mahomes", "QB", "KC", 2018, 16, 417.1, 5097, 50, 12, 272, 2, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2018, 16, 355, 4924, 35, 7, 125, 3, 1, 5, 1],
  ["Ben Roethlisberger", "QB", "PIT", 2018, 16, 341.9, 5129, 34, 16, 98, 3, 1, -1, 0],
  ["Deshaun Watson", "QB", "HOU", 2018, 16, 331.7, 4165, 26, 9, 551, 5, 0, 0, 0],
  ["Andrew Luck", "QB", "IND", 2018, 16, 327.9, 4593, 39, 15, 148, 0, 1, 4, 0],
  ["Aaron Rodgers", "QB", "GB", 2018, 16, 312.6, 4442, 25, 2, 269, 2, 0, 0, 0],
  ["Jared Goff", "QB", "LAR", 2018, 16, 312.3, 4688, 32, 12, 108, 2, 0, 0, 0],
  ["Drew Brees", "QB", "NO", 2018, 15, 305, 3992, 32, 5, 22, 4, 1, 1, 0],
  ["Russell Wilson", "QB", "SEA", 2018, 16, 299.4, 3448, 35, 7, 376, 0, 1, -11, 0],
  ["Dak Prescott", "QB", "DAL", 2018, 16, 285.9, 3885, 22, 8, 305, 6, 0, 0, 0],
  ["Philip Rivers", "QB", "LAC", 2018, 16, 285, 4308, 32, 12, 7, 0, 0, 0, 0],
  ["Kirk Cousins", "QB", "MIN", 2018, 16, 283.1, 4298, 30, 10, 123, 1, 1, -1, 0],
  ["Cam Newton", "QB", "CAR", 2018, 14, 282.6, 3395, 24, 13, 488, 4, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2018, 16, 281.3, 4355, 29, 11, 35, 2, 1, 6, 0],
  ["Mitchell Trubisky", "QB", "CHI", 2018, 14, 263, 3223, 24, 12, 421, 3, 0, 0, 0],
  ["Baker Mayfield", "QB", "CLE", 2018, 14, 240.1, 3725, 27, 14, 131, 0, 0, 0, 0],
  ["Saquon Barkley", "RB", "NYG", 2018, 16, 385.8, 0, 0, 0, 1307, 11, 91, 721, 4],
  ["Christian McCaffrey", "RB", "CAR", 2018, 16, 385.5, 50, 1, 0, 1098, 7, 107, 867, 6],
  ["Todd Gurley", "RB", "LAR", 2018, 14, 372.1, 0, 0, 0, 1251, 17, 59, 580, 4],
  ["Alvin Kamara", "RB", "NO", 2018, 15, 354.2, 0, 0, 0, 883, 14, 81, 709, 4],
  ["Ezekiel Elliott", "RB", "DAL", 2018, 15, 329.1, 0, 0, 0, 1434, 6, 77, 567, 3],
  ["James Conner", "RB", "PIT", 2018, 13, 280, 0, 0, 0, 973, 12, 55, 497, 1],
  ["James White", "RB", "NE", 2018, 16, 276.6, 0, 0, 0, 425, 5, 87, 751, 7],
  ["Melvin Gordon", "RB", "LAC", 2018, 12, 275.5, 0, 0, 0, 885, 10, 50, 490, 4],
  ["David Johnson", "RB", "ARI", 2018, 16, 246.6, 0, 0, 0, 940, 7, 50, 446, 3],
  ["Joe Mixon", "RB", "CIN", 2018, 14, 243.4, 0, 0, 0, 1168, 8, 43, 296, 1],
  ["Tarik Cohen", "RB", "CHI", 2018, 16, 233.9, 1, 1, 0, 444, 3, 71, 725, 5],
  ["Kareem Hunt", "RB", "KC", 2018, 11, 230.2, 0, 0, 0, 824, 7, 26, 378, 7],
  ["Phillip Lindsay", "RB", "DEN", 2018, 15, 222.8, 0, 0, 0, 1037, 9, 35, 241, 1],
  ["Kenyan Drake", "RB", "MIA", 2018, 16, 206.2, 0, 0, 0, 535, 4, 53, 477, 5],
  ["Chris Carson", "RB", "SEA", 2018, 14, 201.4, 0, 0, 0, 1151, 9, 20, 163, 0],
  ["Derrick Henry", "RB", "TEN", 2018, 16, 201.4, 14, 0, 0, 1059, 12, 15, 99, 0],
  ["Nick Chubb", "RB", "CLE", 2018, 16, 194.5, 0, 0, 0, 996, 8, 20, 149, 2],
  ["Tevin Coleman", "RB", "ATL", 2018, 16, 193.6, 0, 0, 0, 800, 4, 32, 276, 5],
  ["Adrian Peterson", "RB", "WAS", 2018, 16, 189, 0, 0, 0, 1042, 7, 20, 208, 1],
  ["Jordan Howard", "RB", "CHI", 2018, 16, 180, 0, 0, 0, 935, 9, 20, 145, 0],
  ["Marlon Mack", "RB", "IND", 2018, 12, 178.1, 0, 0, 0, 908, 9, 17, 103, 1],
  ["T.J. Yeldon", "RB", "JAX", 2018, 14, 173.1, 0, 0, 0, 414, 1, 55, 487, 4],
  ["Lamar Miller", "RB", "HOU", 2018, 14, 172.6, 0, 0, 0, 973, 5, 25, 163, 1],
  ["Aaron Jones", "RB", "GB", 2018, 12, 171.4, 0, 0, 0, 728, 8, 26, 206, 1],
  ["Austin Ekeler", "RB", "LAC", 2018, 14, 168.8, 0, 0, 0, 554, 3, 39, 404, 3],
  ["Matt Breida", "RB", "SF", 2018, 14, 162.5, 0, 0, 0, 814, 3, 27, 261, 2],
  ["Nyheim Hines", "RB", "IND", 2018, 16, 160.9, 0, 0, 0, 314, 2, 63, 425, 2],
  ["Dion Lewis", "RB", "TEN", 2018, 16, 160.7, 0, 0, 0, 517, 1, 59, 400, 1],
  ["Jalen Richard", "RB", "OAK", 2018, 16, 156.6, 0, 0, 0, 259, 1, 68, 607, 0],
  ["Dalvin Cook", "RB", "MIN", 2018, 11, 152, 0, 0, 0, 615, 2, 40, 305, 2],
  ["Tyreek Hill", "WR", "KC", 2018, 16, 334, 0, 0, 0, 151, 1, 87, 1479, 12],
  ["DeAndre Hopkins", "WR", "HOU", 2018, 16, 333.5, 0, 0, 0, -7, 0, 115, 1572, 11],
  ["Davante Adams", "WR", "GB", 2018, 15, 329.6, 0, 0, 0, 0, 0, 111, 1386, 13],
  ["Julio Jones", "WR", "ATL", 2018, 16, 325.9, 0, 0, 0, 12, 0, 113, 1677, 8],
  ["Antonio Brown", "WR", "PIT", 2018, 15, 323.7, 0, 0, 0, 0, 0, 104, 1297, 15],
  ["Michael Thomas", "WR", "NO", 2018, 16, 315.5, 0, 0, 0, 0, 0, 125, 1405, 9],
  ["Adam Thielen", "WR", "MIN", 2018, 16, 307.3, 0, 0, 0, 30, 0, 113, 1373, 9],
  ["JuJu Smith-Schuster", "WR", "PIT", 2018, 16, 296.9, 0, 0, 0, 13, 0, 111, 1426, 7],
  ["Mike Evans", "WR", "TB", 2018, 16, 284.4, 0, 0, 0, 0, 0, 86, 1524, 8],
  ["Stefon Diggs", "WR", "MIN", 2018, 15, 266.3, 0, 0, 0, 62, 0, 102, 1021, 9],
  ["Robert Woods", "WR", "LAR", 2018, 16, 265.6, 0, 0, 0, 157, 1, 86, 1219, 6],
  ["Keenan Allen", "WR", "LAC", 2018, 15, 260.1, 0, 0, 0, 75, 0, 97, 1196, 6],
  ["Brandin Cooks", "WR", "LAR", 2018, 15, 243.2, 0, 0, 0, 68, 1, 80, 1204, 5],
  ["T.Y. Hilton", "WR", "IND", 2018, 14, 239, 0, 0, 0, 0, 0, 76, 1270, 6],
  ["Odell Beckham", "WR", "NYG", 2018, 12, 232.3, 106, 2, 0, 19, 0, 77, 1052, 6],
  ["Tyler Lockett", "WR", "SEA", 2018, 16, 222.4, 0, 0, 0, 69, 0, 57, 965, 10],
  ["Tyler Boyd", "WR", "CIN", 2018, 14, 221.1, 0, 0, 0, 3, 0, 76, 1028, 7],
  ["Jarvis Landry", "WR", "CLE", 2018, 16, 217.1, 63, 0, 0, 60, 1, 81, 976, 4],
  ["Amari Cooper", "WR", "DAL", 2018, 15, 215.5, 0, 0, 0, 20, 0, 75, 1005, 7],
  ["Julian Edelman", "WR", "NE", 2018, 12, 207.4, 43, 0, 0, 107, 0, 74, 850, 6],
  ["Kenny Golladay", "WR", "DET", 2018, 15, 207.1, 0, 0, 0, 8, 0, 70, 1063, 5],
  ["Calvin Ridley", "WR", "ATL", 2018, 16, 206.8, 0, 0, 0, 27, 0, 64, 821, 10],
  ["Emmanuel Sanders", "WR", "DEN", 2018, 12, 198.2, 28, 1, 0, 53, 1, 71, 868, 4],
  ["Adam Humphries", "WR", "TB", 2018, 16, 188.7, 0, 0, 0, 11, 0, 76, 816, 5],
  ["Larry Fitzgerald", "WR", "ARI", 2018, 16, 185.7, 32, 1, 0, 0, 0, 69, 734, 6],
  ["Alshon Jeffery", "WR", "PHI", 2018, 13, 185.3, 0, 0, 0, 0, 0, 65, 843, 6],
  ["Chris Godwin", "WR", "TB", 2018, 16, 185.2, 0, 0, 0, 0, 0, 59, 842, 7],
  ["Corey Davis", "WR", "TEN", 2018, 16, 183.6, 0, 0, 0, 55, 0, 65, 891, 4],
  ["Golden Tate", "WR", "PHI", 2018, 15, 182.9, 0, 0, 0, 34, 0, 74, 795, 4],
  ["Sterling Shepard", "WR", "NYG", 2018, 16, 182.5, 0, 0, 0, 33, 0, 66, 872, 4],
  ["Mohamed Sanu", "WR", "ATL", 2018, 16, 182.4, 5, 1, 0, 44, 0, 66, 838, 4],
  ["Dede Westbrook", "WR", "JAX", 2018, 16, 181.5, 0, 0, 0, 98, 0, 66, 717, 5],
  ["Mike Williams", "WR", "LAC", 2018, 16, 180.2, 0, 0, 0, 28, 1, 43, 664, 10],
  ["Nelson Agholor", "WR", "PHI", 2018, 16, 165.4, 15, 0, 0, 32, 0, 64, 736, 4],
  ["Zay Jones", "WR", "BUF", 2018, 16, 165.2, 0, 0, 0, 0, 0, 56, 652, 7],
  ["D.J. Moore", "WR", "CAR", 2018, 16, 159, 0, 0, 0, 172, 0, 55, 788, 2],
  ["Travis Kelce", "TE", "KC", 2018, 16, 294.6, 0, 0, 0, 0, 0, 103, 1336, 10],
  ["Zach Ertz", "TE", "PHI", 2018, 16, 280.3, 0, 0, 0, 0, 0, 116, 1163, 8],
  ["George Kittle", "TE", "SF", 2018, 16, 258.7, 0, 0, 0, 10, 0, 88, 1377, 5],
  ["Eric Ebron", "TE", "IND", 2018, 16, 222.2, 0, 0, 0, -8, 1, 66, 750, 13],
  ["Jared Cook", "TE", "OAK", 2018, 16, 193.6, 0, 0, 0, 0, 0, 68, 896, 6],
  ["Austin Hooper", "TE", "ATL", 2018, 16, 163, 0, 0, 0, 0, 0, 71, 660, 4],
  ["Kyle Rudolph", "TE", "MIN", 2018, 16, 151.4, 0, 0, 0, 0, 0, 64, 634, 4],
  ["Trey Burton", "TE", "CHI", 2018, 16, 147.1, 0, 0, 0, 2, 0, 54, 569, 6],
  ["David Njoku", "TE", "CLE", 2018, 15, 143.9, 0, 0, 0, 0, 0, 56, 639, 4],
  ["Vance McDonald", "TE", "PIT", 2018, 15, 133, 0, 0, 0, 0, 0, 50, 610, 4],
  ["Rob Gronkowski", "TE", "NE", 2018, 13, 131.2, 0, 0, 0, 0, 0, 47, 682, 3],
  ["Jimmy Graham", "TE", "GB", 2018, 16, 130.6, 0, 0, 0, 0, 0, 55, 636, 2],
  ["Lamar Jackson", "QB", "BAL", 2019, 15, 415.7, 3127, 36, 6, 1206, 7, 0, 0, 0],
  ["Dak Prescott", "QB", "DAL", 2019, 16, 337.8, 4902, 30, 11, 277, 3, 0, 0, 0],
  ["Russell Wilson", "QB", "SEA", 2019, 16, 328.6, 4110, 31, 5, 342, 3, 0, 0, 0],
  ["Deshaun Watson", "QB", "HOU", 2019, 15, 321, 3852, 26, 12, 413, 7, 1, 6, 1],
  ["Jameis Winston", "QB", "TB", 2019, 16, 305.4, 5109, 33, 30, 250, 1, 0, 0, 0],
  ["Josh Allen", "QB", "BUF", 2019, 16, 288.6, 3089, 20, 9, 510, 9, 0, 0, 0],
  ["Patrick Mahomes", "QB", "KC", 2019, 14, 287, 4031, 26, 5, 218, 2, 0, 0, 0],
  ["Kyler Murray", "QB", "ARI", 2019, 16, 286, 3752, 20, 12, 539, 4, 0, 0, 0],
  ["Aaron Rodgers", "QB", "GB", 2019, 16, 278.4, 4002, 26, 4, 183, 1, 0, 0, 0],
  ["Carson Wentz", "QB", "PHI", 2019, 16, 275.9, 4039, 27, 7, 243, 1, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2019, 15, 267.3, 4466, 26, 14, 147, 1, 0, 0, 0],
  ["Tom Brady", "QB", "NE", 2019, 16, 263.7, 4057, 24, 8, 34, 3, 0, 0, 0],
  ["Jared Goff", "QB", "LAR", 2019, 16, 247.5, 4638, 22, 16, 40, 2, 0, 0, 0],
  ["Jimmy Garoppolo", "QB", "SF", 2019, 16, 247.3, 3978, 27, 13, 62, 1, 0, 0, 0],
  ["Derek Carr", "QB", "OAK", 2019, 16, 246.4, 4054, 21, 8, 82, 2, 0, 0, 0],
  ["Kirk Cousins", "QB", "MIN", 2019, 15, 244.4, 3603, 26, 6, 63, 1, 0, 0, 0],
  ["Christian McCaffrey", "RB", "CAR", 2019, 16, 471.2, 0, 0, 0, 1387, 15, 116, 1005, 4],
  ["Aaron Jones", "RB", "GB", 2019, 16, 314.8, 0, 0, 0, 1084, 16, 49, 474, 3],
  ["Ezekiel Elliott", "RB", "DAL", 2019, 16, 311.7, 0, 0, 0, 1357, 12, 54, 420, 2],
  ["Austin Ekeler", "RB", "LAC", 2019, 16, 311, 0, 0, 0, 557, 3, 92, 993, 8],
  ["Derrick Henry", "RB", "TEN", 2019, 15, 294.6, 0, 0, 0, 1540, 16, 18, 206, 2],
  ["Dalvin Cook", "RB", "MIN", 2019, 14, 292.4, 0, 0, 0, 1135, 13, 53, 519, 0],
  ["Leonard Fournette", "RB", "JAX", 2019, 15, 259.4, 0, 0, 0, 1152, 3, 76, 522, 0],
  ["Nick Chubb", "RB", "CLE", 2019, 16, 257.1, 0, 0, 0, 1513, 8, 36, 278, 0],
  ["Alvin Kamara", "RB", "NO", 2019, 14, 248.5, 13, 0, 0, 797, 5, 81, 533, 1],
  ["Saquon Barkley", "RB", "NYG", 2019, 13, 244.1, 0, 0, 0, 1003, 6, 52, 438, 2],
  ["Mark Ingram", "RB", "BAL", 2019, 15, 242.5, 0, 0, 0, 1018, 10, 26, 247, 5],
  ["Chris Carson", "RB", "SEA", 2019, 15, 232.6, 0, 0, 0, 1230, 7, 37, 266, 2],
  ["Joe Mixon", "RB", "CIN", 2019, 16, 225.4, 0, 0, 0, 1137, 5, 35, 287, 3],
  ["Todd Gurley", "RB", "LAR", 2019, 15, 219.4, 0, 0, 0, 857, 12, 31, 207, 2],
  ["Miles Sanders", "RB", "PHI", 2019, 16, 218.7, 0, 0, 0, 818, 3, 50, 509, 3],
  ["Kenyan Drake", "RB", "ARI", 2019, 14, 217, 0, 0, 0, 785, 8, 50, 345, 0],
  ["Le'Veon Bell", "RB", "NYJ", 2019, 15, 215, 0, 0, 0, 789, 3, 66, 461, 1],
  ["James White", "RB", "NE", 2019, 15, 202.2, 35, 0, 0, 263, 1, 72, 645, 5],
  ["Phillip Lindsay", "RB", "DEN", 2019, 16, 197.7, 0, 0, 0, 1011, 7, 35, 196, 0],
  ["Devonta Freeman", "RB", "ATL", 2019, 14, 197.6, 0, 0, 0, 656, 2, 59, 410, 4],
  ["Josh Jacobs", "RB", "OAK", 2019, 13, 191.6, 0, 0, 0, 1150, 7, 20, 166, 0],
  ["Marlon Mack", "RB", "IND", 2019, 14, 181.3, 0, 0, 0, 1091, 8, 14, 82, 0],
  ["Melvin Gordon", "RB", "LAC", 2019, 12, 180.8, 0, 0, 0, 612, 8, 42, 296, 1],
  ["David Montgomery", "RB", "CHI", 2019, 16, 170.4, 0, 0, 0, 889, 6, 25, 185, 1],
  ["Raheem Mostert", "RB", "SF", 2019, 15, 167.2, 0, 0, 0, 772, 8, 14, 180, 2],
  ["Ronald Jones", "RB", "TB", 2019, 16, 166.3, 0, 0, 0, 724, 6, 31, 309, 0],
  ["Tarik Cohen", "RB", "CHI", 2019, 16, 163.9, 0, 0, 0, 213, 0, 79, 456, 3],
  ["Latavius Murray", "RB", "NO", 2019, 16, 157.2, 0, 0, 0, 637, 5, 34, 235, 1],
  ["Duke Johnson", "RB", "HOU", 2019, 16, 154, 0, 0, 0, 410, 2, 44, 410, 3],
  ["Carlos Hyde", "RB", "HOU", 2019, 16, 153.2, 0, 0, 0, 1070, 6, 10, 42, 0],
  ["Michael Thomas", "WR", "NO", 2019, 16, 374.6, 0, 0, 0, -9, 0, 149, 1725, 9],
  ["Chris Godwin", "WR", "TB", 2019, 14, 276.1, 0, 0, 0, 8, 0, 86, 1333, 9],
  ["Julio Jones", "WR", "ATL", 2019, 15, 274.1, 0, 0, 0, -3, 0, 99, 1394, 6],
  ["Cooper Kupp", "WR", "LAR", 2019, 16, 270.5, 0, 0, 0, 4, 0, 94, 1161, 10],
  ["DeAndre Hopkins", "WR", "HOU", 2019, 15, 268.5, 6, 1, 1, 18, 0, 104, 1165, 7],
  ["Keenan Allen", "WR", "LAC", 2019, 16, 261.5, 0, 0, 0, 16, 0, 104, 1199, 6],
  ["Julian Edelman", "WR", "NE", 2019, 16, 256.3, 47, 1, 0, 27, 0, 100, 1117, 6],
  ["Allen Robinson", "WR", "CHI", 2019, 16, 254.9, 0, 0, 0, 2, 0, 98, 1147, 7],
  ["Kenny Golladay", "WR", "DET", 2019, 16, 248, 0, 0, 0, 0, 0, 65, 1190, 11],
  ["Amari Cooper", "WR", "DAL", 2019, 16, 246.5, 0, 0, 0, 6, 0, 79, 1189, 8],
  ["DeVante Parker", "WR", "MIA", 2019, 16, 246.2, 0, 0, 0, 0, 0, 72, 1202, 9],
  ["Jarvis Landry", "WR", "CLE", 2019, 16, 237.4, 0, 0, 0, 10, 0, 83, 1174, 6],
  ["Tyler Lockett", "WR", "SEA", 2019, 16, 235.2, 0, 0, 0, -5, 0, 82, 1057, 8],
  ["Robert Woods", "WR", "LAR", 2019, 15, 232.9, 0, 0, 0, 115, 1, 90, 1134, 2],
  ["Mike Evans", "WR", "TB", 2019, 13, 232.7, 0, 0, 0, 0, 0, 67, 1157, 8],
  ["D.J. Moore", "WR", "CAR", 2019, 15, 230.5, 0, 0, 0, 40, 0, 87, 1175, 4],
  ["D.J. Chark", "WR", "JAX", 2019, 15, 225.8, 0, 0, 0, 20, 0, 73, 1008, 8],
  ["Tyler Boyd", "WR", "CIN", 2019, 16, 222.9, 0, 0, 0, 23, 0, 90, 1046, 5],
  ["Courtland Sutton", "WR", "DEN", 2019, 16, 222.4, 38, 0, 0, 17, 0, 72, 1112, 6],
  ["John Brown", "WR", "BUF", 2019, 15, 219.8, 28, 1, 0, 7, 0, 72, 1060, 6],
  ["A.J. Brown", "WR", "TEN", 2019, 16, 217.1, 0, 0, 0, 60, 1, 52, 1051, 8],
  ["Odell Beckham", "WR", "CLE", 2019, 16, 215.9, 20, 0, 0, 10, 0, 75, 1091, 5],
  ["Davante Adams", "WR", "GB", 2019, 12, 212.7, 0, 0, 0, 0, 0, 83, 997, 5],
  ["Michael Gallup", "WR", "DAL", 2019, 14, 212.7, 0, 0, 0, 0, 0, 66, 1107, 6],
  ["Stefon Diggs", "WR", "MIN", 2019, 15, 212.1, 0, 0, 0, 61, 0, 63, 1130, 6],
  ["Jamison Crowder", "WR", "NYJ", 2019, 16, 197.7, 0, 0, 0, 4, 0, 78, 833, 6],
  ["Calvin Ridley", "WR", "ATL", 2019, 13, 197, 0, 0, 0, 34, 0, 63, 866, 7],
  ["Marvin Jones", "WR", "DET", 2019, 13, 193.9, 0, 0, 0, 0, 0, 62, 779, 9],
  ["Terry McLaurin", "WR", "WAS", 2019, 14, 191.9, 0, 0, 0, 0, 0, 58, 919, 7],
  ["Emmanuel Sanders", "WR", "SF", 2019, 17, 190.3, 35, 1, 0, 0, 0, 66, 869, 5],
  ["Deebo Samuel", "WR", "SF", 2019, 15, 189.1, 0, 0, 0, 159, 3, 57, 802, 3],
  ["Tyreek Hill", "WR", "KC", 2019, 12, 188.3, 0, 0, 0, 23, 0, 58, 860, 7],
  ["DK Metcalf", "WR", "SEA", 2019, 16, 187.1, 0, 0, 0, 11, 0, 58, 900, 7],
  ["Cole Beasley", "WR", "BUF", 2019, 15, 184.8, 0, 0, 0, 0, 0, 67, 778, 6],
  ["Larry Fitzgerald", "WR", "ARI", 2019, 16, 178.5, 0, 0, 0, 0, 0, 73, 835, 4],
  ["Curtis Samuel", "WR", "CAR", 2019, 16, 171.7, 0, 0, 0, 130, 1, 54, 627, 6],
  ["Travis Kelce", "TE", "KC", 2019, 16, 254.3, 0, 0, 0, 4, 1, 97, 1229, 5],
  ["George Kittle", "TE", "SF", 2019, 14, 222.5, 0, 0, 0, 22, 0, 85, 1053, 5],
  ["Darren Waller", "TE", "OAK", 2019, 16, 221, 0, 0, 0, 5, 0, 90, 1145, 3],
  ["Zach Ertz", "TE", "PHI", 2019, 15, 215.6, 0, 0, 0, 0, 0, 88, 916, 6],
  ["Mark Andrews", "TE", "BAL", 2019, 15, 207.2, 0, 0, 0, 0, 0, 64, 852, 10],
  ["Austin Hooper", "TE", "ATL", 2019, 13, 191.7, 0, 0, 0, 0, 0, 75, 787, 6],
  ["Jared Cook", "TE", "NO", 2019, 14, 167.5, 0, 0, 0, 0, 0, 43, 705, 9],
  ["Tyler Higbee", "TE", "LAR", 2019, 14, 160.4, 0, 0, 0, 0, 0, 69, 734, 3],
  ["Hunter Henry", "TE", "LAC", 2019, 12, 150.2, 0, 0, 0, 0, 0, 55, 652, 5],
  ["Dallas Goedert", "TE", "PHI", 2019, 15, 144.7, 0, 0, 0, 0, 0, 58, 607, 5],
  ["Jason Witten", "TE", "DAL", 2019, 16, 139.9, 0, 0, 0, 0, 0, 63, 529, 4],
  ["Mike Gesicki", "TE", "MIA", 2019, 15, 136, 0, 0, 0, 0, 0, 51, 570, 5],
  ["Josh Allen", "QB", "BUF", 2020, 16, 396.1, 4544, 37, 10, 421, 8, 1, 12, 1],
  ["Aaron Rodgers", "QB", "GB", 2020, 16, 383.3, 4299, 48, 5, 149, 3, 1, -6, 0],
  ["Kyler Murray", "QB", "ARI", 2020, 16, 378.7, 3971, 26, 12, 819, 11, 0, 0, 0],
  ["Patrick Mahomes", "QB", "KC", 2020, 15, 374.4, 4740, 38, 6, 308, 2, 0, 0, 0],
  ["Deshaun Watson", "QB", "HOU", 2020, 16, 369.3, 4823, 33, 7, 444, 3, 0, 0, 0],
  ["Russell Wilson", "QB", "SEA", 2020, 16, 359.8, 4212, 40, 13, 513, 2, 0, 0, 0],
  ["Ryan Tannehill", "QB", "TEN", 2020, 16, 348.4, 3819, 34, 7, 266, 7, 1, 0, 0],
  ["Tom Brady", "QB", "TB", 2020, 16, 337.9, 4633, 40, 12, 6, 3, 0, 0, 0],
  ["Justin Herbert", "QB", "LAC", 2020, 15, 332.8, 4336, 31, 10, 234, 5, 0, 0, 0],
  ["Lamar Jackson", "QB", "BAL", 2020, 15, 332.8, 2757, 26, 9, 1005, 7, 0, 0, 0],
  ["Kirk Cousins", "QB", "MIN", 2020, 16, 306.2, 4265, 35, 13, 156, 1, 0, 0, 0],
  ["Matt Ryan", "QB", "ATL", 2020, 16, 282.4, 4581, 26, 11, 92, 2, 0, 0, 0],
  ["Derek Carr", "QB", "LV", 2020, 16, 272.1, 4103, 27, 9, 140, 3, 0, 0, 0],
  ["Ben Roethlisberger", "QB", "PIT", 2020, 15, 267.2, 3803, 33, 10, 11, 0, 0, 0, 0],
  ["Cam Newton", "QB", "NE", 2020, 15, 261, 2657, 8, 10, 592, 12, 2, 35, 1],
  ["Matthew Stafford", "QB", "DET", 2020, 16, 260.6, 4084, 26, 10, 112, 0, 0, 0, 0],
  ["Alvin Kamara", "RB", "NO", 2020, 15, 377.8, 0, 0, 0, 932, 16, 83, 756, 5],
  ["Dalvin Cook", "RB", "MIN", 2020, 14, 337.8, 0, 0, 0, 1557, 16, 44, 361, 1],
  ["Derrick Henry", "RB", "TEN", 2020, 16, 333.1, 0, 0, 0, 2027, 17, 19, 114, 0],
  ["David Montgomery", "RB", "CHI", 2020, 15, 264.8, 0, 0, 0, 1070, 8, 54, 438, 2],
  ["Aaron Jones", "RB", "GB", 2020, 14, 258.9, 0, 0, 0, 1104, 9, 47, 355, 2],
  ["Jonathan Taylor", "RB", "IND", 2020, 15, 252.8, 0, 0, 0, 1169, 11, 36, 299, 1],
  ["James Robinson", "RB", "JAX", 2020, 14, 250.4, 0, 0, 0, 1070, 7, 49, 344, 3],
  ["Josh Jacobs", "RB", "LV", 2020, 15, 231.3, 0, 0, 0, 1065, 12, 33, 238, 0],
  ["Ezekiel Elliott", "RB", "DAL", 2020, 15, 223.7, 0, 0, 0, 979, 6, 52, 338, 2],
  ["Kareem Hunt", "RB", "CLE", 2020, 16, 218.5, 0, 0, 0, 841, 6, 38, 304, 5],
  ["Nick Chubb", "RB", "CLE", 2020, 12, 207.7, 0, 0, 0, 1067, 12, 16, 150, 0],
  ["Mike Davis", "RB", "CAR", 2020, 14, 206.5, 0, 0, 0, 642, 6, 59, 373, 2],
  ["Antonio Gibson", "RB", "WAS", 2020, 14, 202.2, 0, 0, 0, 795, 11, 36, 247, 0],
  ["Melvin Gordon", "RB", "DEN", 2020, 15, 198.4, 0, 0, 0, 986, 9, 32, 158, 1],
  ["Nyheim Hines", "RB", "IND", 2020, 16, 193.2, 0, 0, 0, 380, 3, 63, 482, 4],
  ["Kenyan Drake", "RB", "ARI", 2020, 15, 192.2, 0, 0, 0, 955, 10, 25, 137, 0],
  ["J.D. McKissic", "RB", "WAS", 2020, 16, 191.4, 0, 0, 0, 365, 1, 80, 589, 2],
  ["D'Andre Swift", "RB", "DET", 2020, 13, 189.8, 0, 0, 0, 521, 8, 46, 357, 2],
  ["Chris Carson", "RB", "SEA", 2020, 12, 187.8, 0, 0, 0, 681, 5, 37, 287, 4],
  ["Ronald Jones", "RB", "TB", 2020, 14, 186.3, 0, 0, 0, 978, 7, 28, 165, 1],
  ["David Johnson", "RB", "HOU", 2020, 12, 179.5, 0, 0, 0, 691, 6, 33, 314, 2],
  ["Clyde Edwards-Helaire", "RB", "KC", 2020, 13, 176, 0, 0, 0, 803, 4, 36, 297, 1],
  ["Miles Sanders", "RB", "PHI", 2020, 12, 170.4, 0, 0, 0, 867, 6, 28, 197, 0],
  ["J.K. Dobbins", "RB", "BAL", 2020, 15, 168.5, 0, 0, 0, 805, 9, 18, 120, 0],
  ["Chase Edmonds", "RB", "ARI", 2020, 16, 168, 0, 0, 0, 448, 1, 53, 402, 4],
  ["Austin Ekeler", "RB", "LAC", 2020, 10, 165.3, 0, 0, 0, 530, 1, 54, 403, 2],
  ["James Conner", "RB", "PIT", 2020, 13, 164.6, 0, 0, 0, 721, 6, 35, 215, 0],
  ["Myles Gaskin", "RB", "MIA", 2020, 10, 164.2, 0, 0, 0, 584, 3, 41, 388, 2],
  ["Todd Gurley", "RB", "ATL", 2020, 15, 163.2, 0, 0, 0, 678, 9, 25, 164, 0],
  ["Giovani Bernard", "RB", "CIN", 2020, 16, 158.1, 0, 0, 0, 416, 3, 47, 355, 3],
  ["Davante Adams", "WR", "GB", 2020, 14, 358.4, 0, 0, 0, 0, 0, 115, 1374, 18],
  ["Tyreek Hill", "WR", "KC", 2020, 15, 328.9, 0, 0, 0, 123, 2, 87, 1276, 15],
  ["Stefon Diggs", "WR", "BUF", 2020, 16, 328.6, 0, 0, 0, 1, 0, 127, 1535, 8],
  ["DeAndre Hopkins", "WR", "ARI", 2020, 16, 287.8, 0, 0, 0, 1, 0, 115, 1407, 6],
  ["Calvin Ridley", "WR", "ATL", 2020, 15, 281.5, 0, 0, 0, 1, 0, 90, 1374, 9],
  ["Justin Jefferson", "WR", "MIN", 2020, 16, 274.2, 0, 0, 0, 2, 0, 88, 1400, 7],
  ["DK Metcalf", "WR", "SEA", 2020, 16, 273.3, 0, 0, 0, 0, 0, 83, 1303, 10],
  ["Tyler Lockett", "WR", "SEA", 2020, 16, 265.4, 0, 0, 0, 0, 0, 100, 1054, 10],
  ["Allen Robinson", "WR", "CHI", 2020, 16, 262.9, 0, 0, 0, -1, 0, 102, 1250, 6],
  ["Adam Thielen", "WR", "MIN", 2020, 15, 254, 0, 0, 0, 15, 0, 74, 925, 14],
  ["Mike Evans", "WR", "TB", 2020, 16, 248.6, 0, 0, 0, 0, 0, 70, 1006, 13],
  ["A.J. Brown", "WR", "TEN", 2020, 14, 247.5, 0, 0, 0, 0, 0, 70, 1075, 11],
  ["Keenan Allen", "WR", "LAC", 2020, 14, 245.1, 0, 0, 0, -1, 0, 100, 992, 8],
  ["Robert Woods", "WR", "LAR", 2020, 16, 245.1, 0, 0, 0, 155, 2, 90, 936, 6],
  ["Amari Cooper", "WR", "DAL", 2020, 16, 236.8, 0, 0, 0, 14, 0, 92, 1114, 5],
  ["JuJu Smith-Schuster", "WR", "PIT", 2020, 16, 234.1, 0, 0, 0, 0, 0, 97, 831, 9],
  ["Brandin Cooks", "WR", "HOU", 2020, 15, 232, 0, 0, 0, 0, 0, 81, 1150, 6],
  ["Marvin Jones", "WR", "DET", 2020, 16, 227.8, 0, 0, 0, 0, 0, 76, 978, 9],
  ["Robbie Chosen", "WR", "CAR", 2020, 16, 224.1, 0, 0, 0, 15, 0, 95, 1096, 3],
  ["Diontae Johnson", "WR", "PIT", 2020, 15, 223.8, 0, 0, 0, 15, 0, 88, 923, 7],
  ["Terry McLaurin", "WR", "WAS", 2020, 15, 223.8, 0, 0, 0, 30, 0, 87, 1118, 4],
  ["CeeDee Lamb", "WR", "DAL", 2020, 16, 217.7, 0, 0, 0, 82, 1, 74, 935, 5],
  ["Chase Claypool", "WR", "PIT", 2020, 16, 214.9, 0, 0, 0, 16, 2, 62, 873, 9],
  ["Curtis Samuel", "WR", "CAR", 2020, 15, 212.1, 0, 0, 0, 200, 2, 77, 851, 3],
  ["D.J. Moore", "WR", "CAR", 2020, 15, 211.5, 0, 0, 0, 22, 0, 66, 1193, 4],
  ["Cooper Kupp", "WR", "LAR", 2020, 15, 210.7, 0, 0, 0, 33, 0, 92, 974, 3],
  ["Cole Beasley", "WR", "BUF", 2020, 15, 207.5, 20, 1, 0, 0, 0, 82, 967, 4],
  ["Tee Higgins", "WR", "CIN", 2020, 15, 194.6, 0, 0, 0, 28, 0, 67, 908, 6],
  ["Tyler Boyd", "WR", "CIN", 2020, 15, 192.6, 16, 0, 0, 49, 0, 79, 841, 4],
  ["Corey Davis", "WR", "TEN", 2020, 14, 191.4, 0, 0, 0, 0, 0, 65, 984, 5],
  ["Chris Godwin", "WR", "TB", 2020, 12, 191, 0, 0, 0, 0, 0, 65, 840, 7],
  ["Will Fuller", "WR", "HOU", 2020, 11, 188.9, 0, 0, 0, 0, 0, 53, 879, 8],
  ["Jarvis Landry", "WR", "CLE", 2020, 15, 188, 74, 1, 0, 10, 1, 72, 840, 3],
  ["Nelson Agholor", "WR", "LV", 2020, 16, 185.6, 0, 0, 0, 0, 0, 48, 896, 8],
  ["Brandon Aiyuk", "WR", "SF", 2020, 12, 184.5, 0, 0, 0, 77, 2, 60, 748, 5],
  ["Marquise Brown", "WR", "BAL", 2020, 16, 183, 0, 0, 0, 1, 0, 58, 769, 8],
  ["Travis Kelce", "TE", "KC", 2020, 15, 312.8, 4, 0, 0, 0, 0, 105, 1416, 11],
  ["Darren Waller", "TE", "LV", 2020, 16, 278.6, 0, 0, 0, 0, 0, 107, 1196, 9],
  ["Logan Thomas", "TE", "WAS", 2020, 16, 176.6, 28, 0, 0, 5, 0, 72, 670, 6],
  ["Robert Tonyan", "TE", "GB", 2020, 15, 176.6, 0, 0, 0, 0, 0, 52, 586, 11],
  ["T.J. Hockenson", "TE", "DET", 2020, 16, 175.3, 0, 0, 0, 0, 0, 67, 723, 6],
  ["Mark Andrews", "TE", "BAL", 2020, 14, 170.1, 0, 0, 0, 0, 0, 58, 701, 7],
  ["Mike Gesicki", "TE", "MIA", 2020, 15, 159.3, 0, 0, 0, 0, 0, 53, 703, 6],
  ["Rob Gronkowski", "TE", "TB", 2020, 16, 149.3, 0, 0, 0, 0, 0, 45, 623, 7],
  ["Noah Fant", "TE", "DEN", 2020, 14, 149.3, 0, 0, 0, 0, 0, 62, 673, 3],
  ["Hayden Hurst", "TE", "ATL", 2020, 16, 149.1, 0, 0, 0, 0, 0, 56, 571, 6],
  ["Dalton Schultz", "TE", "DAL", 2020, 16, 146.5, 0, 0, 0, 0, 0, 63, 615, 4],
  ["Hunter Henry", "TE", "LAC", 2020, 14, 145.3, 0, 0, 0, 0, 0, 60, 613, 4],
  ["Josh Allen", "QB", "BUF", 2021, 17, 402.6, 4407, 36, 15, 763, 6, 0, 0, 0],
  ["Justin Herbert", "QB", "LAC", 2021, 17, 382.8, 5014, 38, 15, 302, 3, 0, 0, 0],
  ["Tom Brady", "QB", "TB", 2021, 17, 374.7, 5316, 43, 12, 81, 2, 0, 0, 0],
  ["Patrick Mahomes", "QB", "KC", 2021, 17, 361.7, 4839, 37, 13, 381, 2, 0, 0, 0],
  ["Aaron Rodgers", "QB", "GB", 2021, 16, 333.3, 4115, 37, 4, 101, 3, 1, -4, 0],
  ["Matthew Stafford", "QB", "LAR", 2021, 17, 329.7, 4886, 41, 17, 43, 0, 0, 0, 0],
  ["Dak Prescott", "QB", "DAL", 2021, 16, 320.6, 4449, 37, 10, 146, 1, 0, 0, 0],
  ["Joe Burrow", "QB", "CIN", 2021, 16, 314.2, 4611, 34, 14, 118, 2, 0, 0, 0],
  ["Jalen Hurts", "QB", "PHI", 2021, 15, 312.2, 3144, 16, 9, 784, 10, 0, 0, 0],
  ["Kirk Cousins", "QB", "MIN", 2021, 16, 300.3, 4221, 33, 7, 115, 1, 0, 0, 0],
  ["Kyler Murray", "QB", "ARI", 2021, 14, 299.8, 3787, 24, 10, 423, 5, 0, 0, 0],
  ["Ryan Tannehill", "QB", "TEN", 2021, 17, 272.4, 3734, 22, 14, 270, 7, 0, 0, 0],
  ["Carson Wentz", "QB", "IND", 2021, 17, 258, 3563, 27, 7, 215, 1, 0, 0, 0],
  ["Derek Carr", "QB", "LV", 2021, 17, 257, 4804, 23, 14, 108, 0, 0, 0, 0],
  ["Russell Wilson", "QB", "SEA", 2021, 14, 242.8, 3113, 25, 6, 183, 2, 0, 0, 0],
  ["Lamar Jackson", "QB", "BAL", 2021, 12, 240, 2882, 16, 13, 767, 2, 0, 0, 0],
  ["Jonathan Taylor", "RB", "IND", 2021, 17, 373.1, 0, 0, 0, 1811, 18, 40, 360, 2],
  ["Austin Ekeler", "RB", "LAC", 2021, 16, 343.8, 0, 0, 0, 911, 12, 70, 647, 8],
  ["Najee Harris", "RB", "PIT", 2021, 17, 300.7, 0, 0, 0, 1200, 7, 74, 467, 3],
  ["Joe Mixon", "RB", "CIN", 2021, 16, 287.9, 0, 0, 0, 1205, 13, 42, 314, 3],
  ["James Conner", "RB", "ARI", 2021, 15, 257.7, 0, 0, 0, 752, 15, 37, 375, 3],
  ["Leonard Fournette", "RB", "TB", 2021, 14, 255.6, 0, 0, 0, 812, 8, 69, 454, 2],
  ["Ezekiel Elliott", "RB", "DAL", 2021, 17, 252.1, 4, 0, 0, 1002, 10, 47, 287, 2],
  ["Alvin Kamara", "RB", "NO", 2021, 13, 234.7, 0, 0, 0, 898, 4, 47, 439, 5],
  ["Cordarrelle Patterson", "RB", "ATL", 2021, 16, 234.6, 0, 0, 0, 618, 6, 52, 548, 5],
  ["Antonio Gibson", "RB", "WAS", 2021, 16, 229.1, 0, 0, 0, 1037, 7, 42, 294, 3],
  ["Aaron Jones", "RB", "GB", 2021, 15, 229, 0, 0, 0, 799, 4, 52, 391, 6],
  ["Josh Jacobs", "RB", "LV", 2021, 15, 226, 0, 0, 0, 872, 9, 54, 348, 0],
  ["Nick Chubb", "RB", "CLE", 2021, 14, 215.3, 0, 0, 0, 1259, 8, 20, 174, 1],
  ["Damien Harris", "RB", "NE", 2021, 15, 210.1, 0, 0, 0, 929, 15, 18, 132, 0],
  ["D'Andre Swift", "RB", "DET", 2021, 13, 208.9, 0, 0, 0, 617, 5, 62, 452, 2],
  ["Dalvin Cook", "RB", "MIN", 2021, 13, 206.3, 0, 0, 0, 1159, 6, 34, 224, 0],
  ["Javonte Williams", "RB", "DEN", 2021, 17, 204.9, 0, 0, 0, 903, 4, 43, 316, 3],
  ["Devin Singletary", "RB", "BUF", 2021, 17, 197.8, 0, 0, 0, 870, 7, 40, 228, 1],
  ["Darrel Williams", "RB", "KC", 2021, 17, 196, 0, 0, 0, 558, 6, 47, 452, 2],
  ["Melvin Gordon", "RB", "DEN", 2021, 16, 195.1, 0, 0, 0, 918, 8, 28, 213, 2],
  ["David Montgomery", "RB", "CHI", 2021, 13, 195, 0, 0, 1, 849, 7, 42, 301, 0],
  ["Derrick Henry", "RB", "TEN", 2021, 8, 193.3, 5, 1, 0, 937, 10, 18, 154, 0],
  ["A.J. Dillon", "RB", "GB", 2021, 17, 185.6, 0, 0, 0, 803, 5, 34, 313, 2],
  ["James Robinson", "RB", "JAX", 2021, 14, 173.9, 0, 0, 0, 767, 8, 31, 222, 0],
  ["Myles Gaskin", "RB", "MIA", 2021, 17, 173.6, 0, 0, 0, 612, 3, 49, 234, 4],
  ["Elijah Mitchell", "RB", "SF", 2021, 11, 165, 0, 0, 0, 963, 5, 19, 137, 1],
  ["Darrell Henderson", "RB", "LAR", 2021, 12, 163.4, 0, 0, 0, 688, 5, 29, 176, 3],
  ["Tony Pollard", "RB", "DAL", 2021, 15, 162.6, 0, 0, 0, 719, 2, 39, 337, 0],
  ["Michael Carter", "RB", "NYJ", 2021, 14, 154.4, 0, 0, 0, 639, 4, 36, 325, 0],
  ["Saquon Barkley", "RB", "NYG", 2021, 13, 148.6, 0, 0, 0, 593, 2, 41, 263, 2],
  ["Cooper Kupp", "WR", "LAR", 2021, 17, 439.5, 0, 0, 0, 18, 0, 145, 1947, 16],
  ["Davante Adams", "WR", "GB", 2021, 16, 344.3, 0, 0, 0, 0, 0, 123, 1553, 11],
  ["Deebo Samuel", "WR", "SF", 2021, 16, 339, 24, 1, 0, 365, 8, 77, 1405, 6],
  ["Justin Jefferson", "WR", "MIN", 2021, 17, 330.4, 35, 0, 0, 14, 0, 108, 1616, 10],
  ["Ja'Marr Chase", "WR", "CIN", 2021, 17, 304.6, 0, 0, 0, 21, 0, 81, 1455, 13],
  ["Tyreek Hill", "WR", "KC", 2021, 17, 296.5, 0, 0, 0, 96, 0, 111, 1239, 9],
  ["Stefon Diggs", "WR", "BUF", 2021, 17, 285.5, 0, 0, 0, 0, 0, 103, 1225, 10],
  ["Diontae Johnson", "WR", "PIT", 2021, 16, 274.4, 0, 0, 0, 53, 0, 107, 1161, 8],
  ["Mike Evans", "WR", "TB", 2021, 16, 262.5, 0, 0, 0, 10, 0, 74, 1035, 14],
  ["Hunter Renfrow", "WR", "LV", 2021, 17, 259.1, 0, 0, 0, 3, 0, 103, 1038, 9],
  ["Keenan Allen", "WR", "LAC", 2021, 16, 257.8, 0, 0, 0, 0, 0, 106, 1138, 6],
  ["Jaylen Waddle", "WR", "MIA", 2021, 16, 247.8, 0, 0, 0, 3, 1, 104, 1015, 6],
  ["Mike Williams", "WR", "LAC", 2021, 16, 246.6, 0, 0, 0, 0, 0, 76, 1146, 9],
  ["DK Metcalf", "WR", "SEA", 2021, 17, 244.3, 0, 0, 0, 6, 0, 75, 967, 12],
  ["Chris Godwin", "WR", "TB", 2021, 14, 242.4, 0, 0, 0, 21, 1, 98, 1103, 5],
  ["Tyler Lockett", "WR", "SEA", 2021, 16, 241.4, 0, 0, 0, 9, 0, 73, 1175, 8],
  ["Michael Pittman", "WR", "IND", 2021, 17, 238.6, 0, 0, 0, 44, 0, 88, 1082, 6],
  ["D.J. Moore", "WR", "CAR", 2021, 17, 237.5, 0, 0, 0, 48, 0, 93, 1157, 4],
  ["CeeDee Lamb", "WR", "DAL", 2021, 16, 232.8, 0, 0, 0, 76, 0, 79, 1102, 6],
  ["Brandin Cooks", "WR", "HOU", 2021, 16, 231.8, 0, 0, 0, 21, 0, 90, 1037, 6],
  ["Amon-Ra St. Brown", "WR", "DET", 2021, 16, 227.3, 0, 0, 0, 61, 1, 90, 912, 5],
  ["Marquise Brown", "WR", "BAL", 2021, 16, 226.3, 0, 0, 0, 5, 0, 91, 1008, 6],
  ["Darnell Mooney", "WR", "CHI", 2021, 17, 219.7, 0, 0, 0, 32, 1, 81, 1055, 4],
  ["Tee Higgins", "WR", "CIN", 2021, 14, 219.1, 0, 0, 0, 0, 0, 74, 1091, 6],
  ["Terry McLaurin", "WR", "WAS", 2021, 17, 213.5, 0, 0, 0, 12, 0, 77, 1053, 5],
  ["Christian Kirk", "WR", "ARI", 2021, 17, 207.6, 33, 0, 0, 11, 0, 77, 982, 5],
  ["Amari Cooper", "WR", "DAL", 2021, 15, 202.5, 0, 0, 0, 0, 0, 68, 865, 8],
  ["Adam Thielen", "WR", "MIN", 2021, 13, 199.8, 0, 0, 0, 2, 0, 67, 726, 10],
  ["Jakobi Meyers", "WR", "NE", 2021, 16, 186.3, 45, 0, 0, 9, 0, 83, 866, 2],
  ["DeVonta Smith", "WR", "PHI", 2021, 17, 185.6, 0, 0, 0, 0, 0, 64, 916, 5],
  ["Tyler Boyd", "WR", "CIN", 2021, 16, 183.8, 46, 0, 0, 22, 0, 67, 828, 5],
  ["A.J. Brown", "WR", "TEN", 2021, 13, 180.9, 0, 0, 0, 10, 0, 63, 869, 5],
  ["Kendrick Bourne", "WR", "NE", 2021, 17, 180.5, 25, 1, 0, 125, 0, 55, 800, 5],
  ["Marvin Jones", "WR", "JAX", 2021, 17, 180.2, 0, 0, 0, 0, 0, 73, 832, 4],
  ["Brandon Aiyuk", "WR", "SF", 2021, 16, 170.3, 0, 0, 0, 17, 0, 56, 826, 5],
  ["Van Jefferson", "WR", "LAR", 2021, 17, 168.2, 0, 0, 0, 20, 0, 50, 802, 6],
  ["Mark Andrews", "TE", "BAL", 2021, 17, 301.1, 0, 0, 0, 0, 0, 107, 1361, 9],
  ["Travis Kelce", "TE", "KC", 2021, 16, 262.8, 0, 0, 0, 3, 1, 92, 1125, 9],
  ["Dalton Schultz", "TE", "DAL", 2021, 17, 208.8, 0, 0, 0, 0, 0, 78, 808, 8],
  ["George Kittle", "TE", "SF", 2021, 14, 198, 0, 0, 0, 20, 0, 71, 910, 6],
  ["Zach Ertz", "TE", "ARI", 2021, 17, 180.7, 0, 0, 0, 4, 0, 74, 763, 5],
  ["Kyle Pitts", "TE", "ATL", 2021, 17, 176.6, 0, 0, 0, 0, 0, 68, 1026, 1],
  ["Rob Gronkowski", "TE", "TB", 2021, 12, 171.2, 0, 0, 0, 0, 0, 55, 802, 6],
  ["Dallas Goedert", "TE", "PHI", 2021, 15, 165, 0, 0, 0, 0, 0, 56, 830, 4],
  ["Mike Gesicki", "TE", "MIA", 2021, 17, 165, 0, 0, 0, 0, 0, 73, 780, 2],
  ["Hunter Henry", "TE", "NE", 2021, 16, 164.3, 0, 0, 0, 0, 0, 50, 603, 9],
  ["Dawson Knox", "TE", "BUF", 2021, 15, 163.7, 0, 0, 0, 0, 0, 49, 587, 9],
  ["Noah Fant", "TE", "DEN", 2021, 16, 159, 0, 0, 0, 0, 0, 68, 670, 4],
  ["Patrick Mahomes", "QB", "KC", 2022, 17, 417.4, 5250, 41, 12, 358, 4, 1, 6, 0],
  ["Josh Allen", "QB", "BUF", 2022, 16, 395.5, 4283, 35, 14, 762, 7, 0, 0, 0],
  ["Jalen Hurts", "QB", "PHI", 2022, 15, 378, 3701, 22, 6, 760, 13, 0, 0, 0],
  ["Joe Burrow", "QB", "CIN", 2022, 16, 350.7, 4475, 35, 12, 257, 5, 0, 0, 0],
  ["Geno Smith", "QB", "SEA", 2022, 17, 303.9, 4282, 30, 11, 366, 1, 0, 0, 0],
  ["Justin Fields", "QB", "CHI", 2022, 15, 296, 2242, 17, 11, 1143, 8, 0, 0, 0],
  ["Trevor Lawrence", "QB", "JAX", 2022, 17, 295.6, 4113, 25, 8, 291, 5, 0, 0, 0],
  ["Kirk Cousins", "QB", "MIN", 2022, 17, 291.6, 4547, 29, 14, 97, 2, 0, 0, 0],
  ["Daniel Jones", "QB", "NYG", 2022, 16, 289, 3205, 15, 5, 708, 7, 0, 0, 0],
  ["Jared Goff", "QB", "DET", 2022, 17, 284.3, 4438, 29, 7, 73, 0, 1, 5, 0],
  ["Justin Herbert", "QB", "LAC", 2022, 17, 281.3, 4739, 25, 10, 147, 0, 2, -10, 0],
  ["Tom Brady", "QB", "TB", 2022, 17, 271.7, 4694, 25, 9, -1, 1, 0, 0, 0],
  ["Aaron Rodgers", "QB", "GB", 2022, 17, 239.2, 3695, 26, 12, 94, 1, 0, 0, 0],
  ["Lamar Jackson", "QB", "BAL", 2022, 12, 236.1, 2242, 17, 7, 764, 3, 0, 0, 0],
  ["Tua Tagovailoa", "QB", "MIA", 2022, 13, 230.9, 3548, 25, 8, 70, 0, 0, 0, 0],
  ["Russell Wilson", "QB", "DEN", 2022, 15, 225.8, 3524, 16, 11, 277, 3, 1, 1, 0],
  ["Austin Ekeler", "RB", "LAC", 2022, 17, 372.7, 0, 0, 0, 915, 13, 107, 722, 5],
  ["Christian McCaffrey", "RB", "SF", 2022, 17, 356.4, 34, 1, 0, 1139, 8, 85, 741, 5],
  ["Josh Jacobs", "RB", "LV", 2022, 17, 328.3, 0, 0, 0, 1653, 12, 53, 400, 0],
  ["Derrick Henry", "RB", "TEN", 2022, 16, 302.8, 4, 1, 0, 1538, 13, 33, 398, 0],
  ["Saquon Barkley", "RB", "NYG", 2022, 16, 284, 0, 0, 0, 1312, 10, 57, 338, 0],
  ["Nick Chubb", "RB", "CLE", 2022, 17, 281.4, 0, 0, 0, 1525, 12, 27, 239, 1],
  ["Rhamondre Stevenson", "RB", "NE", 2022, 17, 249.1, 0, 0, 0, 1040, 5, 69, 421, 1],
  ["Tony Pollard", "RB", "DAL", 2022, 16, 248.8, 0, 0, 0, 1007, 9, 39, 371, 3],
  ["Aaron Jones", "RB", "GB", 2022, 17, 248.6, 0, 0, 0, 1121, 2, 59, 395, 5],
  ["Joe Mixon", "RB", "CIN", 2022, 14, 239.5, 0, 0, 0, 814, 7, 60, 441, 2],
  ["Dalvin Cook", "RB", "MIN", 2022, 17, 237.8, 0, 0, 0, 1173, 8, 39, 295, 2],
  ["Leonard Fournette", "RB", "TB", 2022, 16, 226.1, 0, 0, 1, 668, 3, 73, 523, 3],
  ["Jamaal Williams", "RB", "DET", 2022, 17, 225.9, 0, 0, 0, 1066, 17, 12, 73, 0],
  ["Najee Harris", "RB", "PIT", 2022, 17, 223.5, 4, 0, 0, 1034, 7, 41, 229, 3],
  ["Miles Sanders", "RB", "PHI", 2022, 17, 216.7, 0, 0, 0, 1269, 11, 20, 78, 0],
  ["Alvin Kamara", "RB", "NO", 2022, 15, 211.7, 0, 0, 0, 897, 2, 57, 490, 2],
  ["Travis Etienne", "RB", "JAX", 2022, 17, 203.1, 0, 0, 0, 1125, 5, 35, 316, 0],
  ["Kenneth Walker", "RB", "SEA", 2022, 15, 202.5, 0, 0, 0, 1050, 9, 27, 165, 0],
  ["James Conner", "RB", "ARI", 2022, 13, 200.2, 0, 0, 0, 782, 7, 46, 300, 1],
  ["Jerick McKinnon", "RB", "KC", 2022, 17, 196.3, 0, 0, 0, 291, 1, 56, 512, 9],
  ["D'Andre Swift", "RB", "DET", 2022, 14, 191.1, 0, 0, 0, 542, 5, 48, 389, 3],
  ["Ezekiel Elliott", "RB", "DAL", 2022, 15, 185.8, 0, 0, 0, 876, 12, 17, 92, 0],
  ["Devin Singletary", "RB", "BUF", 2022, 16, 177.9, 0, 0, 0, 819, 5, 38, 280, 1],
  ["David Montgomery", "RB", "CHI", 2022, 16, 177.7, 0, 0, 0, 801, 5, 34, 316, 1],
  ["Raheem Mostert", "RB", "MIA", 2022, 16, 168.3, 0, 0, 0, 891, 3, 31, 202, 2],
  ["A.J. Dillon", "RB", "GB", 2022, 17, 167.6, 0, 0, 0, 770, 7, 28, 206, 0],
  ["Dameon Pierce", "RB", "HOU", 2022, 13, 166.4, 0, 0, 0, 939, 4, 30, 165, 1],
  ["Antonio Gibson", "RB", "WAS", 2022, 15, 165.9, 0, 0, 0, 546, 3, 46, 353, 2],
  ["Tyler Allgeier", "RB", "ATL", 2022, 16, 159.4, 0, 0, 0, 1035, 3, 16, 139, 1],
  ["Jeffery Wilson", "RB", "MIA", 2022, 16, 158.5, 0, 0, 0, 860, 5, 22, 185, 1],
  ["Justin Jefferson", "WR", "MIN", 2022, 17, 368.7, 34, 0, 0, 24, 1, 128, 1809, 8],
  ["Tyreek Hill", "WR", "MIA", 2022, 17, 341.2, 0, 0, 0, 32, 1, 119, 1710, 7],
  ["Davante Adams", "WR", "LV", 2022, 17, 335.5, 0, 0, 0, -1, 0, 100, 1516, 14],
  ["Stefon Diggs", "WR", "BUF", 2022, 16, 316.6, 0, 0, 0, -3, 0, 108, 1429, 11],
  ["CeeDee Lamb", "WR", "DAL", 2022, 17, 301.6, 0, 0, 0, 47, 0, 107, 1359, 9],
  ["A.J. Brown", "WR", "PHI", 2022, 17, 299.6, 0, 0, 0, 0, 0, 88, 1496, 11],
  ["Amon-Ra St. Brown", "WR", "DET", 2022, 16, 267.6, 0, 0, 0, 95, 0, 106, 1161, 6],
  ["Jaylen Waddle", "WR", "MIA", 2022, 17, 259.2, 0, 0, 0, 26, 0, 75, 1356, 8],
  ["DeVonta Smith", "WR", "PHI", 2022, 17, 254.6, 0, 0, 0, 0, 0, 95, 1196, 7],
  ["Amari Cooper", "WR", "CLE", 2022, 17, 246, 0, 0, 1, 0, 0, 78, 1160, 9],
  ["Christian Kirk", "WR", "JAX", 2022, 17, 243.9, 0, 0, 0, 11, 0, 84, 1108, 8],
  ["Ja'Marr Chase", "WR", "CIN", 2022, 12, 242.4, 0, 0, 0, 8, 0, 87, 1046, 9],
  ["Tyler Lockett", "WR", "SEA", 2022, 16, 239.3, 0, 0, 0, 0, 0, 84, 1033, 9],
  ["Terry McLaurin", "WR", "WAS", 2022, 17, 229, 0, 0, 0, 29, 0, 77, 1191, 5],
  ["Brandon Aiyuk", "WR", "SF", 2022, 17, 227.8, 0, 0, 0, 23, 0, 78, 1015, 8],
  ["DK Metcalf", "WR", "SEA", 2022, 17, 226.8, 0, 0, 0, 0, 0, 90, 1048, 6],
  ["Mike Evans", "WR", "TB", 2022, 15, 225.4, 0, 0, 0, 0, 0, 77, 1124, 6],
  ["Chris Godwin", "WR", "TB", 2022, 15, 222.8, 0, 0, 0, 5, 0, 104, 1023, 3],
  ["Tee Higgins", "WR", "CIN", 2022, 14, 220.9, 0, 0, 0, 0, 0, 74, 1029, 7],
  ["Michael Pittman", "WR", "IND", 2022, 16, 216.5, 0, 0, 0, 30, 0, 99, 925, 4],
  ["Garrett Wilson", "WR", "NYJ", 2022, 17, 215.7, 0, 0, 0, 4, 0, 83, 1103, 4],
  ["Jerry Jeudy", "WR", "DEN", 2022, 15, 204.2, 0, 0, 0, 40, 0, 67, 972, 6],
  ["Cooper Kupp", "WR", "LAR", 2022, 9, 201.4, 0, 0, 0, 52, 1, 75, 812, 6],
  ["D.J. Moore", "WR", "CAR", 2022, 17, 199.1, 0, 0, 0, 53, 0, 63, 888, 7],
  ["Chris Olave", "WR", "NO", 2022, 15, 198.2, 0, 0, 0, 0, 0, 72, 1042, 4],
  ["Zay Jones", "WR", "JAX", 2022, 16, 198.1, 0, 0, 0, 18, 0, 82, 823, 5],
  ["JuJu Smith-Schuster", "WR", "KC", 2022, 16, 185.3, 0, 0, 0, 0, 0, 78, 933, 3],
  ["Jakobi Meyers", "WR", "NE", 2022, 14, 184.3, 0, 0, 0, 9, 0, 67, 804, 6],
  ["Diontae Johnson", "WR", "PIT", 2022, 17, 180.7, 0, 0, 0, 25, 0, 86, 882, 0],
  ["Adam Thielen", "WR", "MIN", 2022, 17, 180, 0, 0, 0, 4, 0, 70, 716, 6],
  ["Drake London", "WR", "ATL", 2022, 17, 178.6, 0, 0, 0, 0, 0, 72, 866, 4],
  ["Mike Williams", "WR", "LAC", 2022, 13, 176.5, 0, 0, 0, 0, 0, 63, 895, 4],
  ["Curtis Samuel", "WR", "WAS", 2022, 17, 176.3, 0, 0, 0, 187, 1, 64, 656, 4],
  ["Allen Lazard", "WR", "GB", 2022, 15, 174.8, 0, 0, 0, 0, 0, 60, 788, 6],
  ["Gabe Davis", "WR", "BUF", 2022, 15, 171.6, 0, 0, 0, 0, 0, 48, 836, 7],
  ["Josh Palmer", "WR", "LAC", 2022, 16, 169.3, 0, 0, 0, 4, 0, 72, 769, 3],
  ["Travis Kelce", "TE", "KC", 2022, 17, 316.3, 0, 0, 0, 5, 0, 110, 1338, 12],
  ["T.J. Hockenson", "TE", "MIN", 2022, 17, 215.4, 0, 0, 0, 0, 0, 86, 914, 6],
  ["George Kittle", "TE", "SF", 2022, 15, 200.5, 0, 0, 0, 0, 0, 60, 765, 11],
  ["Mark Andrews", "TE", "BAL", 2022, 15, 190.5, 0, 0, 0, 8, 0, 73, 847, 5],
  ["Evan Engram", "TE", "JAX", 2022, 17, 176.9, 0, 0, 0, 13, 0, 73, 766, 4],
  ["Tyler Higbee", "TE", "LAR", 2022, 16, 152, 0, 0, 0, 0, 0, 72, 620, 3],
  ["Pat Freiermuth", "TE", "PIT", 2022, 15, 148.2, 0, 0, 0, 0, 0, 63, 732, 2],
  ["Cole Kmet", "TE", "CHI", 2022, 17, 147.3, 0, 0, 0, 9, 0, 50, 544, 7],
  ["Dalton Schultz", "TE", "DAL", 2022, 15, 142.7, 0, 0, 0, 0, 0, 57, 577, 5],
  ["David Njoku", "TE", "CLE", 2022, 14, 142, 0, 0, 0, -8, 0, 58, 628, 4],
  ["Dallas Goedert", "TE", "PHI", 2022, 12, 141.2, 0, 0, 0, 0, 0, 55, 702, 3],
  ["Gerald Everett", "TE", "LAC", 2022, 15, 139.5, 0, 0, 0, 0, 0, 58, 555, 4],
  ["Josh Allen", "QB", "BUF", 2023, 17, 394.6, 4306, 29, 18, 524, 15, 0, 0, 0],
  ["Jalen Hurts", "QB", "PHI", 2023, 17, 356.8, 3858, 23, 15, 605, 15, 0, 0, 0],
  ["Dak Prescott", "QB", "DAL", 2023, 17, 342.8, 4516, 36, 9, 242, 2, 0, 0, 0],
  ["Lamar Jackson", "QB", "BAL", 2023, 16, 331.2, 3678, 24, 7, 821, 5, 0, 0, 0],
  ["Jordan Love", "QB", "GB", 2023, 17, 319.1, 4159, 32, 11, 247, 4, 0, 0, 0],
  ["Brock Purdy", "QB", "SF", 2023, 16, 295.6, 4280, 31, 11, 144, 2, 0, 0, 0],
  ["Jared Goff", "QB", "DET", 2023, 17, 289.1, 4575, 30, 12, 21, 2, 0, 0, 0],
  ["Patrick Mahomes", "QB", "KC", 2023, 16, 280.2, 4183, 27, 14, 389, 0, 0, 0, 0],
  ["C.J. Stroud", "QB", "HOU", 2023, 15, 275, 4108, 23, 5, 157, 3, 1, 0, 0],
  ["Baker Mayfield", "QB", "TB", 2023, 17, 274.1, 4044, 28, 10, 163, 1, 0, 0, 0],
  ["Tua Tagovailoa", "QB", "MIA", 2023, 17, 272.4, 4624, 29, 14, 74, 0, 0, 0, 0],
  ["Trevor Lawrence", "QB", "JAX", 2023, 16, 262.5, 4016, 21, 14, 339, 4, 0, 0, 0],
  ["Sam Howell", "QB", "WAS", 2023, 17, 257.5, 3946, 21, 21, 263, 5, 1, 4, 0],
  ["Russell Wilson", "QB", "DEN", 2023, 15, 256.9, 3070, 26, 8, 341, 3, 0, 0, 0],
  ["Matthew Stafford", "QB", "LAR", 2023, 15, 243.1, 3965, 24, 11, 65, 0, 0, 0, 0],
  ["Derek Carr", "QB", "NO", 2023, 17, 241.1, 3878, 25, 8, 40, 0, 0, 0, 0],
  ["Christian McCaffrey", "RB", "SF", 2023, 16, 391.3, 0, 0, 0, 1459, 14, 67, 564, 7],
  ["Breece Hall", "RB", "NYJ", 2023, 17, 290.5, 0, 0, 0, 994, 5, 76, 591, 4],
  ["Travis Etienne", "RB", "JAX", 2023, 17, 282.4, 0, 0, 0, 1008, 11, 58, 476, 1],
  ["Rachaad White", "RB", "TB", 2023, 17, 267.9, 0, 0, 0, 990, 6, 64, 549, 3],
  ["Raheem Mostert", "RB", "MIA", 2023, 15, 267.7, 0, 0, 0, 1012, 18, 25, 175, 3],
  ["Joe Mixon", "RB", "CIN", 2023, 17, 267, 0, 0, 0, 1034, 9, 52, 376, 3],
  ["Kyren Williams", "RB", "LAR", 2023, 12, 255, 0, 0, 0, 1144, 12, 32, 206, 3],
  ["Derrick Henry", "RB", "TEN", 2023, 17, 246.7, 14, 2, 0, 1167, 12, 28, 214, 0],
  ["Bijan Robinson", "RB", "ATL", 2023, 17, 246.3, 0, 0, 0, 976, 4, 58, 487, 4],
  ["Jahmyr Gibbs", "RB", "DET", 2023, 15, 242.1, 0, 0, 0, 945, 10, 52, 316, 1],
  ["Alvin Kamara", "RB", "NO", 2023, 13, 233, 0, 0, 0, 694, 5, 75, 466, 1],
  ["James Cook", "RB", "BUF", 2023, 17, 232.7, 0, 0, 0, 1122, 2, 44, 445, 4],
  ["Saquon Barkley", "RB", "NYG", 2023, 14, 223.2, 0, 0, 0, 962, 6, 41, 280, 4],
  ["Tony Pollard", "RB", "DAL", 2023, 17, 222.6, 0, 0, 0, 1005, 6, 55, 311, 0],
  ["Isiah Pacheco", "RB", "KC", 2023, 14, 213.9, 0, 0, 0, 935, 7, 44, 244, 2],
  ["Jerome Ford", "RB", "CLE", 2023, 17, 213.2, 0, 0, 0, 813, 4, 44, 319, 5],
  ["David Montgomery", "RB", "DET", 2023, 14, 207.2, 0, 0, 0, 1015, 13, 16, 117, 0],
  ["James Conner", "RB", "ARI", 2023, 13, 201.5, 0, 0, 0, 1040, 7, 27, 165, 2],
  ["Kenneth Walker III", "RB", "SEA", 2023, 15, 199.4, 0, 0, 0, 905, 8, 29, 259, 1],
  ["D'Andre Swift", "RB", "PHI", 2023, 16, 199.3, 0, 0, 0, 1049, 5, 39, 214, 1],
  ["Brian Robinson", "RB", "WAS", 2023, 15, 198.1, 0, 0, 0, 733, 5, 36, 368, 4],
  ["Jaylen Warren", "RB", "PIT", 2023, 17, 196.4, 0, 0, 0, 784, 4, 61, 370, 0],
  ["Najee Harris", "RB", "PIT", 2023, 17, 195.5, 0, 0, 0, 1035, 8, 29, 170, 0],
  ["De'Von Achane", "RB", "MIA", 2023, 11, 190.7, 0, 0, 0, 800, 8, 27, 197, 3],
  ["Gus Edwards", "RB", "BAL", 2023, 17, 187, 0, 0, 0, 810, 13, 12, 180, 0],
  ["Austin Ekeler", "RB", "LAC", 2023, 14, 185.4, 0, 0, 0, 628, 5, 51, 436, 1],
  ["Chuba Hubbard", "RB", "CAR", 2023, 17, 182.5, 0, 0, 0, 902, 5, 39, 233, 0],
  ["Josh Jacobs", "RB", "LV", 2023, 13, 181.1, 0, 0, 0, 805, 6, 37, 296, 0],
  ["Javonte Williams", "RB", "DEN", 2023, 16, 179.2, 0, 0, 0, 774, 3, 47, 228, 2],
  ["Ezekiel Elliott", "RB", "NE", 2023, 17, 174.5, 0, 0, 0, 642, 3, 51, 313, 2],
  ["CeeDee Lamb", "WR", "DAL", 2023, 17, 405.2, 0, 0, 0, 113, 2, 135, 1749, 12],
  ["Tyreek Hill", "WR", "MIA", 2023, 16, 376.4, 0, 0, 0, 15, 0, 119, 1799, 13],
  ["Amon-Ra St. Brown", "WR", "DET", 2023, 16, 330.9, 0, 0, 0, 24, 0, 119, 1515, 10],
  ["Puka Nacua", "WR", "LAR", 2023, 17, 298.5, 0, 0, 0, 89, 0, 105, 1486, 6],
  ["A.J. Brown", "WR", "PHI", 2023, 17, 289.6, 0, 0, 0, 0, 0, 106, 1456, 7],
  ["DJ Moore", "WR", "CHI", 2023, 17, 286.5, 0, 0, 0, 21, 1, 96, 1364, 8],
  ["Mike Evans", "WR", "TB", 2023, 17, 282.5, 0, 0, 0, 0, 0, 79, 1255, 13],
  ["Keenan Allen", "WR", "LAC", 2023, 13, 278.9, 49, 1, 0, 6, 0, 108, 1243, 7],
  ["Stefon Diggs", "WR", "BUF", 2023, 17, 273.8, 0, 0, 0, 5, 0, 107, 1183, 8],
  ["Davante Adams", "WR", "LV", 2023, 17, 265.4, 0, 0, 0, 0, 0, 103, 1144, 8],
  ["Ja'Marr Chase", "WR", "CIN", 2023, 16, 262.7, -7, 0, 0, -6, 0, 100, 1216, 7],
  ["Nico Collins", "WR", "HOU", 2023, 15, 260.4, 0, 0, 0, 7, 0, 80, 1297, 8],
  ["Michael Pittman", "WR", "IND", 2023, 16, 252.2, 0, 0, 0, 0, 0, 109, 1152, 4],
  ["Brandon Aiyuk", "WR", "SF", 2023, 16, 249.2, 0, 0, 0, 0, 0, 75, 1342, 7],
  ["Deebo Samuel Sr.", "WR", "SF", 2023, 15, 243.7, 0, 0, 0, 225, 5, 60, 892, 7],
  ["Chris Olave", "WR", "NO", 2023, 16, 231.3, 0, 0, 0, 0, 0, 87, 1123, 5],
  ["Adam Thielen", "WR", "CAR", 2023, 17, 231, 0, 0, 0, 6, 0, 103, 1014, 4],
  ["Calvin Ridley", "WR", "JAX", 2023, 17, 229.9, 0, 0, 0, 23, 0, 76, 1016, 8],
  ["DeVonta Smith", "WR", "PHI", 2023, 16, 227.6, 0, 0, 0, 0, 0, 81, 1066, 7],
  ["Amari Cooper", "WR", "CLE", 2023, 15, 227, 0, 0, 0, 0, 0, 72, 1250, 5],
  ["DK Metcalf", "WR", "SEA", 2023, 16, 225.4, 0, 0, 0, 0, 0, 66, 1114, 8],
  ["DeAndre Hopkins", "WR", "TEN", 2023, 17, 223.6, 0, 0, 0, 9, 0, 75, 1057, 7],
  ["Jordan Addison", "WR", "MIN", 2023, 17, 221.3, 0, 0, 0, 2, 0, 70, 911, 10],
  ["Jakobi Meyers", "WR", "LV", 2023, 16, 218.6, 12, 1, 0, 24, 2, 71, 807, 8],
  ["Jayden Reed", "WR", "GB", 2023, 16, 217.2, 0, 0, 0, 119, 2, 64, 793, 8],
  ["Garrett Wilson", "WR", "NYJ", 2023, 17, 213.2, 0, 0, 0, 0, 0, 95, 1042, 3],
  ["Rashee Rice", "WR", "KC", 2023, 16, 212.5, 0, 0, 0, -3, 0, 79, 938, 7],
  ["Chris Godwin", "WR", "TB", 2023, 17, 209.2, 0, 0, 0, 38, 1, 83, 1024, 2],
  ["George Pickens", "WR", "PIT", 2023, 17, 208.8, 0, 0, 0, 18, 0, 63, 1140, 5],
  ["Zay Flowers", "WR", "BAL", 2023, 16, 206.4, 0, 0, 0, 56, 1, 77, 858, 5],
  ["Justin Jefferson", "WR", "MIN", 2023, 10, 204.2, 0, 0, 0, -12, 0, 68, 1074, 5],
  ["Terry McLaurin", "WR", "WAS", 2023, 17, 203.2, 0, 0, 0, 0, 0, 79, 1002, 4],
  ["Tyler Lockett", "WR", "SEA", 2023, 17, 202.4, 0, 0, 0, 0, 0, 79, 894, 5],
  ["Jaylen Waddle", "WR", "MIA", 2023, 14, 198.6, 0, 0, 0, 12, 0, 72, 1014, 4],
  ["Courtland Sutton", "WR", "DEN", 2023, 16, 190.2, 0, 0, 0, 0, 0, 59, 772, 10],
  ["Romeo Doubs", "WR", "GB", 2023, 17, 174.4, 0, 0, 0, 0, 0, 59, 674, 8],
  ["Sam LaPorta", "TE", "DET", 2023, 17, 239.3, 0, 0, 0, 4, 0, 86, 889, 10],
  ["Evan Engram", "TE", "JAX", 2023, 17, 230.3, 0, 0, 0, 0, 0, 114, 963, 4],
  ["Travis Kelce", "TE", "KC", 2023, 15, 219.4, 0, 0, 0, 0, 0, 93, 984, 5],
  ["T.J. Hockenson", "TE", "MIN", 2023, 15, 219, 0, 0, 0, 0, 0, 95, 960, 5],
  ["George Kittle", "TE", "SF", 2023, 16, 203.2, 0, 0, 0, 2, 0, 65, 1020, 6],
  ["David Njoku", "TE", "CLE", 2023, 16, 201.2, 0, 0, 0, 0, 0, 81, 882, 6],
  ["Trey McBride", "TE", "ARI", 2023, 17, 181.5, 0, 0, 0, 0, 0, 81, 825, 3],
  ["Cole Kmet", "TE", "CHI", 2023, 15, 181.1, 0, 0, 0, 2, 0, 73, 719, 6],
  ["Jake Ferguson", "TE", "DAL", 2023, 17, 177.1, 0, 0, 0, 0, 0, 71, 761, 5],
  ["Dalton Schultz", "TE", "HOU", 2023, 15, 150.5, 0, 0, 0, 0, 0, 59, 635, 5],
  ["Dalton Kincaid", "TE", "BUF", 2023, 16, 150.3, 0, 0, 0, 0, 0, 73, 673, 2],
  ["Taysom Hill", "TE", "NO", 2023, 16, 143.5, 83, 1, 0, 401, 4, 33, 291, 2],
  ["Lamar Jackson", "QB", "BAL", 2024, 17, 430.4, 4172, 41, 4, 915, 4, 0, 0, 0],
  ["Joe Burrow", "QB", "CIN", 2024, 17, 372.8, 4918, 43, 9, 201, 2, 0, 0, 0],
  ["Josh Allen", "QB", "BUF", 2024, 16, 372.3, 3731, 28, 6, 531, 12, 0, 0, 0],
  ["Baker Mayfield", "QB", "TB", 2024, 17, 365.8, 4500, 41, 16, 378, 3, 0, 0, 0],
  ["Jayden Daniels", "QB", "WAS", 2024, 17, 355.8, 3568, 25, 9, 891, 6, 0, 0, 0],
  ["Jared Goff", "QB", "DET", 2024, 17, 324.5, 4629, 37, 12, 56, 0, 1, 7, 1],
  ["Bo Nix", "QB", "DEN", 2024, 17, 317.2, 3775, 29, 12, 430, 4, 1, 2, 1],
  ["Jalen Hurts", "QB", "PHI", 2024, 15, 315.1, 2903, 18, 5, 630, 14, 0, 0, 0],
  ["Sam Darnold", "QB", "MIN", 2024, 17, 308, 4319, 35, 12, 212, 1, 0, 0, 0],
  ["Kyler Murray", "QB", "ARI", 2024, 17, 297.2, 3851, 21, 11, 572, 5, 0, 0, 0],
  ["Justin Herbert", "QB", "LAC", 2024, 17, 285.4, 3870, 23, 3, 306, 2, 0, 0, 0],
  ["Patrick Mahomes", "QB", "KC", 2024, 16, 283, 3928, 26, 11, 307, 2, 1, 2, 0],
  ["Brock Purdy", "QB", "SF", 2024, 15, 266.9, 3864, 20, 12, 323, 5, 0, 0, 0],
  ["Geno Smith", "QB", "SEA", 2024, 17, 266, 4320, 21, 15, 272, 2, 0, 0, 0],
  ["Aaron Rodgers", "QB", "NYJ", 2024, 17, 256.6, 3897, 28, 11, 107, 0, 0, 0, 0],
  ["Caleb Williams", "QB", "CHI", 2024, 17, 254.5, 3541, 20, 6, 489, 0, 0, 0, 0],
  ["Saquon Barkley", "RB", "PHI", 2024, 16, 355.3, 0, 0, 0, 2005, 13, 33, 278, 2],
  ["Jahmyr Gibbs", "RB", "DET", 2024, 17, 354.9, 0, 0, 0, 1412, 16, 52, 497, 3],
  ["Bijan Robinson", "RB", "ATL", 2024, 17, 341.7, 0, 0, 0, 1456, 14, 61, 431, 1],
  ["Derrick Henry", "RB", "BAL", 2024, 17, 336.4, 0, 0, 0, 1921, 16, 19, 193, 2],
  ["Devon Achane", "RB", "MIA", 2024, 17, 299.9, 0, 0, 0, 907, 6, 78, 592, 6],
  ["Josh Jacobs", "RB", "GB", 2024, 17, 293.1, 0, 0, 0, 1329, 15, 36, 342, 1],
  ["Kyren Williams", "RB", "LAR", 2024, 16, 272.1, 0, 0, 0, 1299, 14, 34, 182, 2],
  ["James Cook", "RB", "BUF", 2024, 16, 266.7, 0, 0, 0, 1009, 16, 32, 258, 2],
  ["Alvin Kamara", "RB", "NO", 2024, 14, 265.3, 0, 0, 0, 950, 6, 68, 543, 2],
  ["Chase Brown", "RB", "CIN", 2024, 16, 255, 0, 0, 0, 990, 7, 54, 360, 4],
  ["James Conner", "RB", "ARI", 2024, 16, 253.8, 0, 0, 0, 1094, 8, 47, 414, 1],
  ["Jonathan Taylor", "RB", "IND", 2024, 14, 246.7, 0, 0, 0, 1431, 11, 18, 136, 1],
  ["Bucky Irving", "RB", "TB", 2024, 17, 244.4, 0, 0, 0, 1122, 8, 47, 392, 0],
  ["Aaron Jones", "RB", "MIN", 2024, 17, 241.6, 0, 0, 0, 1138, 5, 51, 408, 2],
  ["Chuba Hubbard", "RB", "CAR", 2024, 15, 241.6, 0, 0, 0, 1195, 10, 43, 171, 1],
  ["Breece Hall", "RB", "NYJ", 2024, 16, 240.9, 0, 0, 0, 876, 5, 57, 483, 3],
  ["Joe Mixon", "RB", "HOU", 2024, 14, 240.5, 0, 0, 0, 1016, 11, 36, 309, 1],
  ["David Montgomery", "RB", "DET", 2024, 14, 221.7, 3, 1, 0, 775, 12, 36, 341, 0],
  ["D'Andre Swift", "RB", "CHI", 2024, 17, 214.5, 0, 0, 0, 959, 6, 42, 386, 0],
  ["Najee Harris", "RB", "PIT", 2024, 17, 204.6, 0, 0, 0, 1043, 6, 36, 283, 0],
  ["Tony Pollard", "RB", "TEN", 2024, 16, 200.7, 0, 0, 0, 1079, 5, 41, 238, 0],
  ["Rachaad White", "RB", "TB", 2024, 15, 199.6, 0, 0, 0, 613, 3, 51, 393, 6],
  ["Rico Dowdle", "RB", "DAL", 2024, 16, 197.8, 0, 0, 0, 1079, 2, 39, 249, 3],
  ["J.K. Dobbins", "RB", "LAC", 2024, 13, 191.8, 0, 0, 0, 905, 9, 32, 153, 0],
  ["Zach Charbonnet", "RB", "SEA", 2024, 17, 183.7, 0, 0, 0, 569, 8, 42, 308, 1],
  ["Tyrone Tracy", "RB", "NYG", 2024, 17, 182.3, 0, 0, 0, 839, 5, 38, 284, 1],
  ["Kenneth Walker", "RB", "SEA", 2024, 11, 181.2, 0, 0, 0, 573, 7, 46, 299, 1],
  ["Rhamondre Stevenson", "RB", "NE", 2024, 15, 175.9, 0, 0, 0, 801, 7, 33, 168, 1],
  ["Brian Robinson", "RB", "WAS", 2024, 14, 159.8, 0, 0, 0, 799, 8, 20, 159, 0],
  ["Javonte Williams", "RB", "DEN", 2024, 17, 157.9, 0, 0, 0, 513, 4, 52, 346, 0],
  ["Ja'Marr Chase", "WR", "CIN", 2024, 17, 403, 0, 0, 0, 32, 0, 127, 1708, 17],
  ["Justin Jefferson", "WR", "MIN", 2024, 17, 317.5, 22, 0, 0, 3, 0, 103, 1533, 10],
  ["Amon-Ra St. Brown", "WR", "DET", 2024, 17, 316.2, 7, 1, 0, 6, 0, 115, 1263, 12],
  ["Brian Thomas", "WR", "JAX", 2024, 17, 284, 0, 0, 0, 48, 0, 87, 1282, 10],
  ["Drake London", "WR", "ATL", 2024, 17, 280.8, 0, 0, 0, -3, 0, 100, 1271, 9],
  ["Malik Nabers", "WR", "NYG", 2024, 15, 273.6, 0, 0, 0, 2, 0, 109, 1204, 7],
  ["Terry McLaurin", "WR", "WAS", 2024, 17, 267.8, 0, 0, 0, 2, 0, 82, 1096, 13],
  ["CeeDee Lamb", "WR", "DAL", 2024, 15, 263.4, 0, 0, 0, 70, 0, 101, 1194, 6],
  ["Jaxon Smith-Njigba", "WR", "SEA", 2024, 17, 253, 35, 0, 0, 26, 0, 100, 1130, 6],
  ["Garrett Wilson", "WR", "NYJ", 2024, 17, 251.9, 0, 0, 0, 5, 0, 101, 1104, 7],
  ["Davante Adams", "WR", "NYJ", 2024, 14, 241.3, 0, 0, 0, 0, 0, 85, 1063, 8],
  ["Jerry Jeudy", "WR", "CLE", 2024, 17, 240.9, 0, 0, 0, 0, 0, 90, 1229, 4],
  ["Ladd McConkey", "WR", "LAC", 2024, 16, 240.9, 0, 0, 0, 0, 0, 82, 1149, 7],
  ["Mike Evans", "WR", "TB", 2024, 14, 240.4, 0, 0, 0, 0, 0, 74, 1004, 11],
  ["Courtland Sutton", "WR", "DEN", 2024, 16, 240.3, 30, 1, 0, 0, 0, 81, 1081, 8],
  ["D.J. Moore", "WR", "CHI", 2024, 17, 238.1, 0, 0, 0, 75, 0, 98, 966, 6],
  ["Tee Higgins", "WR", "CIN", 2024, 12, 222.1, 0, 0, 0, 0, 0, 73, 911, 10],
  ["Tyreek Hill", "WR", "MIA", 2024, 17, 218.2, 0, 0, 0, 53, 0, 81, 959, 6],
  ["Jakobi Meyers", "WR", "LV", 2024, 15, 218, 0, 0, 0, 23, 0, 87, 1027, 4],
  ["A.J. Brown", "WR", "PHI", 2024, 13, 216.9, 0, 0, 0, 0, 0, 67, 1079, 7],
  ["Jordan Addison", "WR", "MIN", 2024, 15, 212.5, 0, 0, 0, 20, 1, 63, 875, 9],
  ["Jameson Williams", "WR", "DET", 2024, 15, 212.2, 0, 0, 0, 61, 1, 58, 1001, 7],
  ["Nico Collins", "WR", "HOU", 2024, 12, 210.6, 0, 0, 0, 0, 0, 68, 1006, 7],
  ["Jauan Jennings", "WR", "SF", 2024, 15, 210.5, 0, 0, 0, 0, 0, 77, 975, 6],
  ["Zay Flowers", "WR", "BAL", 2024, 17, 209.5, 0, 0, 0, 56, 0, 74, 1059, 4],
  ["Puka Nacua", "WR", "LAR", 2024, 11, 206.6, 0, 0, 0, 46, 1, 79, 990, 3],
  ["DeVonta Smith", "WR", "PHI", 2024, 13, 199.4, 0, 0, 0, 1, 0, 68, 833, 8],
  ["Calvin Ridley", "WR", "TEN", 2024, 17, 199.2, 0, 0, 0, 55, 1, 64, 1017, 4],
  ["Jayden Reed", "WR", "GB", 2024, 17, 197, 0, 0, 0, 163, 1, 55, 857, 6],
  ["Marvin Harrison", "WR", "ARI", 2024, 17, 196.5, 0, 0, 0, 0, 0, 62, 885, 8],
  ["Darnell Mooney", "WR", "ATL", 2024, 16, 193.2, 0, 0, 0, 0, 0, 64, 992, 5],
  ["DK Metcalf", "WR", "SEA", 2024, 15, 191.2, 0, 0, 0, 0, 0, 66, 992, 5],
  ["Xavier Worthy", "WR", "KC", 2024, 16, 187.2, 0, 0, 0, 104, 3, 59, 638, 6],
  ["Keenan Allen", "WR", "CHI", 2024, 15, 184.4, 0, 0, 1, 0, 0, 70, 744, 7],
  ["Wan'Dale Robinson", "WR", "NYG", 2024, 17, 182.7, 0, 0, 0, 18, 0, 93, 699, 3],
  ["Khalil Shakir", "WR", "BUF", 2024, 15, 182.5, 0, 0, 0, 4, 0, 76, 821, 4],
  ["Brock Bowers", "TE", "LV", 2024, 17, 262.7, 0, 0, 0, 13, 0, 112, 1194, 5],
  ["Trey McBride", "TE", "ARI", 2024, 16, 243.8, 0, 0, 0, 2, 1, 111, 1146, 2],
  ["George Kittle", "TE", "SF", 2024, 15, 236.6, 0, 0, 0, 0, 0, 78, 1106, 8],
  ["Jonnu Smith", "TE", "MIA", 2024, 17, 222.3, 0, 0, 0, -1, 0, 88, 884, 8],
  ["Travis Kelce", "TE", "KC", 2024, 16, 195.4, 0, 0, 0, 1, 0, 97, 823, 3],
  ["Mark Andrews", "TE", "BAL", 2024, 17, 188.8, 0, 0, 0, 5, 0, 55, 673, 11],
  ["Zach Ertz", "TE", "WAS", 2024, 17, 177.4, 0, 0, 0, 0, 0, 66, 654, 7],
  ["Sam LaPorta", "TE", "DET", 2024, 16, 174.6, 0, 0, 0, 0, 0, 60, 726, 7],
  ["Pat Freiermuth", "TE", "PIT", 2024, 17, 168.3, 0, 0, 0, 0, 0, 65, 653, 7],
  ["Tucker Kraft", "TE", "GB", 2024, 17, 163.3, 0, 0, 0, 6, 0, 50, 707, 7],
  ["David Njoku", "TE", "CLE", 2024, 11, 148.5, 0, 0, 0, 0, 0, 64, 505, 5],
  ["Hunter Henry", "TE", "NE", 2024, 16, 145.4, 0, 0, 0, 0, 0, 66, 674, 2],
  ["Josh Allen", "QB", "BUF", 2025, 16, 364.6, 3668, 25, 10, 579, 14, 0, 0, 0],
  ["Drake Maye", "QB", "NE", 2025, 17, 352, 4394, 31, 8, 450, 4, 1, 2, 0],
  ["Matthew Stafford", "QB", "LAR", 2025, 17, 350.4, 4707, 46, 8, 1, 0, 0, 0, 0],
  ["Trevor Lawrence", "QB", "JAX", 2025, 17, 338.2, 4007, 29, 12, 359, 9, 0, 0, 0],
  ["Caleb Williams", "QB", "CHI", 2025, 17, 318.7, 3942, 27, 7, 388, 3, 2, 22, 1],
  ["Dak Prescott", "QB", "DAL", 2025, 17, 313.8, 4552, 30, 10, 177, 2, 0, 0, 0],
  ["Bo Nix", "QB", "DEN", 2025, 17, 304.8, 3931, 25, 11, 356, 5, 0, 0, 0],
  ["Jalen Hurts", "QB", "PHI", 2025, 16, 301.1, 3224, 25, 6, 421, 8, 0, 0, 0],
  ["Jared Goff", "QB", "DET", 2025, 17, 297.1, 4564, 34, 8, 45, 0, 0, 0, 0],
  ["Justin Herbert", "QB", "LAC", 2025, 16, 286.9, 3727, 26, 13, 498, 2, 0, 0, 0],
  ["Patrick Mahomes", "QB", "KC", 2025, 14, 285.7, 3587, 22, 11, 422, 5, 1, -10, 0],
  ["Baker Mayfield", "QB", "TB", 2025, 17, 271.9, 3693, 26, 11, 382, 1, 0, 0, 0],
  ["Jaxson Dart", "QB", "NYG", 2025, 14, 241.6, 2272, 15, 5, 487, 9, 0, 0, 0],
  ["Sam Darnold", "QB", "SEA", 2025, 17, 235.4, 4048, 25, 14, 95, 0, 0, 0, 0],
  ["Jordan Love", "QB", "GB", 2025, 15, 235.1, 3381, 23, 6, 199, 0, 0, 0, 0],
  ["Jacoby Brissett", "QB", "ARI", 2025, 14, 227.4, 3366, 23, 8, 168, 1, 0, 0, 0],
  ["Christian McCaffrey", "RB", "SF", 2025, 17, 416.6, 0, 0, 0, 1202, 10, 102, 924, 7],
  ["Bijan Robinson", "RB", "ATL", 2025, 17, 370.8, 0, 0, 0, 1478, 7, 79, 820, 4],
  ["Jahmyr Gibbs", "RB", "DET", 2025, 17, 366.9, 0, 0, 0, 1223, 13, 77, 616, 5],
  ["Jonathan Taylor", "RB", "IND", 2025, 17, 362.3, 0, 0, 0, 1585, 18, 46, 378, 2],
  ["De'Von Achane", "RB", "MIA", 2025, 16, 322.8, 0, 0, 0, 1350, 8, 67, 488, 4],
  ["James Cook", "RB", "BUF", 2025, 17, 302.2, 0, 0, 0, 1621, 12, 33, 291, 2],
  ["Chase Brown", "RB", "CIN", 2025, 17, 282.6, 0, 0, 0, 1019, 6, 69, 437, 5],
  ["Derrick Henry", "RB", "BAL", 2025, 17, 279.5, 0, 0, 0, 1595, 16, 15, 150, 0],
  ["Kyren Williams", "RB", "LAR", 2025, 17, 263.3, 0, 0, 0, 1252, 10, 36, 281, 3],
  ["Travis Etienne", "RB", "JAX", 2025, 17, 253.9, 0, 0, 0, 1107, 7, 36, 292, 6],
  ["Ashton Jeanty", "RB", "LV", 2025, 17, 245.1, 0, 0, 0, 975, 5, 55, 346, 5],
  ["Javonte Williams", "RB", "DAL", 2025, 16, 242.8, 0, 0, 0, 1201, 11, 35, 137, 2],
  ["Josh Jacobs", "RB", "GB", 2025, 15, 237.1, 0, 0, 0, 929, 13, 36, 282, 1],
  ["Saquon Barkley", "RB", "PHI", 2025, 16, 232.3, 0, 0, 0, 1140, 7, 37, 273, 2],
  ["D'Andre Swift", "RB", "CHI", 2025, 16, 228.6, 0, 0, 0, 1087, 9, 34, 299, 1],
  ["Kenny Gainwell", "RB", "PIT", 2025, 17, 221.3, 0, 0, 0, 537, 5, 73, 486, 3],
  ["Jaylen Warren", "RB", "PIT", 2025, 16, 217.1, 0, 0, 0, 958, 6, 40, 333, 2],
  ["Rico Dowdle", "RB", "CAR", 2025, 17, 216.3, 0, 0, 0, 1076, 6, 39, 297, 1],
  ["Breece Hall", "RB", "NYJ", 2025, 16, 207.7, 4, 1, 0, 1065, 4, 36, 350, 1],
  ["RJ Harvey", "RB", "DEN", 2025, 17, 206.6, 0, 0, 0, 540, 7, 47, 356, 5],
  ["TreVeyon Henderson", "RB", "NE", 2025, 17, 206.2, 0, 0, 0, 911, 9, 35, 221, 1],
  ["Kenneth Walker III", "RB", "SEA", 2025, 17, 191.9, 0, 0, 0, 1027, 5, 31, 282, 0],
  ["Tony Pollard", "RB", "TEN", 2025, 17, 185.8, 0, 0, 0, 1082, 5, 33, 206, 0],
  ["Zach Charbonnet", "RB", "SEA", 2025, 16, 181.4, 0, 0, 0, 730, 12, 20, 144, 0],
  ["Rhamondre Stevenson", "RB", "NE", 2025, 14, 178.8, 0, 0, 0, 603, 7, 32, 345, 2],
  ["Quinshon Judkins", "RB", "CLE", 2025, 14, 169.8, 0, 0, 0, 827, 7, 26, 171, 0],
  ["David Montgomery", "RB", "DET", 2025, 17, 166.9, 3, 1, 0, 716, 8, 24, 192, 0],
  ["Tyrone Tracy Jr.", "RB", "NYG", 2025, 15, 160.8, 0, 0, 0, 740, 2, 36, 288, 2],
  ["Kyle Monangai", "RB", "CHI", 2025, 17, 146.7, 0, 0, 0, 783, 5, 18, 164, 0],
  ["Kareem Hunt", "RB", "KC", 2025, 17, 145.4, 0, 0, 0, 611, 8, 18, 143, 1],
  ["Puka Nacua", "WR", "LAR", 2025, 16, 375, 0, 0, 0, 105, 1, 129, 1715, 10],
  ["Jaxon Smith-Njigba", "WR", "SEA", 2025, 17, 359.9, 0, 0, 0, 36, 0, 119, 1793, 10],
  ["Amon-Ra St. Brown", "WR", "DET", 2025, 17, 324, 0, 0, 0, 9, 0, 117, 1401, 11],
  ["Ja'Marr Chase", "WR", "CIN", 2025, 16, 313.6, 0, 0, 0, 14, 0, 125, 1412, 8],
  ["George Pickens", "WR", "DAL", 2025, 17, 291.9, 0, 0, 0, 0, 0, 93, 1429, 9],
  ["Chris Olave", "WR", "NO", 2025, 16, 268, 0, 0, 1, -3, 0, 100, 1163, 9],
  ["Zay Flowers", "WR", "BAL", 2025, 17, 243.3, 0, 0, 0, 62, 1, 86, 1211, 5],
  ["Nico Collins", "WR", "HOU", 2025, 15, 226.2, 0, 0, 0, 15, 1, 71, 1117, 6],
  ["Davante Adams", "WR", "LAR", 2025, 14, 222.9, 0, 0, 0, 0, 0, 60, 789, 14],
  ["Michael Wilson", "WR", "ARI", 2025, 17, 220.6, 0, 0, 0, 0, 0, 78, 1006, 7],
  ["A.J. Brown", "WR", "PHI", 2025, 15, 220.3, 0, 0, 0, 0, 0, 78, 1003, 7],
  ["Jameson Williams", "WR", "DET", 2025, 17, 219.9, 0, 0, 0, 12, 0, 65, 1117, 7],
  ["Courtland Sutton", "WR", "DEN", 2025, 17, 219.7, 0, 0, 0, 0, 0, 74, 1017, 7],
  ["Wan'Dale Robinson", "WR", "NYG", 2025, 16, 217.9, 0, 0, 0, 5, 0, 92, 1014, 4],
  ["Tetairoa McMillan", "WR", "CAR", 2025, 17, 213.4, 0, 0, 0, 0, 0, 70, 1014, 7],
  ["Tee Higgins", "WR", "CIN", 2025, 15, 211.6, 0, 0, 0, 0, 0, 59, 846, 11],
  ["Stefon Diggs", "WR", "NE", 2025, 17, 210.3, 0, 0, 0, 0, 0, 85, 1013, 4],
  ["Michael Pittman", "WR", "IND", 2025, 17, 202.4, 0, 0, 0, 0, 0, 80, 784, 7],
  ["Drake London", "WR", "ATL", 2025, 12, 201.9, 0, 0, 0, 0, 0, 68, 919, 7],
  ["DeVonta Smith", "WR", "PHI", 2025, 17, 201.8, 0, 0, 0, 0, 0, 77, 1008, 4],
  ["Justin Jefferson", "WR", "MIN", 2025, 17, 201.5, 0, 0, 0, 7, 0, 84, 1048, 2],
  ["CeeDee Lamb", "WR", "DAL", 2025, 13, 200.9, 0, 0, 0, 2, 0, 75, 1077, 3],
  ["Emeka Egbuka", "WR", "TB", 2025, 17, 195.7, 0, 0, 0, 9, 0, 63, 938, 6],
  ["Jaylen Waddle", "WR", "MIA", 2025, 16, 194.1, 8, 0, 0, 28, 0, 64, 910, 6],
  ["Deebo Samuel Sr.", "WR", "WAS", 2025, 16, 188.2, 0, 0, 0, 75, 1, 72, 727, 5],
  ["DK Metcalf", "WR", "PIT", 2025, 15, 187.2, 0, 0, 0, 12, 1, 59, 850, 6],
  ["Parker Washington", "WR", "JAX", 2025, 16, 184.7, 0, 0, 0, 0, 0, 58, 847, 5],
  ["Alec Pierce", "WR", "IND", 2025, 15, 183.3, 0, 0, 0, 0, 0, 47, 1003, 6],
  ["Keenan Allen", "WR", "LAC", 2025, 17, 182.7, 0, 0, 0, 0, 0, 81, 777, 4],
  ["Ladd McConkey", "WR", "LAC", 2025, 16, 180.9, 0, 0, 0, 0, 0, 66, 789, 6],
  ["Troy Franklin", "WR", "DEN", 2025, 17, 177.1, 0, 0, 0, 12, 0, 65, 709, 6],
  ["Jakobi Meyers", "WR", "JAX", 2025, 16, 175.8, 0, 0, 0, 13, 0, 75, 835, 3],
  ["Jauan Jennings", "WR", "SF", 2025, 15, 173.3, 0, 0, 0, 0, 0, 55, 643, 9],
  ["DJ Moore", "WR", "CHI", 2025, 17, 172.2, 2, 1, 0, 79, 1, 50, 682, 6],
  ["Quentin Johnston", "WR", "LAC", 2025, 13, 171.2, 0, 0, 0, 7, 0, 51, 735, 8],
  ["Khalil Shakir", "WR", "BUF", 2025, 16, 166.4, 0, 0, 0, 5, 0, 72, 719, 4],
  ["Trey McBride", "TE", "ARI", 2025, 17, 315.9, 0, 0, 0, 0, 0, 126, 1239, 11],
  ["Kyle Pitts", "TE", "ATL", 2025, 17, 210.8, 0, 0, 0, 0, 0, 88, 928, 5],
  ["Travis Kelce", "TE", "KC", 2025, 17, 193.2, 0, 0, 0, 1, 0, 76, 851, 5],
  ["Tyler Warren", "TE", "IND", 2025, 17, 188.5, 0, 0, 0, 8, 1, 76, 817, 4],
  ["Jake Ferguson", "TE", "DAL", 2025, 17, 188.1, 0, 0, 0, 1, 0, 82, 600, 8],
  ["Harold Fannin Jr.", "TE", "CLE", 2025, 16, 186.4, 0, 0, 0, 13, 1, 72, 731, 6],
  ["Dallas Goedert", "TE", "PHI", 2025, 15, 185.1, 0, 0, 0, 0, 0, 60, 591, 11],
  ["Juwan Johnson", "TE", "NO", 2025, 17, 179.9, 0, 0, 0, 0, 0, 77, 889, 3],
  ["Hunter Henry", "TE", "NE", 2025, 17, 178.8, 0, 0, 0, 0, 0, 60, 768, 7],
  ["Dalton Schultz", "TE", "HOU", 2025, 17, 177.7, 0, 0, 0, 0, 0, 82, 777, 3],
  ["Brock Bowers", "TE", "LV", 2025, 12, 176.2, 0, 0, 0, 2, 0, 64, 680, 7],
  ["Colston Loveland", "TE", "CHI", 2025, 16, 165.1, 0, 0, 0, -2, 0, 58, 713, 6]
];

// ../supabase/functions/_shared/miniGames.ts
var TICKS_PER_SECOND = 30;
var TRIVIA_FIRST = Math.min(...TRIVIA_ROWS.map((row) => row[3]));
var TRIVIA_LAST = Math.max(...TRIVIA_ROWS.map((row) => row[3]));
var GAMES = {
  climb: {
    title: "The Climb Dash",
    blurb: `Climb the mountain while the crew tumbles down at you. Dodge Chrome, Connor's '57 and the rest. Grab "OIP!" for a bonus.`,
    style: "skill",
    unit: "pts"
  },
  shred: {
    title: "Shred the Summit",
    blurb: "Snowboard down the mountain. Tap to jump (tap again in the air to double jump). Footballs are 10 points and landing on top of a rock, stump or tree is 5. Ride through gift sleds for footballs, but later some hold hot dogs on a fuse, and past 100 points hot dogs fall from the sky. It gets faster the farther you go.",
    style: "skill",
    unit: "pts"
  },
  fieldgoal: {
    title: "Field Goal Gauntlet",
    blurb: "Michael holds. Tap to aim, tap for power, mind the wind. It starts at 20 yards and backs up 5 every make. One miss ends it.",
    style: "skill",
    unit: "yds"
  },
  penalty: {
    title: "Pink Dress Penalty Kicks",
    blurb: "Ten penalty kicks at Chrome in the pink dress. Pick left or right, high or low, time your power, and hope he dives the wrong way.",
    style: "turns",
    unit: "goals"
  },
  price: {
    title: "Price Is Right: Fantasy Edition",
    blurb: `Guess a player's PPR fantasy points for one season (${TRIVIA_FIRST}-${TRIVIA_LAST}). Closest without going over scores the most. 20 seconds a guess.`,
    style: "turns",
    unit: "pts"
  },
  nameplayer: {
    title: "Name That Player",
    blurb: `A mystery season's stat line (${TRIVIA_FIRST}-${TRIVIA_LAST}) and four names. Pick the right one fast; quicker answers score more.`,
    style: "turns",
    unit: "pts"
  }
};
var GAME_KINDS = Object.keys(GAMES);
var isGameKind = (value) => typeof value === "string" && value in GAMES;
function nextRandom(state) {
  let t = state.r = state.r + 1831565813 | 0;
  t = Math.imul(t ^ t >>> 15, t | 1);
  t ^= t + Math.imul(t ^ t >>> 7, t | 61);
  return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function mixSeed(seed, salt) {
  let h = seed ^ Math.imul(salt + 1, 2654435761) | 0;
  h = Math.imul(h ^ h >>> 16, 2246822507);
  h = Math.imul(h ^ h >>> 13, 3266489909);
  return h ^ h >>> 16 | 0;
}
var randomFrom = (seed, salt) => {
  const state = { r: mixSeed(seed, salt) };
  return () => nextRandom(state);
};
function swing(ticks, period) {
  const phase = ticks % period / period;
  return phase < 0.5 ? -1 + 4 * phase : 3 - 4 * phase;
}
var clamp = (value, lo, hi) => Math.min(hi, Math.max(lo, value));
var CLIMB = {
  lanes: 3,
  /** The climber's box, in a 0-100 tall screen. */
  playerTop: 80,
  playerBottom: 92,
  objectSize: 10,
  oipBonus: 25,
  maxTicks: TICKS_PER_SECOND * 600
};
var climbSpeed = (tick) => Math.min(2.4, 0.85 + tick * 28e-5);
function climbStart(seed) {
  return { r: seed | 0, tick: 0, lane: 1, height: 0, oips: 0, alive: true, hitBy: null, objects: [], nextRow: 20, nextId: 1 };
}
function spawnClimbRow(s) {
  const blockTwo = nextRandom(s) < Math.min(0.7, 0.15 + s.tick / 4e3);
  const open = Math.floor(nextRandom(s) * CLIMB.lanes);
  let blocked = [0, 1, 2].filter((lane) => lane !== open);
  if (!blockTwo)
    blocked = [blocked[Math.floor(nextRandom(s) * 2)]];
  for (const lane of blocked) {
    const roll = nextRandom(s);
    const kind = roll < 0.12 ? "car" : roll < 0.3 ? "chrome" : "guy";
    const art = kind === "car" ? 6 : kind === "chrome" ? 5 : Math.floor(nextRandom(s) * 10);
    s.objects.push({ id: s.nextId++, kind, lane, y: -CLIMB.objectSize, art });
  }
  if (nextRandom(s) < 0.22) {
    const free = [0, 1, 2].filter((lane) => !blocked.includes(lane));
    s.objects.push({ id: s.nextId++, kind: "oip", lane: free[Math.floor(nextRandom(s) * free.length)], y: -CLIMB.objectSize, art: 8 });
  }
  const v = climbSpeed(s.tick);
  const gap = CLIMB.objectSize + (CLIMB.playerBottom - CLIMB.playerTop) + 4;
  s.nextRow = s.tick + Math.max(Math.ceil(gap / v), Math.floor(30 - s.tick / 200));
}
function climbStep(s, lane) {
  if (!s.alive)
    return s;
  if (lane != null)
    s.lane = clamp(Math.trunc(lane), 0, CLIMB.lanes - 1);
  if (s.tick >= s.nextRow)
    spawnClimbRow(s);
  const v = climbSpeed(s.tick);
  const kept = [];
  for (const o of s.objects) {
    o.y += v;
    const touching = o.lane === s.lane && o.y + CLIMB.objectSize > CLIMB.playerTop && o.y < CLIMB.playerBottom;
    if (touching && o.kind === "oip") {
      s.oips += 1;
      continue;
    }
    if (touching && s.alive) {
      s.alive = false;
      s.hitBy = o.kind;
    }
    if (o.y < 110)
      kept.push(o);
  }
  s.objects = kept;
  s.height += v * 0.1;
  s.tick += 1;
  if (s.tick >= CLIMB.maxTicks)
    s.alive = false;
  return s;
}
var climbScore = (s) => Math.floor(s.height) + s.oips * CLIMB.oipBonus;
var SHRED = {
  gravity: 0.8,
  jump: 12.5,
  /** The second jump, from a tap in the air (once per jump). */
  doubleJump: 10.5,
  maxFall: 18,
  /** The rider's box: half its width, and its height above the board. */
  halfWidth: 11,
  height: 40,
  ballRadius: 12,
  ballPoints: 10,
  /** Landing on top of a rock, stump, tree, snowman or snowball bounces you up for these. */
  stompPoints: 5,
  stompBounce: 9,
  /** World units per meter (distance only sets speed and difficulty; it scores nothing). */
  pointEvery: 25,
  /** Hot dogs start falling from the sky at this score. */
  hotDogsFrom: 100,
  hotDogFall: 40,
  /** Gift sleds can hold a hot dog once you have this many footballs. */
  giftHotDogsFrom: 8,
  /** Letting go of Jump while rising faster than this slows the rise to it (a short hop). */
  jumpCut: 5.5,
  /** How fast sleds slide back toward the rider. */
  sledSlide: 2.5,
  /** Ticks a thrown hot dog sits before it blows. */
  fuse: 45,
  /** Gift launchers (a box that keeps firing footballs and hot dogs) show up from this score. */
  launchersFrom: 200,
  itemGravity: 0.3,
  blastRadius: 38,
  blastHeight: 50,
  blastTicks: 8,
  /** Ticks a tap is remembered for, and ticks after leaving the ground a jump still works. */
  jumpBuffer: 5,
  coyote: 4,
  maxTicks: TICKS_PER_SECOND * 600
};
var SHRED_AIR = 2 * SHRED.jump / SHRED.gravity;
var shredSpeed = (meters) => 6 + Math.min(4.5, meters / 160);
var SHRED_SAFE = ["sled", "launcher"];
function shredStart(seed) {
  const s = {
    r: seed | 0,
    tick: 0,
    x: 0,
    y: 0,
    vx: shredSpeed(0),
    vy: 0,
    grounded: true,
    lastGround: 0,
    wantJump: -100,
    jumps: 0,
    doubleAt: -100,
    jumped: false,
    balls: 0,
    stomps: 0,
    alive: true,
    hitBy: null,
    segments: [],
    pits: [],
    obstacles: [],
    footballs: [],
    hotdogs: [],
    genX: -300,
    genY: 0,
    noObstacleUntil: 500,
    nextHotDog: 0,
    nextId: 1
  };
  shredBuild(s);
  return s;
}
var shredDistance = (s) => Math.max(0, Math.floor(s.x / SHRED.pointEvery));
var shredScore = (s) => s.balls * SHRED.ballPoints + s.stomps * SHRED.stompPoints;
function shredGround(s, x) {
  for (const g of s.segments) {
    if (x >= g.x0 && x < g.x1)
      return g.y0 + (g.y1 - g.y0) * (x - g.x0) / (g.x1 - g.x0);
  }
  return null;
}
var shredSlope = (s, x) => {
  for (const g of s.segments)
    if (x >= g.x0 && x < g.x1)
      return (g.y1 - g.y0) / (g.x1 - g.x0);
  return 0;
};
function addSegment(s, length, drop, kind) {
  s.segments.push(kind ? { x0: s.genX, x1: s.genX + length, y0: s.genY, y1: s.genY + drop, kind } : { x0: s.genX, x1: s.genX + length, y0: s.genY, y1: s.genY + drop });
  s.genX += length;
  s.genY += drop;
}
var rand = (s, lo, hi) => lo + nextRandom(s) * (hi - lo);
function addBallLine(s, x0, count, high) {
  for (let i = 0; i < count; i += 1) {
    const x = x0 + i * 48;
    const g = shredGround(s, x);
    if (g != null)
      s.footballs.push({ id: s.nextId++, x, y: g - (high ? 95 : 24) });
  }
}
var SHRED_SIZES = {
  rock: [30, 20],
  stump: [34, 16],
  tree: [26, 48],
  snowman: [26, 40],
  snowball: [34, 34],
  sled: [50, 36],
  launcher: [50, 40]
};
function maybeLauncher(s, x0, x1) {
  if (shredScore(s) < SHRED.launchersFrom || x1 - x0 < 260 || nextRandom(s) > 0.3)
    return;
  const x = x0 + (x1 - x0) * 0.6;
  const g = shredGround(s, x);
  if (g == null)
    return;
  s.obstacles.push({ id: s.nextId++, kind: "launcher", x, y: g, w: SHRED_SIZES.launcher[0], h: SHRED_SIZES.launcher[1], roll: SHRED.sledSlide * 0.6, shot: 0 });
}
function placeObstacles(s, x0, x1, reach, hard) {
  let x = Math.max(x0 + 60, s.noObstacleUntil);
  while (x < x1 - 40) {
    if (nextRandom(s) < 0.7 + 0.25 * hard) {
      const roll = nextRandom(s);
      const kind = roll < 0.12 ? "rock" : roll < 0.32 ? "stump" : roll < 0.54 ? "tree" : roll < 0.62 ? "snowman" : roll < 0.72 ? hard < 0.15 ? "stump" : "snowball" : "sled";
      if (kind === "snowball")
        x += 140;
      const g = shredGround(s, x);
      if (x >= x1 - 40 || g == null)
        break;
      const size = SHRED_SIZES[kind];
      const o = { id: s.nextId++, kind, x, y: g, w: size[0], h: size[1], roll: kind === "snowball" ? 1.6 : 0 };
      if (kind === "sled") {
        o.gift = nextRandom(s) < 0.6;
        o.roll = SHRED.sledSlide;
      }
      s.obstacles.push(o);
      if (nextRandom(s) < 0.3)
        s.footballs.push({ id: s.nextId++, x, y: g - size[1] - 46 });
      s.noObstacleUntil = x + reach * 1.6;
      x = s.noObstacleUntil + nextRandom(s) * reach * (0.9 - 0.5 * hard);
    } else {
      const g = shredGround(s, x);
      if (g != null && nextRandom(s) < 0.5) {
        s.obstacles.push({ id: s.nextId++, kind: "sled", x, y: g, w: SHRED_SIZES.sled[0], h: SHRED_SIZES.sled[1], roll: SHRED.sledSlide, gift: nextRandom(s) < 0.6 });
      }
      x += reach * 0.6;
    }
  }
}
var runUp = (s, least) => Math.max(least, s.noObstacleUntil - s.genX + 40);
function shredBuild(s) {
  while (s.genX < s.x + 1800) {
    const hard = Math.min(1, s.genX / 4e4);
    const speed = shredSpeed(shredDistance(s) + (s.genX - s.x) / SHRED.pointEvery);
    const reach = SHRED_AIR * speed;
    const start = s.genX;
    if (s.genX < 600) {
      addSegment(s, 900, 140);
      continue;
    }
    const roll = nextRandom(s);
    if (roll < 0.24) {
      const length = rand(s, 420, 820);
      addSegment(s, length, length * rand(s, 0.12, 0.34 + 0.1 * hard));
      placeObstacles(s, start, s.genX, reach, hard);
      if (nextRandom(s) < 0.5)
        addBallLine(s, start + rand(s, 40, length - 240), 4, nextRandom(s) < 0.4);
    } else if (roll < 0.34) {
      const length = rand(s, 280, 480);
      addSegment(s, length, length * rand(s, 0, 0.05));
      placeObstacles(s, start, s.genX, reach, hard);
      maybeLauncher(s, start, s.genX);
      if (nextRandom(s) < 0.5)
        addBallLine(s, start + 40, 5, false);
    } else if (roll < 0.48) {
      const up = rand(s, 220, 360);
      addSegment(s, up, -up * rand(s, 0.18, 0.32));
      addBallLine(s, s.genX - up + 40, 4, false);
      addSegment(s, 80, 0);
      const down = rand(s, 320, 520);
      const downStart = s.genX;
      addSegment(s, down, down * rand(s, 0.4, 0.65));
      placeObstacles(s, downStart + 100, s.genX, reach, hard);
    } else if (roll < 0.62) {
      addSegment(s, runUp(s, 60), 0);
      addSegment(s, 140, -rand(s, 80, 110), "ramp");
      const lipX = s.genX;
      const lipY = s.genY;
      s.genY += rand(s, 150, 260);
      addSegment(s, 420, 170);
      for (let i = 1; i <= 5; i += 1)
        s.footballs.push({ id: s.nextId++, x: lipX + i * speed * 4, y: lipY - 46 - i * 9 + i * i * 1.6 });
      s.noObstacleUntil = s.genX;
    } else if (roll < 0.78) {
      const lead = runUp(s, 120);
      addSegment(s, lead, lead * 0.25);
      const edgeY = s.genY;
      const width = reach * (0.3 + nextRandom(s) * (0.2 + 0.4 * hard));
      const drop = rand(s, 20, 120);
      s.pits.push({ x0: s.genX, x1: s.genX + width, floor: edgeY + drop + 220 });
      for (let i = 1; i <= 3; i += 1)
        s.footballs.push({ id: s.nextId++, x: s.genX + width * i / 4, y: edgeY - 70 });
      s.genX += width;
      s.genY += drop;
      addSegment(s, 300, 50);
      s.noObstacleUntil = s.genX;
    } else if (roll < 0.9) {
      const lead = runUp(s, 120);
      addSegment(s, lead, lead * 0.25);
      const edgeY = s.genY;
      const first = reach * rand(s, 0.25, 0.42);
      const deckY = edgeY + rand(s, -20, 40);
      s.pits.push({ x0: s.genX, x1: s.genX + first, floor: Math.max(edgeY, deckY) + 260 });
      s.genX += first;
      s.genY = deckY;
      const deck = rand(s, 220, 380);
      addSegment(s, deck, 0, "bridge");
      addBallLine(s, s.genX - deck + 50, 4, nextRandom(s) < 0.5);
      const second = reach * (0.25 + nextRandom(s) * (0.17 + 0.25 * hard));
      const drop = rand(s, 30, 110);
      s.pits.push({ x0: s.genX, x1: s.genX + second, floor: deckY + drop + 260 });
      s.genX += second;
      s.genY += drop;
      addSegment(s, 300, 50);
      s.noObstacleUntil = s.genX;
    } else {
      addSegment(s, runUp(s, 160), 10);
      s.genY += rand(s, 120, 260);
      addSegment(s, 360, 90);
      s.noObstacleUntil = s.genX;
    }
  }
  const behind = s.x - 500;
  s.segments = s.segments.filter((g) => g.x1 > behind);
  s.pits = s.pits.filter((p) => p.x1 > behind);
  s.obstacles = s.obstacles.filter((o) => o.x > behind);
  s.footballs = s.footballs.filter((b) => b.x > behind);
}
function throwHotDog(s, x, y, vx, vy) {
  s.hotdogs.push({ id: s.nextId++, x, y, vx, vy, ground: 0, landed: false, sky: false, fuse: SHRED.fuse, boom: 0 });
}
function shredHotDogs(s, score) {
  if (score >= SHRED.hotDogsFrom && s.tick >= s.nextHotDog) {
    const x = s.x + s.vx * SHRED.hotDogFall + rand(s, -60, 160);
    const g = shredGround(s, x);
    if (g != null) {
      const vy = (440 - SHRED.itemGravity * SHRED.hotDogFall * (SHRED.hotDogFall + 1) / 2) / SHRED.hotDogFall;
      s.hotdogs.push({ id: s.nextId++, x, y: g - 440, vx: 0, vy, ground: g, landed: false, sky: true, fuse: 0, boom: 0 });
      s.nextHotDog = s.tick + Math.floor(Math.max(35, 120 - (score - SHRED.hotDogsFrom) / 4) + nextRandom(s) * 30);
    }
  }
  const kept = [];
  for (const d of s.hotdogs) {
    if (!d.landed) {
      d.vy += SHRED.itemGravity;
      d.x += d.vx;
      d.y += d.vy;
      const g = d.sky ? d.ground : shredGround(s, d.x);
      if (g != null && d.y >= g) {
        d.y = g;
        d.ground = g;
        d.landed = true;
        if (d.fuse === 0)
          d.boom = 1;
      } else if (d.y > s.y + 900) {
        continue;
      }
    } else if (d.fuse > 0) {
      d.fuse -= 1;
      if (d.fuse === 0)
        d.boom = 1;
    } else {
      d.boom += 1;
    }
    if (d.boom <= SHRED.blastTicks + 6)
      kept.push(d);
  }
  s.hotdogs = kept;
}
function shredLaunchers(s) {
  var _a, _b;
  for (const o of s.obstacles) {
    if (o.kind !== "launcher" || o.x - s.x > 650 || o.x < s.x - 40 || s.tick < ((_a = o.shot) != null ? _a : 0))
      continue;
    const vx = -rand(s, 0.5, 2.5);
    const vy = -rand(s, 8, 12);
    if (nextRandom(s) < 0.55)
      s.footballs.push({ id: s.nextId++, x: o.x, y: o.y - o.h, vx, vy });
    else
      throwHotDog(s, o.x, o.y - o.h, vx, vy);
    o.shot = s.tick + 55 + Math.floor(nextRandom(s) * 25);
  }
  for (const b of s.footballs) {
    if (b.vy == null)
      continue;
    b.vy += SHRED.itemGravity;
    b.x += (_b = b.vx) != null ? _b : 0;
    b.y += b.vy;
    const g = shredGround(s, b.x);
    if (g != null && b.y >= g - 14) {
      b.y = g - 14;
      delete b.vx;
      delete b.vy;
    }
  }
  s.footballs = s.footballs.filter((b) => b.y < s.y + 900);
}
function openGift(s, o) {
  o.gift = false;
  if (s.balls < SHRED.giftHotDogsFrom || nextRandom(s) < 0.6)
    s.balls += 1;
  else
    throwHotDog(s, o.x, o.y - o.h, s.vx * 1.5, -9);
}
function shredCrash(s, hit) {
  s.alive = false;
  s.hitBy = hit;
}
function shredStep(s, tap = false, held = true) {
  if (!s.alive)
    return s;
  if (tap)
    s.wantJump = s.tick;
  const score = shredScore(s);
  const base = shredSpeed(shredDistance(s));
  const slope = shredSlope(s, s.x);
  const canJump = s.grounded || s.tick - s.lastGround <= SHRED.coyote && s.vy >= 0;
  if (s.tick - s.wantJump <= SHRED.jumpBuffer && canJump) {
    s.vy = Math.min(0, slope * s.vx) * 0.5 - SHRED.jump;
    s.grounded = false;
    s.lastGround = -100;
    s.wantJump = -100;
    s.doubleAt = -100;
    s.jumped = true;
    s.jumps += 1;
  } else if (tap && !s.grounded && !s.jumped) {
    s.vy = Math.min(s.vy, 0) - SHRED.jump;
    s.jumped = true;
    s.wantJump = -100;
    s.jumps += 1;
  } else if (tap && !s.grounded && s.doubleAt < 0) {
    s.vy = Math.min(s.vy, 0) - SHRED.doubleJump;
    s.doubleAt = s.tick;
    s.wantJump = -100;
    s.jumps += 1;
  }
  if (!held && !s.grounded && s.vy < -SHRED.jumpCut)
    s.vy = -SHRED.jumpCut;
  if (s.grounded) {
    s.vx = clamp(s.vx + slope * 0.25 - (s.vx - base) * 0.03, base * 0.75, base * 1.5);
    const nx = s.x + s.vx;
    const g = shredGround(s, nx);
    if (g == null || g - s.y > s.vx * 0.9 + 6) {
      s.vy = slope * s.vx;
      s.grounded = false;
      s.x = nx;
      s.y += s.vy;
    } else {
      s.x = nx;
      s.y = g;
      s.lastGround = s.tick;
    }
  } else {
    s.vx += (base - s.vx) * 0.01;
    s.vy = Math.min(SHRED.maxFall, s.vy + SHRED.gravity);
    s.x += s.vx;
    s.y += s.vy;
    const g = shredGround(s, s.x);
    if (g != null && s.y >= g) {
      if (s.y - g <= Math.max(16, s.vy + 2)) {
        s.y = g;
        s.vy = 0;
        s.grounded = true;
        s.doubleAt = -100;
        s.jumped = false;
        s.lastGround = s.tick;
      } else {
        shredCrash(s, "cliff");
      }
    }
    for (const p of s.pits)
      if (s.x >= p.x0 && s.x < p.x1 && s.y > p.floor)
        shredCrash(s, "gap");
  }
  const left = s.x - SHRED.halfWidth;
  const right = s.x + SHRED.halfWidth;
  const top = s.y - SHRED.height;
  for (const o of s.obstacles) {
    if (o.roll > 0 && o.x - s.x < 700) {
      o.x -= o.roll;
      const g = shredGround(s, o.x);
      if (g == null || o.fell) {
        o.y += 12;
        o.fell = true;
      } else
        o.y = g;
    }
    const touching = right > o.x - o.w / 2 + 4 && left < o.x + o.w / 2 - 4 && s.y > o.y - o.h + 5 && top < o.y;
    if (!touching || o.stomped)
      continue;
    const fromAbove = !s.grounded && s.vy >= 0 && s.y - s.vy <= o.y - o.h + 8;
    if (SHRED_SAFE.includes(o.kind)) {
      if (o.gift)
        openGift(s, o);
      if (!fromAbove)
        continue;
    }
    if (fromAbove) {
      o.stomped = true;
      s.y = o.y - o.h;
      s.vy = -SHRED.stompBounce;
      s.jumped = false;
      s.doubleAt = -100;
      s.stomps += 1;
      continue;
    }
    shredCrash(s, o.kind);
  }
  const r = SHRED.ballRadius;
  s.footballs = s.footballs.filter((b) => {
    const got = right > b.x - r && left < b.x + r && s.y > b.y - r && top < b.y + r;
    if (got)
      s.balls += 1;
    return !got;
  });
  shredHotDogs(s, score);
  shredLaunchers(s);
  for (const d of s.hotdogs) {
    if (d.boom === 0 && d.landed) {
      if (right > d.x - 16 && left < d.x + 16 && s.y > d.y - 12)
        d.fuse = 0;
    } else if (d.boom === 0 && d.sky) {
      if (right > d.x - 16 && left < d.x + 16 && s.y > d.y - 10 && top < d.y + 4)
        shredCrash(s, "hotdog");
    } else if (d.boom > 0 && d.boom <= SHRED.blastTicks) {
      if (right > d.x - SHRED.blastRadius && left < d.x + SHRED.blastRadius && s.y > d.ground - SHRED.blastHeight)
        shredCrash(s, "hotdog");
    }
  }
  s.tick += 1;
  shredBuild(s);
  if (s.tick >= SHRED.maxTicks && s.alive)
    shredCrash(s, "time");
  return s;
}
var shredDetail = (s) => `${s.balls} football${s.balls === 1 ? "" : "s"}, ${s.stomps} landing${s.stomps === 1 ? "" : "s"} on top, ${shredDistance(s)} m`;
var FIELD_GOAL = {
  firstDistance: 20,
  step: 5,
  flightTicks: 50,
  /** A meter left alone this long kicks by itself. */
  idleTicks: TICKS_PER_SECOND * 15,
  maxKicks: 20
};
var kickMade = (result) => result === "good" || result === "doink in";
var fieldGoalDistance = (kick) => FIELD_GOAL.firstDistance + FIELD_GOAL.step * kick;
var aimPeriod = (kick) => Math.max(24, 60 - kick * 4);
var powerPeriod = (kick) => Math.max(30, 56 - kick * 2);
var powerAt = (ticks, kick) => (swing(ticks, powerPeriod(kick)) + 1) / 2;
var aimAt = (ticks, kick) => swing(ticks, aimPeriod(kick));
var powerNeeded = (distance) => distance / 70;
var fieldGoalTolerance = (distance) => 0.5 * (25 / distance);
var windEffect = (wind, distance) => wind * 0.5 * (distance / 40);
var powerWindow = (kick) => Math.max(0.12, 0.28 - kick * 0.014);
var powerLimit = (distance, kick) => Math.min(1, powerNeeded(distance) + powerWindow(kick));
var DOINK_BAND = 0.04;
var CROSSBAR_BAND = 0.025;
function gradeKick(aim, power, wind, distance, kick) {
  const need = powerNeeded(distance);
  const tol = fieldGoalTolerance(distance);
  const drift = aim + windEffect(wind, distance);
  if (power > powerLimit(distance, kick))
    return { result: "shank", drift: clamp(drift + 0.7, -1.5, 1.5) };
  const off = Math.abs(drift);
  if (power < need) {
    if (power >= need - CROSSBAR_BAND && off < tol - DOINK_BAND) {
      return { result: power >= need - CROSSBAR_BAND / 2 ? "doink in" : "doink out", drift, post: "bar" };
    }
    return { result: "short", drift: clamp(drift, -1.5, 1.5) };
  }
  if (off >= tol - DOINK_BAND && off <= tol + DOINK_BAND) {
    return { result: off <= tol ? "doink in" : "doink out", drift, post: drift < 0 ? "left" : "right" };
  }
  if (off < tol)
    return { result: "good", drift };
  return { result: drift < 0 ? "wide left" : "wide right", drift: clamp(drift, -1.5, 1.5) };
}
function newKick(s) {
  s.distance = fieldGoalDistance(s.kick);
  s.wind = Math.round((nextRandom(s) * 2 - 1) * Math.min(1, 0.25 + s.kick * 0.08) * 100) / 100;
  s.phase = "aim";
  s.phaseStart = s.tick;
}
function fieldGoalStart(seed) {
  const s = { r: seed | 0, tick: 0, phase: "aim", phaseStart: 0, kick: 0, distance: 0, wind: 0, aim: 0, kicks: [] };
  newKick(s);
  return s;
}
function fieldGoalStep(s, tap = false) {
  if (s.phase === "over")
    return s;
  const since = s.tick - s.phaseStart;
  if (s.phase === "aim" && (tap || since >= FIELD_GOAL.idleTicks)) {
    s.aim = aimAt(since, s.kick);
    s.phase = "power";
    s.phaseStart = s.tick + 1;
  } else if (s.phase === "power" && (tap || since >= FIELD_GOAL.idleTicks)) {
    const power = powerAt(since, s.kick);
    s.kicks.push(__spreadValues({ distance: s.distance, wind: s.wind, aim: s.aim, power }, gradeKick(s.aim, power, s.wind, s.distance, s.kick)));
    s.phase = "flight";
    s.phaseStart = s.tick + 1;
  } else if (s.phase === "flight" && since >= FIELD_GOAL.flightTicks) {
    const last = s.kicks[s.kicks.length - 1];
    if (!kickMade(last.result) || s.kicks.length >= FIELD_GOAL.maxKicks) {
      s.phase = "over";
    } else {
      s.kick += 1;
      newKick(s);
    }
  }
  s.tick += 1;
  return s;
}
var fieldGoalScore = (s) => s.kicks.filter((k) => kickMade(k.result)).reduce((best, k) => Math.max(best, k.distance), 0);
var MAX_INPUTS = 5e3;
function validInputs(value) {
  if (!Array.isArray(value) || value.length > MAX_INPUTS)
    return null;
  const inputs = [];
  let last = -1;
  for (const item of value) {
    if (!Array.isArray(item) || item.length !== 2)
      return null;
    const [tick, input] = item;
    if (!Number.isInteger(tick) || !Number.isInteger(input) || tick < last || tick < 0)
      return null;
    inputs.push([tick, input]);
    last = tick;
  }
  return inputs;
}
function replaySkillGame(game, seed, inputs) {
  let i = 0;
  const inputAt = (tick) => {
    let value = null;
    while (i < inputs.length && inputs[i][0] <= tick) {
      if (inputs[i][0] === tick)
        value = inputs[i][1];
      i += 1;
    }
    return value;
  };
  if (game === "climb") {
    const s = climbStart(seed);
    while (s.alive)
      climbStep(s, inputAt(s.tick));
    const score = climbScore(s);
    return { score, ticks: s.tick, detail: `${Math.floor(s.height)} ft, ${s.oips} OIP${s.oips === 1 ? "" : "s"}` };
  }
  if (game === "shred") {
    const s = shredStart(seed);
    let held = true;
    while (s.alive) {
      const v = inputAt(s.tick);
      if (v != null)
        held = v === 1;
      shredStep(s, v === 1, held);
    }
    return { score: shredScore(s), ticks: s.tick, detail: shredDetail(s) };
  }
  if (game === "fieldgoal") {
    const s = fieldGoalStart(seed);
    while (s.phase !== "over")
      fieldGoalStep(s, inputAt(s.tick) != null);
    const made = s.kicks.filter((k) => kickMade(k.result)).length;
    return { score: fieldGoalScore(s), ticks: s.tick, detail: `${made} made` };
  }
  throw new Error(`${game} is not a skill game`);
}
var TURNS = {
  penalty: { count: 10, seconds: 30 },
  price: { count: 8, seconds: 20 },
  nameplayer: { count: 10, seconds: 12 }
};
var TURN_GRACE_SECONDS = 3;
var turnCount = (game) => game in TURNS ? TURNS[game].count : 0;
var turnSeconds = (game) => game in TURNS ? TURNS[game].seconds : 0;
var formatNumber = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
function statLine(row) {
  const [, pos, , , , , passYds, passTd, ints, rushYds, rushTd, rec, recYds, recTd] = row;
  const parts = [];
  if (pos === "QB")
    parts.push(`${formatNumber(passYds)} pass yds`, `${passTd} pass TD`, `${ints} INT`);
  if (pos === "QB" || pos === "RB" || rushYds >= 100)
    parts.push(`${formatNumber(rushYds)} rush yds`, `${rushTd} rush TD`);
  if (pos !== "QB")
    parts.push(`${rec} rec`, `${formatNumber(recYds)} rec yds`, `${recTd} rec TD`);
  return parts.join(", ");
}
var ALL_ROWS = TRIVIA_ROWS.map((row, index) => ({ row, index }));
var PRICE_ROWS = ALL_ROWS.filter(({ row }) => row[4] >= 8 && row[5] >= 60);
var NAME_ROWS = ALL_ROWS.filter(({ row }) => row[4] >= 6 && row[5] >= 40);
var priceRows = () => PRICE_ROWS;
var nameRows = () => NAME_ROWS;
var TRIVIA_COUNTS = { price: PRICE_ROWS.length, nameplayer: NAME_ROWS.length };
function pickSome(list, count, random) {
  const copy = list.slice();
  const out = [];
  while (out.length < count && copy.length)
    out.push(copy.splice(Math.floor(random() * copy.length), 1)[0]);
  return out;
}
function turnFor(game, seed, index) {
  const of = turnCount(game);
  const seconds = turnSeconds(game);
  if (game === "penalty")
    return { kind: "penalty", index, of, seconds };
  if (game === "price") {
    const { row } = pickSome(priceRows(), of, randomFrom(seed, 1))[index];
    return { kind: "price", index, of, seconds, name: row[0], position: row[1], team: row[2], games: row[4], season: row[3] };
  }
  if (game === "nameplayer") {
    const { row } = pickSome(nameRows(), of, randomFrom(seed, 1))[index];
    const random = randomFrom(seed, 100 + index);
    const names = [...new Set(nameRows().filter((r) => r.row[1] === row[1] && r.row[0] !== row[0] && Math.abs(r.row[3] - row[3]) <= 4).map((r) => r.row[0]))];
    const choices = pickSome(names, 3, random);
    choices.splice(Math.floor(random() * 4), 0, row[0]);
    return { kind: "nameplayer", index, of, seconds, position: row[1], team: row[2], games: row[4], season: row[3], clue: statLine(row), choices };
  }
  throw new Error(`${game} is not a turn game`);
}
var penaltyColumn = (zone) => zone % 2;
var penaltyHigh = (zone) => zone < 2;
function gradeTurn(game, seed, index, answer, seconds, history = []) {
  const limit = turnSeconds(game);
  const late = seconds > limit + TURN_GRACE_SECONDS;
  if (game === "penalty") {
    const { zone, power } = answer != null ? answer : {};
    const z = Number.isInteger(zone) && zone >= 0 && zone < 4 ? zone : 2;
    const p = typeof power === "number" && Number.isFinite(power) ? clamp(power, 0, 1) : 0;
    const random = randomFrom(seed, 200 + index);
    const lastColumns = history.slice(-2).map(penaltyColumn);
    let column = Math.floor(random() * 2);
    if (lastColumns.length === 2 && lastColumns[0] === lastColumns[1] && random() < 0.5)
      column = lastColumns[0];
    const high = random() < 0.4;
    const keeper = { column, high };
    let outcome;
    if (late)
      outcome = "saved";
    else if (penaltyHigh(z) && p > 0.92)
      outcome = "over the bar";
    else if (p > 0.97)
      outcome = "wide";
    else if (column === penaltyColumn(z) && (p < 0.35 || high === penaltyHigh(z)))
      outcome = "saved";
    else
      outcome = "goal";
    const message = late ? "Too slow, the ref blew the whistle." : outcome === "goal" ? "GOAL!" : outcome === "saved" ? "Saved by the dress!" : `Missed, ${outcome}.`;
    return { points: outcome === "goal" ? 1 : 0, message, late, keeper, outcome };
  }
  if (game === "price") {
    const { row } = pickSome(priceRows(), turnCount(game), randomFrom(seed, 1))[index];
    const actual = row[5];
    const guess = typeof answer === "number" && Number.isFinite(answer) ? answer : -1;
    let points = 0;
    if (!late && guess >= 0 && guess <= actual) {
      points = Math.round(100 * Math.max(0, 1 - (actual - guess) / actual * 2));
      if (actual - guess <= 2)
        points += 25;
    }
    const message = late ? `Too slow. Actual: ${actual} pts.` : guess > actual ? `Over! Actual: ${actual} pts.` : `Actual: ${actual} pts. +${points}`;
    return { points, message, late, answer: actual };
  }
  if (game === "nameplayer") {
    const turn = turnFor(game, seed, index);
    const { row } = pickSome(nameRows(), turnCount(game), randomFrom(seed, 1))[index];
    const right = turn.choices.indexOf(row[0]);
    const correct = !late && answer === right;
    const points = correct ? 100 + Math.round(50 * clamp(1 - seconds / limit, 0, 1)) : 0;
    const message = late ? `Too slow. It was ${row[0]}.` : correct ? `Yes, ${row[0]}! +${points}` : `Nope, it was ${row[0]}.`;
    return { points, message, late, answer: row[0] };
  }
  throw new Error(`${game} is not a turn game`);
}
function applyTurn(game, attempt, index, answer, seconds, now) {
  var _a, _b, _c, _d;
  if (index !== attempt.turn || !attempt.servedAt)
    return null;
  const graded = gradeTurn(game, (_a = attempt.seed) != null ? _a : 0, index, answer, seconds, (_b = attempt.history) != null ? _b : []);
  attempt.points = [...(_c = attempt.points) != null ? _c : [], graded.points];
  if (game === "penalty")
    attempt.history = [...(_d = attempt.history) != null ? _d : [], Math.trunc(Number(answer == null ? void 0 : answer.zone)) || 0];
  attempt.turn = index + 1;
  attempt.servedAt = null;
  const total = attempt.points.reduce((sum, p) => sum + p, 0);
  attempt.score = total;
  if (attempt.turn >= turnCount(game)) {
    attempt.finishedAt = now;
    attempt.detail = game === "penalty" ? `${total} of ${turnCount(game)}` : `${attempt.points.filter((p) => p > 0).length} of ${turnCount(game)} scored`;
  }
  return graded;
}
export {
  CLIMB,
  CROSSBAR_BAND,
  DOINK_BAND,
  FIELD_GOAL,
  GAMES,
  GAME_KINDS,
  MAX_INPUTS,
  SHRED,
  TICKS_PER_SECOND,
  TRIVIA_COUNTS,
  TURNS,
  TURN_GRACE_SECONDS,
  aimAt,
  aimPeriod,
  applyTurn,
  climbScore,
  climbSpeed,
  climbStart,
  climbStep,
  fieldGoalDistance,
  fieldGoalScore,
  fieldGoalStart,
  fieldGoalStep,
  fieldGoalTolerance,
  gradeTurn,
  isGameKind,
  kickMade,
  mixSeed,
  nextRandom,
  penaltyColumn,
  penaltyHigh,
  powerAt,
  powerLimit,
  powerNeeded,
  powerPeriod,
  powerWindow,
  replaySkillGame,
  shredDetail,
  shredDistance,
  shredGround,
  shredScore,
  shredSpeed,
  shredStart,
  shredStep,
  statLine,
  swing,
  turnCount,
  turnFor,
  turnSeconds,
  validInputs,
  windEffect
};
